{
  "Welcome": "Welcome",
  "DownloadPdf": "Download PDF",
  "Continue": "Continue",
  "Save": "Save",
  "Menu": "Menu",
  "Close": "Close",
  "CloseMenu": "Close Menu",
  "SaveAndExit": "Save and exit",
  "SaveAndFinishLater": "Save and finish later",
  "SaveAndComplete": "Save & Complete",
  "Invite": "Invite",
  "Approve": "Approve",
  "Decline": "Decline",
  "Cancel": "Cancel",
  "Remove": "Remove",
  "Share": "Share",
  "Choose": "Choose",
  "Edit": "Edit",
  "Roles": "Roles",
  "GoBack": "Go back",
  "GoBackMobile": "Back",
  "Back": "Back",
  "Ok": "Ok",
  "Skip": "Skip",
  "CompanyNotListed": "Company not listed",
  "ReferenceFieldsAndOtherOptions": "Reference Fields and Other Options",
  "LearnMore": "Learn More",
  "Deactivated": "Deactivated",
  "Locations": "Locations",
  "AllLocations": "All Locations",
  "ResendInvite": "Resend Invite",
  "MarketPlace": "Diamond Marketplace",
  "SearchDiamonds": "Search Diamonds",
  "ViewYourOrderStatus": "View Your Order Status",
  "ViewShoppingCart": "Shopping Cart",
  "ShopLabGrownDiamonds": "Shop Lab Grown Diamonds",
  "ShopNaturalDiamonds": "Shop Natural Diamonds",
  "SendInvite": "Send Invite",
  "ConfirmAndContinue": "Confirm & Continue",
  "PersonalDetails": "Personal Details",
  "TeamDirectory": "Team Directory",
  "DeactivateMember": "Deactivate Member",
  "EnterEmailAddress": "Enter Email Address",
  "EnterPhoneNumber": "Enter Phone Number",
  "CreatePassword": "Create Password",
  "SecurityQuestions": "Security Questions",
  "Code_Not_Verified": "It looks like your Phone No. has not been verified yet.",
  "ResetPassword": "Reset Password",
  "TemporaryLogin": "Skip Resetting Password (Temporary Login)",
  "CreateNewPassword": "Please go ahead and create your new Zing<sup>®</sup> Marketplace password below.",
  "VerificationCompleteNote": "Thank you for verifying",
  "IssueDetected": "There seems to be an issue.",
  "AccountLockedMessage": "Your account is locked for your security. ",
  "EnterPersonalDetails": "Enter information below to begin creating your account.",
  "BusinessDescription": "What Best Describes Your Business?",
  "BusinessDescPlaceholder": "Please Select Your Business Category",
  "ShippingNotes": "Non-jewelry related businesses will only have access to JM<sup>®</sup> Shipping Solution.  Other features are exclusively for jewelry professionals.",
  "PleaseSpecify": "Please Specify",
  "InvitationPending": "Invitation Pending",
  "PendingInvite": "Pending Invite",
  "PendingApproval": "Pending Approval",
  "CargoTypeQuestion": "What are you shipping?",
  "ShippingTimeQuestion": "When do you want to Ship?",
  "RepairAndReturnLabel": "Repair and Return should only be selected when sending goods out of the country to be repaired and returned to you. Select the estimated date your goods will be returned.",
  "SelectOtherCargoType": "Select an option",
  "ShipmentReference": "Shipment Reference",
  "MultipleRecordsFound": "Multiple Records Found",
  "MultipleFeinIdMatches": "We have found multiple FEIN matches based on the information that you have entered. Please select the correct one from below.",
  "ParticipantAgreement": "Participant Agreement",
  "Yes": "Yes",
  "No": "No",
  "And": "and",
  "Send": "Send",
  "Confirm": "Confirm",
  "Loading": "Loading",
  "Email": "Email",
  "SendToMyEmail": "Send to my email",
  "PrintLabel": "Print label",
  "Print": "Print",
  "DownloadLabel": "Download label",
  "Download": "Download",
  "ClaimDetailsPage": {
    "FiledOnShipment": "Claim filed on",
    "ClaimFileDate": "Claim File Date",
    "TrackingId": "Tracking ID",
    "ClaimDetails": "Claim Details",
    "ClaimNumbers": "Reference ID / Claim Number",
    "ClaimCoverage": "Claim Coverage",
    "ClaimCoverageText": "This information is based solely on the insurance purchased through <em>JM</em> Shipping Solution",
    "LossDamageDetails": "Loss and Damage Details",
    "ReasonForClaim": "Reason for Claim",
    "SupportingDocuments": "Supporting Documents"
  },
  "YesAndContinue": "Yes, continue",
  "UseMyOwnAddress": "No, use my own",
  "ReferenceNote": "Please enter the reference details to save shipment.",
  "AbandonShipment": "Abandon Shipment",
  "YourPresets": "Your Presets",
  "EnterName": "Enter Name",
  "DeleteAPreset": "Delete a Preset",
  "ShippingDashboard": "Shipping Dashboard",
  "ShipmentDashboard": "Shipment Dashboard",
  "DiamondMarketplaceDashboard": "Diamond Marketplace Dashboard",
  "HVSDeclined": "Your shipment has been declined for the reason(s) listed below. Please review and edit your shipment details (origin, destination, and/or details), requote and resubmit for approval.",
  "ShippingDashboardLastUpdated": "Last updated",
  "Done": "Done",
  "CarriersAndServices": "Carriers & Services",
  "CarrierAndService": "Carrier and Service",
  "PurchaseOptions": "Purchase Options",
  "BuyNow": "Buy Now",
  "NoShipments": "Currently you have no saved shipments.",
  "NoShipmentsToBeViewed": "Currently, there are no shipments to be viewed",
  "NoClaimsToBeViewed": "Currently, there are no claims to be viewed",
  "NoInvoicesToBeViewed": "Currently, there are no invoices to be viewed",
  "NoPayments": "Currently you have no payments posted for this shipment",
  "NoTransactions": "Currently you have no transactions posted for this shipment",
  "MySavedShipments": "My saved shipments",
  "ShipmentSummary": "Shipment summary",
  "ShipmentSummaryUppercase": "Shipment Summary",
  "ShippingLabels": "Shipping Labels",
  "LabelSize": "Choose your preferred label size for printing shipping labels.",
  "SavedShipments": "Saved Shipments",
  "ProcessedShipments": "Processed Shipments",
  "ShippingClaims": "Shipping Claims",
  "ShipmentVoided": "Shipment voided successfully",
  "Claim": "Claim",
  "ActionItem": "Action Item",
  "ShipmentTracking": "Shipment Tracking",
  "CreateNew": "Create New",
  "CreateNewShipment": "Create New Shipment",
  "ManageAddressBook": "Manage Address Book",
  "ShipmentPresets": "Shipment Presets",
  "Contacts": "Contacts",
  "NewShipment": "New Shipment",
  "Insurance": "Insurance",
  "AddressBook": "Address Book",
  "Manual": "Manual",
  "ViewShipmentDetails": "View Shipment Details",
  "PremissionsSaved": "Your shipping permissions has been saved successfully",
  "Permissions": "Permissions",
  "Action": "Action",
  "ManageShipments": "Manage Shipments",
  "CreateShipments": "Create Shipments",
  "CreateShipment": "Create Shipment",
  "RemindMeLater": "Remind Me Later",
  "TryAgain": "Try Again",
  "PoweredBy": "powered by:",
  "ViewMore": "View More",
  "Titles": {
    "ShippingFrom": "Shipping From",
    "ShippingTo": "Shipping To",
    "ShipmentDetails": "Shipment Details",
    "ShipmentCarrierServices": "Shipment Carrier Services",
    "ShipmentConfirmation": "Shipment Confirmation",
    "ExportDetails": "Export Details",
    "CreateInsuranceOnlyShipment": "Create Insurance Only Shipment",
    "Review": "Review",
    "ShipmentDashboard": "Shipment Dashboard",
    "LabelPurchaseAndPrint": "Label Purchase & Print",
    "AddressBook": "Address Book",
    "NewContact": "New Contact",
    "ViewExistingContact": "View Existing Contact",
    "EditExistingContact": "Edit Existing Contact",
    "ShippingDetails": "Shipping Details",
    "BoomerangShipmentSuccess": "Boomerang Shipment Success",
    "CreateNewShipment": "Create New Shipment",
    "EditShipment": "Edit Shipment",
    "BoomerangShipment": "Boomerang Shipment",
    "ShipmentLabel": "Shipment Label",
    "CreateShipmentPreset": "Create Shipment Preset",
    "EditShipmentPreset": "Edit Shipment Preset",
    "QuickQuote": "Quick Quote",
    "ClaimSubmission": "Claim Submission",
    "ClaimDetails": "Claim Details",
    "ClaimSuccess": "Claim Success",
    "SupplyOrders": "Supply Orders",
    "BillingAndPayments": "Billing & Payments - Shipping",
    "BillingAndPaymentsShipmentDashboard": "Billing & Payments",
    "BatchImports": "Batch Imports",
    "InvoiceDetails": "Invoice Details",
    "Ecommerce": "Ecommerce",
    "ArmoredTransportQuote": "Armored Transport Quote",
    "Reconciliations": "Reconciliations",
    "PrintYourLabels": "Print Your Labels",
    "LabelsAndPrinting": "Labels & Printing",
    "AMLOption": "Anti-Money Laundering Compliance",
    "AccountSetup": " Account Setup",
    "DocumentCenter": "Document Center"
  },
  "EcomIntegration": {
    "App": "app",
    "Application": "application",
    "Plugin": "plugin",
    "Intro": "Before integrating, you'll need to do some configuration of your integration's site to allow the connection. Please read and follow the instruction document below for your integration. When ready to proceed, click on the appropriate integration option to get started.",
    "IntroV2": "Easily integrate compatible Ecommerce merchants to simplify your shipping operation. By establishing an integration, we will import your order details to streamline the label production process. You can also set defaults and assign shipping methods received from your merchant. Integrations not only speed up your shipping efforts, it minimizes risks from manual entry.",
    "Instructions": "Instructions",
    "BridgeConnector": "Bridge Connector",
    "YourIntegrations": "Your Integrations",
    "EcommerceIntegrations": "Ecommerce Integrations",
    "StoreName": "Store Name",
    "EditLinkText": "Edit",
    "RemoveLinkText": "Remove",
    "AgreementLinkText": "Agreement",
    "DeclaredValueInsuranceLimitText": "Declared Value Insurance Limit",
    "NoActiveintegrations": "You have no active integrations.",
    "DisclaimerText": "Reference to any specific product, service, trade name, trademark, logo, or otherwise does not constitute recommendation or endorsement by any party.",
    "FailureEmails": "Purchase Failure Notifications Emails",
    "FailureEmailsDescription": "Upon failure to automatically purchase insurance for your imported shipments, a notification email will be sent to the address(es) listed below. Separate multiple addresses by a semicolon (;). 150 characters max.",
    "DailyEmails": "Daily Summary Emails",
    "DailyEmailsDescription": "To receive a daily summary of successful insurance purchases for imported shipments, enter the email address(es) below. Separate multiple addresses with a semicolon (;). 150 characters max.",
    "EmailError": "Enter one or more valid email addresses separated by semicolon.",
    "CheckTheStatus": "Check the status of your integration connection",
    "Modal": {
      "Name": "My {{ modalType }} Integration",
      "ReferTo": "Please refer to",
      "TheseInstructions": "these instructions",
      "ForInformation": "for the information required.",
      "InstructionsNoLink": "Please refer to the instructions provided for the information required.",
      "IntegrationName": "Integration Name",
      "ErrorRequired": "This field is required",
      "ErrorDateRequired": "A valid date is required (today or future date).",
      "ErrorUrl": "A valid URL is required",
      "ErrorTitle": "Error Adding New Store: {{ modalType }}",
      "ErrorMessage": "Client Id: {{ clientId }}. Store: {{ modalType }}. Error creating WebStore. Code: {{ errorCode }}; Message: {{ errorMessage }}",
      "ConnectionSuccessful": "Connection successful",
      "ConnectionCreated": "The connection to your store has been created.",
      "ConnectionInProgress": "Connection In Progress",
      "ConnectionError": "Connection Error",
      "IntegrationCompleted": "Your integration is complete",
      "SelectAddDefaults": "Select 'Add Defaults' to confirm how the shipment details will be added for imported orders or 'Skip' to do this later.",
      "SelectEdit": "Select 'Edit' to confirm integration defaults or 'Skip' to do this later.",
      "ClickOKInProgress": "Click OK to return to the Ecommerce home page where you can check the status of your integration connection edit defaults once the connection is complete.",
      "ClickOKFailed": "Click OK to return to the Ecommerce home page to try again.",
      "BtnDefaults": "Add Defaults",
      "EditBtn": "Edit",
      "BtnSkip": "Skip",
      "BtnOk": "OK"
    },
    "SaveSuccess": "Changes saved successfully",
    "SaveError": "An error has occurred.",
    "SaveErrorTryAgain": "An error has occurred. Please try again later.",
    "ShopifyModal": {
      "Title": "Connect a Shopify Web Store",
      "ApiKey": "Shopify API Key",
      "ApiPassword": "Admin API Access Token",
      "SharedSecret": "API Secret Key",
      "StoreUrl": "Shopify Store URL"
    },
    "WooCommerceModal": {
      "Title": "Connect a WooCommerce Web Store",
      "StoreKey": "Store Key",
      "StoreUrl": "WooCommerce Store URL"
    },
    "ShipStationModal": {
      "Title": "Connect ShipStation",
      "ApiKey": "API Key",
      "ApiSecret": "API Secret",
      "OrderImportStartDate": "Order Import Start Date (today or future date)"
    },
    "AcceptanceModal": {
      "Title": "ShipStation Agreement",
      "Introduction": "Please read the following information carefully. Your integration of your ShipStation account for insurance only transactions constitutes your agreement with the following terms.",
      "AgreeToAutomaticPurchase": "You agree to the automatic purchase of insurance via JM<sup>®</sup> Shipping Solution for labels purchased with the insurance option set to “External” in the ShipStation platform.",
      "EligibleCarriers": "Eligible carriers include FedEx<sup>®</sup>, UPS<sup>®</sup>, USPS<sup>®</sup>, and DHL.",
      "MaximumDeclaredValue": "Maximum declared and insurable value of $5,000 per package. Actual maximum values allowed are dependent on carrier, service, and packaging per",
      "DeclaredValueInsuranceLimits": "Declared Value Insurance Limits",
      "ResidentalDeliveries": "For residential deliveries, signature service is required for declared values over $1,000; Adult signature is required for declared values over $3,000.",
      "JewelryRelated": "Use of jewelry-related or other words that may indicate valuable contents (unless the name of a person, street, or city) will void insurance coverage.",
      "InsurancePurchase": "Insurance purchases occur via data refresh every 15 minutes.",
      "OrdersFulfilled": "Orders fulfilled in multiple shipments are not supported. Insurance for the full order will be applied to the first shipment of the order.",
      "VoidAgreement": "You agree that failure to comply with any of the above terms will void any insurance coverage for the shipment affected.",
      "EmailsAgreemenet": "You agree to receive emails sent to the email address(es) identified in the ShipStation Integration defaults in this platform for:<div><ul><li>Notifications of any purchase failures, including options to resolve.</li><li>Daily summaries of successful purchases.</li></ul><div>",
      "AgreementConclusion": "<div class='pb-3'>You  agree that you may choose to disconnect from this service at any time by clicking the “remove” link on your ecommerce integrations home page.</div> <div>You agree that the standard Shipping Terms and Conditions (T&Cs) apply, including the default 30-day claim reporting window.  You acknowledge that you can upgrade to a 6-month reporting window from your ShipStation defaults menu located in this platform. To the extent any language contained in this Agreement conflicts with any language in the T&Cs, the language in this Agreement shall control.</div>",
      "CheckBoxLabel": "By checking the box, you are agreeing to the terms above.",
      "AgreedOn": "You agreed to the terms above "
    },
    "Defaults": {
      "Introduction": "  Origin details will automatically import with your orders. To override imported details, enter desired information below and select whether to apply to future and/or existing imported orders.",
      "CompanyName": "Company Name",
      "ContactName": "Contact Name",
      "AddressLine1": "Address Line 1",
      "AddressLine2": "Address Line 2",
      "City": "City",
      "State": "State",
      "PostalCode": "Postal Code",
      "Email": "Email Address",
      "OriginPhone": "Origin Phone Number",
      "DestinationPhone": "Destination Phone Number",
      "UseForFutureOrders": "Use the information above for all future imported orders",
      "UseForPreviousOrders": "Use the information above for all previously imported orders (label not yet purchased).",
      "SendNotification": "Send shipment notification to the recipient email address - if provided - upon label purchase?",
      "Tooltip": "Some carriers require a destination phone number. Destination phone number is updated only if missing from imported orders."
    },
    "EcomEditStoreTab": [
      {
        "name": "Store Information"
      },
      {
        "name": "Origin Information Defaults"
      },
      {
        "name": "Shipment Method Defaults"
      },
      {
        "name": "Insurance Default"
      }
    ],
    "EcomEditWoocommerceStoreTab": [
      {
        "name": "Origin Defaults"
      },
      {
        "name": "General Defaults"
      },
      {
        "name": "Shipment Methods"
      }
    ],
    "ShipmentMethodDefaults": {
      "GeneralDefaults": "General Defaults",
      "Economy": "Economy",
      "Express": "Express",
      "Standard": "Standard",
      "InfoTextForGeneralDefaults": "These defaults apply if no values are specified in the individual shipment methods.",
      "InfoTextForDynamicMethod": "These defaults override any values set in the General Defaults",
      "Carrier": "Carrier",
      "Service": "Service",
      "SignatureType": "Signature Type",
      "Packaging": "Packaging",
      "Dimensions": "Dimensions",
      "CargoType": "Cargo Type",
      "Weight": "Weight",
      "Save": "Save",
      "NoDefault": "No Default",
      "Restricted": "Restricted (USPS)",
      "AdultRestricted": "Adult Restricted (USPS)",
      "ClaimReportingPeriod": "Claim Reporting Period"
    },
    "InsuranceDefaults": {
      "SelectClaimReportingWindow": "Select the claim reporting window default for future orders imported.",
      "OneMonthWindow": "30-Day Claim Reporting Window",
      "SixMonthsWindow": "6-Month Claim Reporting Window",
      "Essential": "Essential",
      "Expanded": "Expanded"
    },
    "GenericError": "An error has occurred. Please try again later."
  },
  "ProcessingRequestModal": {
    "Title": "Processing Request",
    "Introduction": "We are processing your request to access JM<sup>®</sup> Shipping Solution. This may take a few moments to complete. Upon dismissing this message:",
    "ProcessingComplete": "If processing is complete, you will be directed to set up your account for Shipping services.",
    "ProcessingNotComplete": "If processing is not yet complete, you will be returned to the dashboard where you'll find instructions for next steps on the <em font-style:italic;>JM</em> Shipping Solution tile.",
    "ErrorMessage": "There was an error processing your company's access request. Please try again later."
  },
  "AccountSetup": {
    "Navigation": {
      "Questionnaire": "Questionnaire",
      "ApprovalStatus": "Approval Status",
      "TermsAndConditions": "Terms and Conditions"
    },
    "Questionnaire": {
      "Welcome": "Welcome to JM<sup>®</sup> Shipping Solution",
      "Answer": "Please answer a few questions so that we can tailor your shipping experience.",
      "Compliance": "In compliance with known shipper regulations, all accounts require review and approval.",
      "Process": "This process is greatly expedited for Jewelers Mutual policyholders.",
      "EnterJMPolicyNumber": "If you have your Jewelers Mutual Policy Number, please enter it below.",
      "JMPolicyNumber": "Jewelers Mutual policy or account number",
      "JMPolicyNumberAdditionText": "(Optional)",
      "JMPolicyNumberExplanation": "If you don't have it, or it doesn't follow the formats 55-XXXXXX OR 3XXXXXXXXX, please skip this box.",
      "ApprovalRequestReview": "If you are not a policyholder or if no policy number is provided, please allow 24 hours for our response.",
      "HowManyPackages": "On average, how many packages do you ship in a week?",
      "AverageShipmentsPerWeek": [
        {
          "label": "1-10",
          "value": "1-10"
        },
        {
          "label": "11-25",
          "value": "11-25"
        },
        {
          "label": "26-50",
          "value": "26-50"
        },
        {
          "label": "51 or more",
          "value": "51+"
        }
      ],
      "ReferralSource": "Name of referring broker or insurance agent, if applicable",
      "ReferralNonJeweler": "How did you hear about us?",
      "ReferralSourceAdditionText": "(Optional)",
      "AGSMember": "Are you an AGS member?"
    },
    "ApprovalStatus": {
      "ApprovalPending": "Approval Pending",
      "AccountApproved": "Account Approved",
      "UnderReview": "We are currently reviewing your request for approval. Please expect a call (via a 1-800#) from our representative in the next 24 hours to review information about your business. When approved, you will receive an email and your approval status will appear on the main dashboard.",
      "UnderReviewNonJeweler": "As per known shipper regulations, we are currently reviewing your request for approval for use of JM Shipping Solution.",
      "EmailConfirmation": "Please expect a call from our Jewelers Mutual representative in the next 24 hours to review information about your business. When approved, you will receive email confirmation and you will advance in the Account Setup flow to review our Terms and Conditions.",
      "PolicyNumberPreviousPage": "If you provided a Jewelers Mutual policy number on the previous page, please",
      "RefreshThePage": "refresh the page",
      "CheckApprovalStatus": "to check your approval status.",
      "UrgentActivation": "For urgent activation, please call (855) 474-4756 or email us at",
      "ThankYou": "Thank you for your patience.",
      "MainDashboard": "Main Dashboard",
      "PleaseReviewTermsAndConditions": "Your account is approved! Please review and accept the Terms and Conditions for full access to begin shipping.",
      "ViewTermsAndConditions": "View Terms and Conditions"
    },
    "TermsAndConditions": {
      "ShippingTermsAndConditions": "Shipping Terms and Conditions",
      "Accept": "I agree to the Terms and Conditions",
      "Reject": "I do not agree to the Terms and Conditions",
      "DoNotAgree": "I do not agree with the Terms & Conditions",
      "DoNotAgreeConfirmation": "<div class='mb-2'>You selected that you do not agree to the terms and conditions. If this was your intent, please confirm your choice by selecting the Log Out option.</div><div>If you did not intend to disagree, you may go back to the Terms & Conditions by selecting the Back option.</div>",
      "LogOut": "Log Out",
      "Back": "Back"
    },
    "GenericError": "An error has occurred. Please try again later."
  },
  "JmccInfoPage": {
    "Headline": "Connect your customers with peace of mind",
    "CustomerConnectHeadline": "JM Customer Connect",
    "CustomerConnectBody1": "Good news! We have now connected with the latest version of The Edge to automatically integrate all sale transactions with Zing by default.",
    "CustomerConnectBody2": "To use this integration, download the latest Edge software (at least version 22.2.3.1018) to all of your POS terminals.",
    "CustomerConnectBody3": "You will also need to receive an updated license file prior to sending JM the data.",
    "StoreManagersHeadline": "Instruction to Store Managers during sale transaction:",
    "StoreManagersBody1": "All sale transactions will show the associate a pop up for JM™ Customer Connect.",
    "StoreManagersBody2": "If the customer does not want to share their purchase information with Jewelers Mutual, select \"Don’t Send\" in this popup.",
    "StoreManagersBody3": "Jewelry insurance is only as good as the company standing behind it. Jewelers Mutual® Group has been protecting jewelry from loss, theft, damage, and even disappearance for over 100 years and has been rated A+ Superior by A.M. Best for over 30 years*. JM™ Customer Connect makes it easier than ever for your customers to experience peace of mind that only an expert like Jewelers Mutual can offer.",
    "HowItWorks": "HOW IT WORKS",
    "HowItWorksForYouHeader": "FOR YOU",
    "HowItWorksForThemHeader": "FOR THEM",
    "HowItWorksForYou1": "Download the <i>latest</i> The EDGE point-of-sale software and install the updated license file provided by The Edge after program enrollment",
    "HowItWorksForThem1": "Opt in to receive a single email from Jewelers Mutual at the time of purchase",
    "HowItWorksForYou2": "Ask your customers to confirm their contact information and consent for Jewelers Mutual to provide them a personalized insurance experience",
    "HowItWorksForThem2": "Receive a personalized quote to protect their jewelry",
    "HowItWorksForYou3": "Earn cash for each qualifying application your customers submit",
    "HowItWorksForThem3": "For eligible purchases, an offer of 15 days of protection with no payment while they evaluate their insurance needs",
    "HowItWorksForYou4": "Get repeat business from insured customers when they need claim-related repairs or replacements",
    "HowItWorksForThem4": "Ability to apply for insurance coverage during the 15 day offer period with coverage beginning the date of their jewelry purchase"
  },
  "JmccDashboard": {
    "Headline": "JM&trade; Customer Connect",
    "QuickStartGuide": "Quick Start Guide",
    "LearningAndFAQs": "Learning & FAQs",
    "CustomerTransactions": "Customer Transactions",
    "SearchLabel": "Find transactions using name, email, phone, or request ID...",
    "SearchPlaceholder": "Find Transactions",
    "ShowingResults": "Showing {{ ordersFrom }}-{{ ordersTo }} of {{ numberOfResults }} results",
    "Resend": "Resend",
    "ResendEnabledTooltip": "Resend communication to customer.",
    "ResendDisabledTooltipResent": "Communication has already been resent. Please contact Jewelers Mutual at +1 (800) 336-5642, extension 2118.",
    "ResendDisabledTooltipHasPolicy": "Customer has already submitted an application. Please contact Jewelers Mutual at +1 (800) 336-5642, extension 2118.",
    "ResendDisabledTooltipCommunicationNone": "Customer has defined the Communication method as None. Please contact Jewelers Mutual at +1 (800) 336-5642, extension 2118.",
    "ContactUs": "Contact Us",
    "ContactUsEnabledTooltip": "Contact Jewelers Mutual regarding this transaction.",
    "ContactUsAndResendDisabledForAdminTooltip": "These actions are only available for transactions within your own company.",
    "ContactUsDisabledTooltip": "Please allow us 48 hours to respond to your request.  If you need immediate assistance, call us at (833) 970-9464",
    "PagerInfo": "Showing {{ start }} to {{ end }} of {{ total }} results",
    "TransactionDate": "Transaction Date",
    "ClaimFiledDate": "Claim Filed Date",
    "DateRangeError": "Please select a date range within 365 days.",
    "NoFirstName": "[No First Name]",
    "NoLastName": "[No Last Name]",
    "NoActiveUntilDate": "[No Active Until Date]",
    "NonInsurableItems": "Non-insurable items Excluded (Returns, Batteries, etc.)",
    "NotApplicable": "N/A",
    "NoEmail": "[No Email]",
    "NoPhoneNumber": "[No Phone Number]",
    "NoCommunicationSent": "[No Communication Sent]",
    "NoTransactions": "No transactions to show.",
    "NoSearchedTransactions": "No transactions found in searching in {{ tab }} Section with the filter of {{ dateRange }}.",
    "CommunicationSent": "Communication sent successfully.",
    "ServiceError": "Something went wrong. Please contact the administrator.",
    "SubscriptionError": "Company does not have a POS Subscription.",
    "RoleError": "User does not have a valid role for JMCC Dashboard access",
    "Admin": {
      "ViewAs": "Admin - View As:",
      "Company": "Company",
      "Person": "Person",
      "ApplyFilters": "Apply Filters",
      "ResetFilters": "Reset Filters",
      "RequiredError": "Required field.",
      "NoCompanyFound": "No company found",
      "NoPersonFound": "No person found"
    },
    "Tabs": {
      "All": "All",
      "Processed": "Processed",
      "NotProcessed": "Not Processed"
    },
    "Columns": {
      "RequestId": "Request ID",
      "Status": "Status",
      "PurchaseLocation": "Purchase Location",
      "Source": "Source",
      "CustomerName": "Customer Name",
      "PurchaseDate": "Purchase Date",
      "OfferValidThrough": "Offer Valid Through",
      "Actions": "Actions",
      "Questions": "Questions?",
      "ContactInformation": "Contact Information",
      "CommunicationMethod": "Communication Method",
      "ItemDescription": "Item Description",
      "ItemID": "Item ID",
      "RetailPrice": "Retail Price"
    },
    "Dialogs": {
      "Close": "Close",
      "ContactUsHeader": "Thank you for contacting us!",
      "ContactUsBody": "We've received your request and will contact you within 2 business days.",
      "SomethingWentWrongHeader": "Something went wrong...",
      "SomethingWentWrongErrorBody": "We've ran into an issue. Please try again. If you continue to receive this message, please reach out to us for help.",
      "ContactUs": "Contact Us",
      "SupportRequestType": "How can we help",
      "SupportRequestTypeEmailPhone": "I need to change customer email / phone",
      "SupportRequestTypeSomethingElse": "Something else",
      "CustomerEmail": "Email",
      "CustomerEmailError": "Enter a valid email address.",
      "CustomerPhone": "Phone",
      "CustomerPhoneError1": "Enter a valid phone number",
      "CustomerPhoneError2": "(Example: +1 (123) 456-7890)",
      "ChangeReason": "Reason for change",
      "Email": "Your email",
      "Phone": "Your phone",
      "Description": "Describe the problem",
      "MaxCharactersError": "Only a max of {{ maxCharacters }} characters are allowed.",
      "RequiredError": "Required field.",
      "Original": "Original:",
      "NotProvided": "Not provided.",
      "ContactUsFooter1": "Need immediate assistance?",
      "ContactUsFooter2": "Call us at",
      "ContactUsFooter3": "+1 (800) 336-5642, extension 2118",
      "Cancel": "Cancel",
      "Submit": "Submit",
      "ResendDialogHeader": "Are you sure?",
      "ResendContent": "You are about to resend the communication to {{ firstName }} {{ lastName }}. Do you want to continue?",
      "ResendContentWithoutName": "You are about to resend the communication. Do you want to continue?",
      "ConfirmResendButton": "Yes, Resend",
      "PearsonSearchTooltip": "Please select a company before choosing a user.",
      "ApplyFiltersSearchTooltip": "Both company and user must be selected to apply filters."
    }
  },
  "JmccQuickStartGuide": {
    "Headline": "JM Customer Connect",
    "QuickStartGuide": "Quick Start Guide",
    "HowToGetStarted": "How to Get Started",
    "UpdateSoftware": "Update Software",
    "UpdateSoftwareBody": "Make sure your POS is updated to the most recent software version and your license is current.",
    "OfferProtection": "Offer Protection",
    "OfferProtectionBody": "Mention jewelry protection to every customer at checkout. If Jewelers Mutual POS integration is enabled, a pop-up menu will appear for qualified purchases.",
    "VerifyCustomerInfo": "Verify Customer Info",
    "VerifyCustomerInfoBody": "After getting customer consent, confirm their contact details and preferred communication method. Use your Jewelers Mutual POS integration or other chosen technology to share purchase information. We'll then send protection info to their preferred contact method.",
    "CustomerOptOut": "Customer Opt-Out",
    "CustomerOptOutBody": "If your customer declines to share their purchase details with Jewelers Mutual, select \"Don't Send\" from the integrated POS Pop-Up menu."
  },
  "JMConnect": {
    "404NotFound": "404 Not found",
    "ThankYouAlreadyPurchasedHtml": "You've accepted your Jewelers Mutual<sup>®</sup> {{ numberOfDays }}-day offer.",
    "SorryOfferInfoHtml": "Your Jewelers Mutual<sup>®</sup> {{ numberOfDays }}-Day offer has expired. But there's still time to get coverage.",
    "SorryOfferExpiredHtml": "Sorry, your {{ numberOfDays }}-day offer has expired.",
    "WellDone": "👏 Well Done!",
    "WeAreSorry": "We're sorry.",
    "ManageMyPolicy": "Manage My Policy",
    "GetAQuote": "Get a Quote",
    "JMGroup": "Jewelers Mutual",
    "JewelersMutualProtection": "{{ numberOfDays }} days of Jewelers Mutual protection from the date of purchase with no upfront payment",
    "RepairOrReplacement": "Repair or replacement in the case of loss, theft, damage, and disappearance — even while traveling worldwide",
    "OptionToWork": "Option to work with your trusted jeweler in the unfortunate event of a claim",
    "TheJewelersMutualAdvantage": "The Jewelers Mutual Advantage",
    "CoverageFromJewelersMutual": "Coverage from Jewelers Mutual gives you low to $0 deductible and higher maximum coverage amount options to keep you appropriately protected.",
    "WeWorkDirectlyWithYourLocalJeweler": "Plus, we work directly with your local jeweler to quickly repair or find a same kind and quality replacement for your jewelry. No running around town hunting for multiple estimates. We do all the leg work to get your jewelry back to you.",
    "HowWeCompare": "How We Compare",
    "TypicalHomeowners": "Typical Homeowners",
    "TypicalRider": "Typical Rider",
    "NotAlwaysCovered": "Not always covered",
    "NotAlwaysCovered1": "Not Always",
    "ZeroDeductibleOption1": "$0 Deductible Option",
    "HomeownersDeductibleApplies1": "Deductible Apply",
    "ContinueItemProtection": "Continue protection on <span class='header-text-blue'> your {{itemName}} </span> for a full year.",
    "YouAreProtectedForFifteenDays": "You're protected for {{numberOfDays}}-days from your purchase date, at no upfront cost to you.",
    "CongratsForActivatingOfferForCustomer": " Congrats on activating your offer, {{name}}! ",
    "CongratsForActivatingOffer": "Congrats on activating your offer!",
    "RemainingDaysMessage": "{{remainingDays}} days left in your {{numberOfDays}}-day offer",
    "EasyToStayProtected": "It's easy to stay protected.",
    "WhatDoesJewelryInsuranceCover": "What Does Jewelry Insurance Cover?",
    "ActivateOfferReminder": "We’ll remind you before your offer expires.",
    "StayProtected": "Stay protected",
    "ChoseAPolicyRemainingDays": "Just choose a policy within the next {{ numberOfDays }} days for a full year of coverage.",
    "OfferExpiredGetProtection": "You get protection from almost every imaginable risk life may throw at your jewelry.",
    "OfferExpiredCoverageNote": "Plus, coverage for worldwide travel.",
    "OutOfPocketCost": "Out-of-Pocket Cost",
    "ZeroDeductibleOption": "$0 deductible option",
    "HomeownersDeductibleApplies": "Homeowners deductible applies",
    "MayHaveADeductible": "May have a deductible",
    "FilingJewelryClaim": "Also, filing a jewelry claim on a standard homeowners policy may increase rates or result in cancellations.",
    "FilingJewelryClaimExpiredFlow": "Typical homeowners or renters polices cap payouts at $1000-$2000/item and can lead to rate increases or even cancelations resulting from a claim.",
    "FloodOrEarthquake": "Flood or Earthquake",
    "WorldwideTravel": "Worldwide Travel",
    "FoundersTitle": "Founded By Jewelers",
    "FoundersText1": "At Jewelers Mutual we've been protecting all things jewelry since 1913.",
    "FoundersText2": "And we didn't get to 110 years without taking care of what matters, our customers. We strive to make choosing the right protection for your jewelry as easy as possible.",
    "FoundersText3": "From our straightforward quote and apply experience to our no-hassle claims, we make protecting your cherished jewelry simple every step of the way. So, relax and wear your jewelry worry-free.",
    "FooterText1": "* The offer expires, and no protection will apply for qualifying applicants, if payment is not received within {{ numberOfDays }} days of the date of purchase.",
    "FooterText2": "Eligibility: You agree that in the past {{ numberOfYears }} years you have not had a jewelry loss or claim, had insurance coverage declined, cancelled or non-renewed, or been convicted of a felony or crime for profit.",
    "FooterText3": "** If a claim occurs during the {{ numberOfDays }} days after purchase, a jewelry insurance policy must be purchased.",
    "FooterText4": "Insurance coverage is subject to underwriting review and approval, and to the actual policy terms and conditions.",
    "FooterText5": "Any descriptions are a brief summary of coverage and are not part of any policies, nor a substitute for the actual policy language.",
    "FooterText6": "Insurance coverage is offered by a member insurer of the Jewelers Mutual Group, either Jewelers Mutual Insurance Company, SI (a stock insurer) or JM Specialty Insurance Company. Policyholders of both insurers are members of Jewelers Mutual Holding Company.",
    "Loss": "Loss",
    "LossDescription": "Maybe you left your ring somewhere - on a beach towel or in a public bathroom. We've all been here before. Just know if it's lost, it's covered.",
    "Theft": "Theft",
    "TheftDescription": "It is our hope you never have to endure the pain of losing a cherished piece to theft. Feel confident knowing you are protected in the unfortunate event your jewelry is stolen.",
    "Damage": "Damage",
    "DamageDescription": "Accidents are bound to happen at some point. If your piece becomes damaged, you can rely on our coverage to help break the fall.",
    "Disappearance": "Disappearance",
    "DisappearanceDescription": "Sometimes you can’t explain it - jewelry just disappears. It could be lost, stolen or hanging out in a drainpipe somewhere. Regardless of what happened, we’ve got you covered.",
    "PlusWorldWideTravel": "Plus, your coverage includes worldwide travel.",
    "WhatInsuranceCovers": "What does Jewelers Mutual cover?",
    "AsLowAs": "As low as",
    "Recurring": "/yr",
    "Deductible": "$0 Deductible",
    "OfferExpiredTitle": "There’s still time to get coverage from Jewelers Mutual<sup>®</sup>",
    "CheckYourRate": "Check Your Rate",
    "ReminderAlreadyRequested": "You’ve already requested a reminder."
  },
  "ShipmentTypes": {
    "Domestic": "Domestic",
    "International": "International",
    "InsuranceOnly": "Insurance Only"
  },
  "BuyLabel": "Buy Label",
  "TermsConditionsButton": "View Shipment Terms & Conditions",
  "TermsAgreementPrepend": "Please agree to the",
  "TermsAgreementAppend": "to continue your Shipment",
  "ShippingTermsConditions": "Shipping Terms and Conditions",
  "Agree": "I Agree",
  "NotAgree": "I do not accept the terms and conditions",
  "AgreeTermsAndConditions": "I agree to the terms and conditions",
  "Allowed": "Allowed",
  "InterLocationsOnly": "Between Company Locations Only",
  "DomesticShipmentsOnly": "Domestic Shipments Only",
  "ShipmentsBelowValue": "Shipments Below Value",
  "ShipmentsBelowCost": "Shipments Below Cost",
  "EnterShipmentBelowValue": "Please enter Shipment Below Value",
  "EnterShipmentBelowCost": "Please enter Shipment Below Cost",
  "StartTypingEmail": "What is the email address?",
  "EmailAddress": "Email Address",
  "CreateShippingPreset": "Create New",
  "EditShippingPreset": "Edit Shipment Preset",
  "ViewShippingPresets": "View Existing",
  "EnterPresetName": "Enter Preset Name",
  "HaveAnExistingAGSAccount": "Have an existing AGS Membership account? ",
  "ToAffiliateWithAGS": "Add your AGS membership details here to get a customized AGS experience on the Zing<sup>®</sup> Marketplace.",
  "AddAGSMembershipDetails": "Add AGS Membership",
  "InvalidAGSMembership": "AGS Membership not recognized",
  "HaveAnExistingAccount": "Have an existing JM<sup>®</sup> Shipping Solution account? ",
  "ToMergeThatAccount": "To merge that account and be able to access your address book and shipment history in the Zing<sup>®</sup> Marketplace, click \"Merge my existing account\" and follow the prompts.",
  "MergeMyExistingAccount": "Merge My Existing Account",
  "MergeExistingAccounts": "Merge Existing Accounts",
  "MergeYourExistingAccount": "Merge your existing JM<sup>®</sup> Shipping Solution account by verifying your username and password for that account. ",
  "MergeShippingAccount": "Merge my existing JM<sup>®</sup> Shipping Solution account",
  "EmailConsentOptOut": "<strong>I consent to receive news, updates or promotions from Jewelers Mutual Group.</strong> I understand that I can unsubscribe at any time. Please refer to our Privacy Policy for more details.",
  "YourAddressBook": "Your address book and shipment history will then be merged and available from the Zing<sup>®</sup> Marketplace.",
  "ThisMerge": "This merge of your shipping history and address book will only take place during this session.",
  "Username": "Username",
  "AddAPaymentMethod": "Add a payment method",
  "ACreditCardOnFile": "A payment method is required before making a shipment. Please update your profile with a payment method, or you may provide one at the time of your first purchase.",
  "AMLCreditCard": "A valid payment method is required to proceed with the AML training purchase. Please add one to your account before purchasing a program.",
  "AMLNoDefaultPaymentMethod": "A default payment method is required to proceed with the AML training purchase. Please update your profile by setting a default payment method before purchasing a program.",
  "ShipmentDashboardNoDefaultPaymentMethod": "A default payment method is required before making a shipment. Please update your profile by setting a default payment method to be used for purchase.",
  "WhatIsYourUsername": "What is your username?",
  "WhatIsYourPassword": "What is your password?",
  "UsernameAndOrPasswordIncorrect": "Username and/or password for iShipJM.com (or Transguardian.com) are incorrect. Please try again. ",
  "SignIn": "Sign In",
  "LogOut": "Log Out",
  "EnterAmount": "Enter Amount",
  "EnterDollarAmount": "Enter $ amount",
  "AGSSuccessBold": "Success! ",
  "SuccessfulAGSAffiliation": "You are now an AGS member.",
  "SuccessBold": "Success! ",
  "SuccessfulMerge": "Your credentials were successfully validated and we have begun to merge your accounts.",
  "YourUsernameAndPasswordAreValid": "Your username and password for the Zing<sup>®</sup> Marketplace are now valid for your iShipJM.com (or TransGuardian.com) account. ",
  "PleaseLogoutAndLogBackIn": "Please logout and log back in to the Zing<sup>®</sup> Marketplace for the changes to take effect.",
  "FedExRequiresITN": "FedEx requires an ITN for international shipments valued over $2,500",
  "FedExInternationalAbove": "FedEx International shipments valued over $2,500 require an Internal Transaction Number (ITN). The ITN is an Automated Export System (AES) generated number assigned to a shipment confirming that an Electronic Export Information (EEI) transaction was accepted and is on file in the AES. If you don't have access to AES in order to secure the required ITN, contact FedEx to request one using your carrier account detail.",
  "Customs": "Customs",
  "IAcknowledgeTheUSCustoms": "I acknowledge the U.S. Customs requirement for me to include 3 copies of a detailed commercial invoice for the contents of this shipment in a plastic pouch on the outside of my package. If requested, a commercial invoice will be sent to you via email for this purpose, or you can use your own.",
  "CustomsAgree": "Agree",
  "NoClaims": "There are currently no claims",
  "NoShippingInsurance": "There is currently no shipping insurance to view",
  "NoPending": "There are currently no pending payments",
  "NoPaymentsCL": "There are currently no payments made for this account",
  "NoTransactionHistory": "There are currently no transactions for this account",
  "RequestReview": "Request Review",
  "SubmitReview": "Submit Review",
  "AdditionalComments": "Additional Comments",
  "NotRecognizedTransaction": "I don’t recognize this transaction",
  "FraudPurchase": "Fraud or Unauthorized purchase",
  "BillingError": "There was a billing error",
  "PackageDetails": "Package Details",
  "ClaimDescription": "Claim Description",
  "DamageAndPackage": "Damage and Package Description",
  "ConfirmAndSubmit": "Confirm And Submit",
  "Submit": "Submit",
  "FileAClaim": "File a Claim",
  "SecuritySetup": "Security Setup",
  "EnterSecuritySetup": "Please enter following details for the security of your account",
  "NeedAssistance": "Need assistance? Call ",
  "To": "To",
  "Person": "Person",
  "SuggestedPreset": "Suggested Preset",
  "PermissionLevel": "Permission Level",
  "Shipping": "Shipping",
  "Banner": "Banner",
  "AccountSettings": "Account Settings",
  "BusinessInsurance": "Business Insurance",
  "QuickQuote": "Quick Quote",
  "Shipment": "Shipment",
  "Return": "Return",
  "ShipmentPurchase": "Shipment Purchase",
  "Label": "Label",
  "ForbiddenWords": "The label contains one or more words that may indicate valuable contents",
  "Tracking": "Tracking",
  "Documents": "Documents",
  "GetQuote": "Get Quote",
  "GetQuotes": "Get Quotes",
  "StartOver": "Start Over",
  "NumberOfResults": "Showing {{ resultNumber }} results.",
  "UserDetails": "User Details",
  "RegistrationID": "User Registration ID",
  "JMShippingSolutionHelp": "JM<sup>®</sup> Shipping Solution Help",
  "GeneralHelpLine": "General Help Line",
  "LengthRule": "8-20 characters",
  "UpperCaseRule": "At least one upper case letter",
  "LowerCaseRule": "At least one lower case letter",
  "NumberRule": "At least one number",
  "Start": "Start",
  "SpecialCharacterRule": "At least one special character",
  "NoSpaceRule": "No spaces",
  "AddBusinessInsurance": "Add Business Insurance",
  "GetBusinessInsuranceQuote": "Get a Business Insurance Quote",
  "MakeAPayment": "Make a Payment",
  "ViewBusinessInsuranceDetails": "View Business Insurance Details",
  "CommercialLineInsuranceHeadline": "My Business Insurance",
  "CommercialLineInsuranceTitle": "Protect your Jewelry Business with JM Policy",
  "PersonalLinesInsuranceHeadline": "Personal Insurance",
  "PersonalLinesInsuranceTitle": "Start a New Customer Claim",
  "CustomerJewelryClaims": "Customer Jewelry Claims",
  "JewelerPagesPermission": "Create or Update Jeweler Page",
  "AuctionPagesPermission": "View Auction Details",
  "MarketPlaceDetails": "View Marketplace Details",
  "PartnerGateway": "JM Partner Gateway",
  "Appraisals": "Appraisals",
  "Jmcc": "Point of Sale Connect",
  "GemAndJewel": "Gem + Jewel",
  "Dashboard": "Dashboard",
  "MyProfile": "My Profile",
  "CarePlan": "Care Plan",
  "HelpVideoTitle": {
    "HelpVideoShippingTitle": "JM™ Shipping Solution",
    "HelpVideoAppraisalTitle": "Jewelry Appraisal Solution",
    "HelpVideoPersonalTitle": "Personal Line Claims",
    "HelpVideoCarePlanTitle": "JM™ Care Plan",
    "HelpVideoMarketPlaceTitle": "Diamond Marketplace",
    "JMShippingSolutionPDF": "How to use JM™ Shipping Solution"
  },
  "HelpVideoDescriptionTitle": {
    "HelpVideoShippingDescriptionTitle": "How to Create a Shipment:",
    "HelpVideoAppraisalDescriptionTitle": "How to Create an Appraisal:",
    "HelpVideoPersonalDescriptionTitle": "How to Submit a Claim:",
    "HelpVideoCarePlanDescriptionTitle": "How to Submit a Care Plan Claim:",
    "HelpVideoMarketPlaceDescriptionTitle": "How to Search for a Diamond:"
  },
  "HelpVideoDescription": {
    "HelpVideoShippingDescription": "JM™ Shipping Solution makes the task of shipping gems and jewelry simple! This video will walk you through how to create your first shipment.",
    "HelpVideoAppraisalDescription": "The Jewelry Appraisal Solution leverages Gemworld’s expertise to make the appraisal process fast and easy. This video will walk you through how to create an appraisal.",
    "HelpVideoPersonalDescription": "The Personal Line Claims tool helps streamline your customers’ claims process. This video will walk you through how to create and submit personal line claims for Jewelers Mutual® Group policyholders.",
    "HelpVideoCarePlanDescription": "JM™ Care Plan protects your customers’ jewelry and watches from damage; keeping them in like-new condition. This video will walk you through how to create a care plan claim for your customer.",
    "HelpVideoMarketPlaceDescription": "The Diamond Marketplace, powered by IDEX, allows you free and transparent access to inventory from suppliers around the globe. This video will walk you through how to search for any diamond you need.",
    "JMShippingSolutionPDF": "View this guide to learn how easy it is to create labels and protect shipments with JM™ Shipping Solution."
  },
  "LandingPageHelpVideoTitle": {
    "HelpVideoAppraisalTitle": "How to Create an Appraisal",
    "HelpVideoPersonalTitle": "How to Submit a Personal Jewelry Claim",
    "HelpVideoCarePlanTitle": "How to Submit a JM Care Plan Claim",
    "HelpVideoMarketPlaceTitle": "How to Search for a Diamond"
  },
  "RegistrationVideoTutorial": {
    "Title": "Zing<sup>®</sup> Marketplace Registration Video",
    "Message": "This quick video will guide you through the registration process.",
    "Button": "Return to Registration"
  },
  "PLClaimsVideoTutorial": {
    "Title": "Zing<sup>®</sup> Marketplace Claim Overview",
    "Message": "This quick video provides a quick overview of customer jewelry claims on Zing<sup>®</sup>.",
    "Button": "Return to Zing Home"
  },
  "LandingPageHelpVideoDescription": {
    "HelpVideoAppraisalDescription": "The Jewelry Appraisal Solution leverages Gemworld’s expertise to make the appraisal process fast and easy. This video will walk you through how to create an appraisal.",
    "HelpVideoPersonalDescription": "The personal jewelry insurance claim feature helps streamline your customers’ claim process. This video will show you how to create and submit claims, saving time and increasing transparency for you and your customers.",
    "HelpVideoCarePlanDescription": "JM Care Plan products protect your customers’ jewelry and watches from damage, keeping them in like-new condition. This video will show you how seamless it is to process a claim for your customers.",
    "HelpVideoMarketPlaceDescription": "The Diamond Marketplace, powered by IDEX, allows you free and transparent access to inventory from suppliers around the globe. This video will show you how simple it is to find the exact diamond you need among hundreds of thousands."
  },
  "HelpDocuments": {
    "OtherHelpDocuments": "Other Help Documents:",
    "InviteStaffHeader": "Learn how to invite your staff",
    "InviteStaffDescription": "View this guide to learn how to add users to your business’s account on the Zing<sup>®</sup> Marketplace and how to set their permissions."
  },
  "HelpVideoHeader": "Help Center Videos",
  "HelpVideoYouTube": " Videos hosted on YouTube",
  "ZingPlatformOverview": "Zing<sup>®</sup> Marketplace Overview",
  "AppraisalSolution": "Jewelry Appraisal Solution",
  "MarketplaceSolution": "Diamond Marketplace",
  "ShippingSolution": "JM<sup>®</sup> Shipping Solution",
  "PolicyholderSolution": "Policyholder Claim Submissions",
  "CarePlanSolution": "JM™ Care Plan",
  "ID": "ID",
  "AppraisalPermissionsHeading": "Generate and View Appraisals",
  "EnterTrackingNumber": "Enter Tracking Number",
  "AverageShipmentsPerWeek": [
    {
      "label": "1-10",
      "value": "1-10"
    },
    {
      "label": "11-25",
      "value": "11-25"
    },
    {
      "label": "26-50",
      "value": "26-50"
    },
    {
      "label": "51 or more",
      "value": "51+"
    }
  ],
  "Hyphen": "-",
  "InsuranceLimits": "Declared Value Insurance Limits",
  "ShippingFAQ": "FAQ/ How do I…",
  "BannerText": "Hello {{ firstName }}! You are unable to use Zing by Jewelers Mutual Group<sup>®</sup> to it’s full potential as your business is still not registered on the Zing<sup>®</sup> Marketplace by your Business Owner.",
  "AuctionBannerUnderReview": "We’re reviewing your application. You’ll hear from us soon!",
  "PagerInfo": "Showing {{start}} to {{end}} of {{total}} entries",
  "Errors": {
    "MemoPreferenceUpload": "Updating T&C failed, please try again later.",
    "MemoLogoUpload": "Updating logo failed, please try again later.",
    "PartnerAffiliations": {
      "AGS": "Invalid AGS Membership details"
    },
    "Memo": {
      "InvalidTrackingNumLength": "50 Characters Maximum",
      "PleaseSelectShape": "Please select a shape",
      "WeightInvalid": "This exceeds the maximum weight allowed.",
      "WeightRequired": "Please enter weight.",
      "CaratWeightRequired": "Please enter carat weight.",
      "ItemIdInvalid": "This exceeds the maximum characters allowed.",
      "ItemIdRequired": "Please enter Item ID.",
      "TotalPriceInvalid": "This exceeds the maximum amount allowed.",
      "TotalPriceRequired": "Please enter total price.",
      "InvalidFormat": "This is an invalid format."
    },
    "Brinks": {
      "OneIsRequired": "(at least one is required)",
      "AtLeastOneIsRequired": "At least one of Company Name, First Name, Last Name is required",
      "ValidAddressRequired": " A valid address is required",
      "CityRequired": "City is required",
      "StateProvinceRequired": "State/Province is required",
      "PostalCodeRequired": "Postal Code is required",
      "CommodityRequired": "Commodity is required",
      "DeclaredValueRequired": "Declared Value is required",
      "PackageWeightRequired": "Package Weight is required",
      "PhoneRequired": "A valid phone number is required",
      "CompanyRequired": "Company is required",
      "FirstNameRequired": "First Name is required",
      "LastNameRequired": "Last Name is required"
    },
    "PasswordRequired": "Enter a valid password.",
    "PasswordStrength": "Your password is weak and should include one uppercase letter, one special character and alphanumeric characters.",
    "NewAndConfirmPasswordNotEqual": "Password does not match.",
    "PasswordMismatch": "Entered password does not match with the current password, please enter correct password.",
    "PasswordAlreadyUsed": "Please create a new password. Your password should be different from previous 10 passwords",
    "PasswordPattern": "Your password is invalid. It should be minimum 8 and maximum 20 characters and include a special character and a digit.",
    "InvalidMobileNumber": "Enter a valid mobile number (Example: 1234567890)",
    "InvalidPhoneNumber": "Enter a valid phone number (Example: 1234567890)",
    "PhoneNumberRequired": "Phone number is required.",
    "InvalidEmailAddress": "Enter your email address (50-character limit).",
    "InvalidEmail": "Enter a valid email address",
    "InvalidEmails": "Enter valid email addresses",
    "InvalidEmailsSemicolon": "Enter one or more valid email addresses separated by semicolon.",
    "EmailIsInUse": "Email is used by another user. Enter different one.",
    "CountryCodeRequired": "Select a country code",
    "InvalidBrand": "Please enter Brand",
    "InvalidModel": "Please enter Model",
    "InvalidMaterial": "Please enter Material",
    "InvalidJewelryStyle": "Style must be alphanumeric. Please re-enter.",
    "RequiredJewelryStyle": "Please enter Jewelry Style",
    "InvalidOtherMetalType": "Type must be alphanumeric or is missing. Please re-enter.",
    "InvalidOtherVariety": "Variety must be alphanumeric or is missing. Please re-enter.",
    "InvalidCompanyName": "Enter your company name (75-character limit).",
    "InvalidLegalCompanyName": "Enter legal company name.",
    "BusinessTypeError": "Select an option that best describes your business.",
    "SpecifyBusinessError": "Enter your business description (200-character limit).",
    "InvalidWebsite": "Enter your company website (75-character limit).(Ex: companyname.com)",
    "CompanyRetrieve": "Unable to get Company Details",
    "AnswerRequired": "Answer security question to continue",
    "InvalidAnswer": "Enter a valid answer that is between 5 and 20 characters in length.",
    "WrongSecurityAnswer": "Your answer could not be verified. Please try again.",
    "TwoFactorAuthCodeInvalid": "The code you have entered is invalid. Please enter correct code.",
    "TwoFAAuthUnsuccessful": "Authentication Unsuccessful.",
    "AccountNotFound": "Try entering your Zing<sup>®</sup> Marketplace account again. We don't recognize this one.",
    "GenericError": "Sorry, there was an error. Please try again later.",
    "ThereWasAnError": "! Sorry, there was an error. Please try again later.",
    "SystemError": "Our system is currently having trouble. Please try again later.",
    "AddressLineEmpty": "Enter valid address",
    "CountryEmpty": "Enter valid country.",
    "StateInvalid": "Please enter valid state.",
    "ProvinceInvalid": "Please enter valid province.",
    "StateRequired": "Please select valid state",
    "CountryInvalid": "Invalid country.",
    "ZipCodeEmpty": "Enter valid zip code",
    "ZipCodeInvalid": "Enter valid zip code",
    "PostalCodeInvalid": "Enter a valid postal code",
    "LocationIsRequired": "Location is required",
    "PackageQuantityRequired": "Package Quantity is required",
    "TotalWeightRequired": "Total Weight  is required",
    "ServiceTypeRequired": "Service Type is required",
    "ReadyTimeRequired": "Ready Time is required",
    "CloseTimeRequired": "Close Time is required",
    "CloseTimeCannotBeEarlierThanReadyTime": "Close Time cannot be earlier than Ready Time",
    "PickupDateRequired": "Pickup Date  is required",
    "CompanyRequired": "Company name is required",
    "DescriptionRequired": "Description is required",
    "MinCartSubtotalRequired": "Min cart subtotal is required",
    "MaxCartSubtotalRequired": "Max cart subtotal is required",
    "MinGreaterThanMax": "Must be less than Max cart subtotal",
    "ValueGreaterThanMillion": "Must be less than $1,000,000",
    "MustBe100OrLess": "Must be 100% or less",
    "FlatRateAmountRequired": "Flat rate amount is required",
    "PercentMarkupRequired": "Percent markup is required",
    "SignatureRequired": "Signature selection is required",
    "PackagingRequired": "Packaging selection is required",
    "ContactIsRequired": "Contact is required",
    "AddressRequired": "Address Line 1 is required",
    "CityRequired": "City is required",
    "PostalCodeIsRequired": "Postal Code is required",
    "PostalCodeRequired": "Enter postal code",
    "CityEmpty": "Please enter valid city",
    "InvalidFeinId": "Enter valid FEIN Id",
    "InvalidBusinessUnitName": "Enter valid Business Unit",
    "ContactPreferenceInvalid": "Please select Contact Preference",
    "ContactRequired": "Please enter valid contact data.",
    "AddressValidationFailed": "The address entered cannot be validated. Please update the address details.",
    "NameInvalid": "Enter a valid name",
    "FirstNameInvalid": "Enter your first name (50-character limit).",
    "LastNameInvalid": "Enter your last name (50-character limit).",
    "ReferenceNameInvalid": "Enter valid Reference Name (50-character limit)",
    "UpdatedPersonalDetails": "Your Personal Details are updated successfully",
    "EmailEmpty": "Enter a valid email address",
    "LocationNameInvalid": "Enter valid location name",
    "AddressDuplicate": "Address location entered is duplicate",
    "PhoneNumberCodeInvalid": "Code entered is invalid. Please enter a valid code.",
    "EmailNotVerified": "Email not verified. Please verify your Email.",
    "LocationRequired": "Location is mandatory for approving request",
    "RoleRequired": "Role is mandatory for approving request",
    "LocationRequiredInviteUser": "Location is mandatory for inviting user",
    "RoleRequiredInviteUser": "Role is mandatory for inviting user",
    "InvalidCompanySearch": " Invalid Company Name, City and/or State",
    "MustHaveOneBA": "Unable to change Role, Business must have at least one Business Administrator",
    "CanNotHaveMoreThen100BA": "Unable to change Role, Business cannot have more than 100 Business Administrators",
    "CanNotHaveMoreThen100BLA": "Unable to change Role and or unable to assign user to Location. Location cannot have more than 100 Business Location Administrators",
    "UnAuthorized": "Sorry, you are not authorized",
    "VerificationCodeExpired": "Your verification code has expired",
    "PhoneNumberDuplicate": "Entered phone number is duplicate",
    "EmailDuplicate": "Entered email address is duplicate",
    "SkillExist": "Skill or Service already exists",
    "InvalidImageFormat": "Image Format should be .jpeg, .png or .gif",
    "DuplicateContactFound": "Duplicate record found, please change the record details and continue",
    "MissingContactName": "Enter at least one of the following 'First Name', 'Last Name', 'Company Name' in order to proceed.",
    "ImageSize": "Image size should be less than 5 MB",
    "FileSize": "File size should be less than 5 MB",
    "FileType": "Supported file types are .pdf, .jpg, .jpeg, .png and .gif",
    "AppraisalFileSize": "Images with a file size larger than 5MB will not upload. Check the size of your file, and reduce it before trying to upload it again.",
    "LogoMaxWidthHeight": "Maximum image size is 2048 X 2048 pixels.",
    "LogoFileType": "Supported file types are .jpg, .jpeg, .png and .gif",
    "SpecialCharacterError": "The uploaded file(s) name contains special characters or '0x' followed by letters or numbers, file(s) cannot be uploaded",
    "FileUploadError": "File(s): {{filenames}} failed to upload. Please check the file(s) type and name.",
    "ToggleFavoriteFailed": "Marking contact as favorite failed.",
    "ToggleUnfavoriteFailed": "Removing contact from favorites failed.",
    "DeleteContactFailed": "Deleting contact failed.",
    "FrequentContactsFailed": "Getting frequently contacted contacts failed.",
    "CargoType": "Cargo Type is required",
    "HoldForPickupAddressNotSelected": "Please choose a FedEx Hold for Pickup location. If you do not wish to use the Hold for Pickup option, please uncheck the box and proceed.",
    "DatePicker": "Date is required",
    "PackagingDetails": "Select a packaging option",
    "PackagingTypes": "Package Type selection is required",
    "SelectPackagingType": "Please select Packaging Type.",
    "TariffCode": "Tariff Code is required",
    "InvalidTariffCode": "Enter valid Tariff Code",
    "Quantity": "Item Quantity is required",
    "QuantityUnit": "Quantity Unit is required",
    "Weight": "Weight is required",
    "WeightUnit": "Weight Unit is required",
    "DetailedDescription": "Detailed Description is required",
    "ExportType": "Export Type is required",
    "ScheduleBUnit": "Schedule B Unit is required",
    "MPidRequired": "Enter the M-PID",
    "NsPidRequired": "Enter the NS-PID",
    "SPidRequired": "Enter the S-PID, or select the \"No barcode\" option",
    "PidMaxLength": "Maximum {{max}} characters",
    "TaxID": "Tax ID is required",
    "EORI": "Enter a valid EORI number (25-character limit)",
    "DHLRegistrationIncomplete": "Tax ID, Registration Type, and Issuer Country must all be provided together",
    "EORIIssuerCountryIncomplete": "EORI number and Issuer Country must both be provided together",
    "ReasonForExport": "Reason for Export is required",
    "customsContentType": "Customs Content Type is required",
    "ContentsDescription": "Contents Description is required",
    "ContentsDescriptionMilitaryMail": "Contents Description is required (25 character maximum)",
    "ItnFilingRequired": "Please indicate whether this shipment needs an ITN filing",
    "RecipientTypeRequired": "Please select whether the recipient is a business or an individual",
    "ItnRequired": "ITN is required",
    "ItnTooShort": "ITN must be at least {{length}} characters",
    "EeiExemptionRequired": "EEI Exemption reason is required",
    "ExemptionCertificationRequired": "Certification is required",
    "StaticDocumentUnavailable": "We couldn't open this document. Please try again later.",
    "invoiceNumber": "Invoice Number is required",
    "termsOfSale": "Terms of Sale is required",
    "InvalidLength": "Please enter Length.",
    "InvalidWidth": "Please enter Width.",
    "InvalidHeight": "Please enter Height.",
    "InvalidWeight": "Package Weight is required",
    "InvalidShipmentWeight": "Weight is required",
    "InvalidDeclaredValue": "Declared Value is required",
    "DeclaredValueAbovePermittedLimit": "This amount exceeds your permitted value limit. Please contact your Business Administrator for more details.",
    "ZeroDeclaredValue": "A declared value greater than $0 is required for insurance only shipments",
    "IsResidentialInvalidDeclaredValue": "Shipments valued over $75,000 are not permitted to residential addresses. Please use the Hold for Pickup option in the Destination section above to ship to a commercial-based address for shipments of this value",
    "InvalidInvoiceValue": "Invoice Value is required",
    "InvalidItemValue": "Item Value is required",
    "InviteLinkExpired": "This link has expired. Please check your inbox for the most recent registration link from Zing by Jewelers Mutual Group. Please contact your business administrator or contact support at {{SupportNumber}} if you need further assistance.",
    "InviteLinkUsed": "This link has already been used. Please contact your business administrator or contact support at {{SupportNumber}} if you need further assistance.",
    "RegistrationFailed": "Your registration has failed",
    "SignaturesRequired": "Signature Type is required",
    "ApprovalCodeRequired": "Please enter an approval code or seal number to proceed.",
    "DownloadFailed": "Download failed. Please try again later",
    "InvalidTrackingId": "  Invalid Tracking ID. Please confirm and try again.",
    "CarrierAndServiceRequired": "Please select a Carrier and Service",
    "CarrierRequired": "Carrier selection is required",
    "DhlUnavailable": "DHL is no longer available. Remove it to continue with the remaining carriers.",
    "ServiceRequired": "Service selection is required",
    "SelectCarrier": "Please select a Carrier.",
    "SelectService": "Please select a Service.",
    "CouldNotProcessShipment": "Could not process this shipment.",
    "PermissionsUpdateFailed": "Updating shipment permissions failed. Please try again later.",
    "EmailRequired": "Email is required.",
    "EmailBoomerangLabelFailed": "Emailing boomerang label instructions failed.",
    "ShipmentAlreadyVoided": "Shipment is already voided.",
    "PresetNameInvalid": "Enter a valid preset name (maximum character length 25)",
    "MaxShippingPresetsReached": "You already have saved {{maxPresets}} presets. Please delete an existing preset if you want to add a new one.",
    "NoInvoicesToBeViewed": "Currently, there are no invoices to be viewed",
    "NoTransactionsToBeViewed": "Currently, there are no transactions to be viewed",
    "NoPaymentsToBeViewed": "Currently, there are no payments to be viewed",
    "InvalidContact": "Enter your contact name (50-character limit)",
    "InvalidCompany": "Enter company name (100-character limit)",
    "NoActivePolicy": "The account below does not have an active policy. Please contact your agent at {{agencyNumber}} for assistance.",
    "AccountIsPastDue": "Your account is past due. Please make the payment immediately.",
    "BillingReviewFailed": "Your request to review the shipment charges is not submitted successfully. Please try again.",
    "CardNumberInvalid": "Enter valid card number",
    "NameOnCardEmpty": "Enter valid name on card",
    "ExpiryDateInvalid": "Enter valid expiration date",
    "CVVNumberInvalid": "Enter valid CVV number",
    "PaymentMethodInvalid": "Enter valid payment method",
    "CardNickNameInvalid": "Enter valid nickname",
    "DecimalValue": "Only integer value with two decimal point is allowed",
    "ContentsDescriptionRequired": "Contents Description is required",
    "RequiredSelection": "Selection is required",
    "CompletePartialRequired": "Complete or Partial selection is required",
    "InvalidPackageValue": "Please enter the package value",
    "ShipmentNotFound": "Shipment ID entered cannot be found. Please try again",
    "AllUnavailableQuotes": "There are no search results matching your request. Please update the shipment details.",
    "TryAgain": "Something went wrong, please try again.",
    "ExchangeRateUnavailable": "We couldn't get the current exchange rate, so the currency wasn't changed. Please select the currency again.",
    "PleaseAddPaymentMethod": "Please add a payment method to your company’s profile.",
    "PleaseAskBusinessAdministrator": "Please ask your company’s Business Administrator to add a payment method in your company’s profile.",
    "ShippingDateInvalid": "Please enter valid shipping date.",
    "CantGetRequiredInfo": "Sorry we can't get the required info.",
    "DuplicateAccount": "This Business Insurance account already exists.",
    "InvalidAccountPolicyNumber": "Enter matching account/policy and postal code details to link the account",
    "InvalidAccountPolicyNumberFormat": "No match found. Enter Account Number/Policy Number",
    "InvalidPostalCode": "No match found. Enter valid Postal Code. Examples (11111, 11111-1111, A1A 1A1)",
    "BusinessInsurancePermissionsLoad": "Could not load Business Insurance Permissions",
    "BusinessInsurancePermissionsSave": "Could not save Business Insurance Permissions",
    "PresetNameAlreadyExistsException": "The Shipping preset name entered is duplicate. Please enter a unique preset name to continue.",
    "NoAppraisalsToBeViewed": "No appraisals – You do not have any appraisals yet.",
    "NoAppraisalFoundWithThatValue": "No appraisal found with that value.",
    "AlreadyMigrated": "This user is already registered on the Zing<sup>®</sup> Marketplace. Please navigate to <a class='login-redirect' href='{{baseUrl}}'> zing.jewelersmutual.com </a> to proceed with log in.",
    "SorryThereWas": "Sorry, there was an",
    "ErrorPleaseTryAgain": "error. Please try again later.",
    "SupplyOrderCarriersRequired": "Please select required supplies.",
    "NoSupplyOrders": "No Orders",
    "NotAllowed": "You do not have permissions to perform the action.",
    "GenerateScanFormFailed": "Generating scan form failed.",
    "GenerateFirmBookFailed": "Generating Firm Book failed.",
    "NoShipmentFound": "No USPS Shipment Found.",
    "InvalidPhoneNumberInternational": "Enter phone number (25-character limit)",
    "InvalidAddressLineInternational": "Enter valid address (50-character limit)",
    "InvalidCityInternational": "Enter city (50-character limit)",
    "InvalidStateLineInternational": "Enter state (50-character limit)",
    "InvalidPostalCodeInternational": "Enter postal code (50-character limit)",
    "InsuranceNotAvailable": "Insurance Not Available",
    "ContactEmpty": "Please enter valid contact",
    "TaxIdEmpty": "Please enter valid tax ID",
    "InvalidTrackingNumber": "Minimum 8 characters required",
    "JMpolicyNumberPlaceholderValidation": "Enter Policy Number (eg. 55-123456) or Account Number (eg. 3001999999)",
    "PolicyNumberFieldError": "Please leave this box blank unless your policy or account number follows the formats 55-XXXXXX OR 3XXXXXXXXX",
    "InvalidInsuranceOnlyQuote": "The shipment details you submitted did not result in a valid quote. Please review and edit the details entered, noting that this is often due to carrier requirements for a custom box on 1<sup>st</sup> class/ground/3-day services.",
    "ApprovalCodeInvalid": "Approval Code is required",
    "ApprovalCodeInvalidQuote": "The approval code you entered is expired, or the shipment value exceeds the limit, or the code does not match our records. Please check your entry.",
    "AddressLine1And2Limit": "The combined total of the Address Line 1 and Address Line 2 cannot be more than {{limit}} characters.",
    "ErrorSingular": "error",
    "ErrorPlural": "errors",
    "SEDSignaturePersonError": "Enter name (35-character limit)",
    "SEDSignatureTitleError": "Enter title (35-character limit)",
    "SEDSignaturePhoneError": "Enter phone number",
    "SEDSignatureEmailError": "Enter a valid email address",
    "AGSMemberNotFound": "AGS Membership not recognized",
    "PaymentError": "System error. Please try again.",
    "ClaimRequired": "Value of Claim is required",
    "InvalidSenderRecipientInfo": "At least one of Company Name, First Name, Last Name is required",
    "InvalidSenderRecipientPhoneNumber": "A valid phone number is required",
    "InvalidSenderRecipientAddress": "A valid address is required (letters and numbers only)",
    "InvalidSenderRecipientAddressTwo": "Enter valid address (letters and numbers only)",
    "InvalidSenderRecipientCity": "City is required",
    "InvalidSenderRecipientState": "State/Province is required",
    "InvalidSenderRecipientPostalCode": "Postal Code is required",
    "ValidPackageDimensionsRequired": "Valid Package Dimensions are required",
    "SelectCarrierServicesPackage": "Select a Carrier, Service and Package Type",
    "SelectCarrierPackage": "Select a Carrier and Package Type",
    "SealRequired": "Seal # is required",
    "PurchaseGenericError": "Sorry there was an error. Please try again.",
    "AddressInformationRequired": "All Address information is required.",
    "OriginAndDestinationAddressRequired": "Origin and Destination address information is required before adding Shipment Details.",
    "SealInvalid": "An invalid seal number was entered. Please input the identification number located on the high security packaging (Fraudstopper™ bag or similar) being used for this shipment.",
    "RetryLimitReached": "System error. Please contact customer support by calling 1-833-970-9464 or emailing zing@jminsure.com to resolve the issue. Thank you for your patience.",
    "UnexpectedError": "We’ve encountered an unexpected error. If the problem continues, please contact our support team at {{ phoneNumber }} for assistance.",
    "UpdateLogoPermissionMessage": "Only Business Administrator has permission to update the logo"
  },
  "Labels": {
    "Counter": "{{value}}/{{maxLength}} characters",
    "FrequentlyAskedQuestions": "Frequently Asked Questions",
    "RemoveSearchPresetConfirmationModal": {
      "Title": "Remove Search Preset",
      "Body": "Are you sure you want to remove: {name}?"
    },
    "AGSNewsWidget": {
      "Title": "AGS News",
      "LearnMoreLink": "Learn more >",
      "FindJewelerTitle": "Find a Jeweler"
    },
    "PartnerAffiliations": {
      "Partners": {
        "None": "None",
        "AGS": "AGS",
        "GemAndJewel": "Gem + Jewel"
      },
      "AffiliationType": "Affiliation",
      "MasterMemberId": "Company Membership ID",
      "IndividualMemberId": "Individual Membership ID"
    },
    "NoEmailConsentBannerMessage": "<strong>You’re missing important news and updates!</strong> Select the checkbox at the bottom of your Profile Settings to update your communication preferences and stay informed.",
    "NoEmailConsentBannerBtnText": "Update Now",
    "ConfirmationBanner": "Changes saved successfully.",
    "ErrorBanner": "Sorry, there was an error. Please try again.",
    "ECommerceAlertMethodEnabled": "Shipment method is now enabled.",
    "ECommerceAlertMethodDisabled": "Shipment method is now disabled.",
    "ECommerceAlertMethodSaved": "Shipment method saved successfully.",
    "ECommerceAlertMethodDeleted": "Shipment method deleted successfully.",
    "ECommerceAlertMethodError": "Sorry, there was an error. Please try again.",
    "ECommerceAlertMethodSaveError": "There was a problem saving the shipment method. Please try again.",
    "ErrorSomeQuotes": "<span class='quotes-alert-bolder'>One or more quotes have errors.</span> Hover over <i class='mdi mdi-alert-outline quote-error-icon'></i> to view error details.",
    "ErrorAllQuotes": "<span class='quotes-alert-bolder'>There are no search results matching your request.</span> Hover over <i class='mdi mdi-alert-outline quote-error-icon'></i> to view error details. Please GO BACK to edit shipment details.",
    "GradingLab": {
      "ReportLabel": "Grading Lab Report"
    },
    "Brinks": {
      "NowAvailable": "Now Available",
      "ArmoredDoorToDoor": "Armored Door-to-Door Transport Services",
      "WeOffer": "We now offer the ability to quote via Brink’s for armored transport service of high value shipments. Quotes are currently available for service between U.S. commercial business locations (residential, PO Box, or APO not available at this time).",
      "BrinksWillContactYou": "Following submission of your quote request, a representative from Brink’s will contact you - the same business day if received before 5pm ET - to complete the transaction. Purchases will be handled directly with Brink’s and any final shipment information will not appear in the Zing® Marketplace. All communications on purchase, delivery, billing and payment will come from Brink’s.",
      "SkipScreen": "Skip this screen next time",
      "GetStarted": "Get Started",
      "RequestAQuote": "Request a Quote",
      "ServicesProvidedBy": "Services provided by",
      "AllowedCharacters": "Please enter only letters, numbers, space, and ( ) [ ] - . #",
      "Commodity": "Commodity",
      "ServiceType": "Service Type",
      "Courier": "Courier",
      "DeclaredValue": "Declared Value",
      "PackageType": "Package Type",
      "PackageWeight": "Package Weight",
      "SubmitToBrinks": "Submit to Brink's",
      "NotNow": "Not now, thank you",
      "IsInformationCorrect": "Is your contact information correct?",
      "BrinksWillUseInformation": "Brink’s will use this information to contact you, so please update it if necessary.",
      "QuoteAmount": "Quote Amount",
      "FinalPricing": "Final pricing is subject to change due to any shipment detail changes and credit card fees.",
      "NoQuotes": "No quotes returned",
      "NoQuotesMessage": "We’re sorry. No quotes were returned. Please try again later.",
      "AlreadyCustomer": "I am already a Brink’s customer",
      "CustomerNumber": "Brink’s Customer Number",
      "Name": "Name",
      "Email": "Email",
      "Phone": "Phone",
      "UnsavedChanges": "Unsaved Changes",
      "YouHaveUnsavedChanges": "You have unsaved changes that will be lost if you leave this form.",
      "DoYouWantContinue": "Do you want to continue?",
      "YesContinue": "Yes, Continue",
      "NoEdit": "No, Keep Editing",
      "ThankYou": "Thank You!",
      "ReturnToDashboard": "Return to Dashboard",
      "SuccessInfo": "A representative from Brink’s will contact you the same business day, if received before 5pm ET to complete the transaction. Purchases will be handled directly with Brink’s and any final shipment information will not appear in the Zing® Marketplace. All communications on purchase, delivery, billing and payment will come from Brink’s. <br/> Refer questions to <a class=\"text-underline\" href=\"mailto:BGSUSCustomerService@brinksinc.com\">BGSUSCustomerService@brinksinc.com</a>",
      "ChooseOne": "Choose one...",
      "ShipmentDetails": "Shipment Details"
    },
    "GemAndJewelModal": {
      "Title": "Coming soon!",
      "TitleText": "Create a world-class online shopping experience",
      "InfoText": "Gem + Jewel is a one-of-kind e-comm platform that connects retailers and vendors to work together as partners, not competitors.",
      "InfoTitleRetailers": "For Retailers",
      "InfoTextRetailers": "Get a turnkey online store with access to our network of virtual vendor inventory and lab-grown diamond marketplace to expand your assortment and reach more customers.",
      "InfoTitleBrands": "For Brands",
      "InfoTextBrands": "Create a stylish, professional brand page to grow your brand exposure with both retailers and consumers. And get access to the global lab-grown diamond market to reduce supply chain costs and inefficiencies.",
      "InfoTextQuestion": "Want to know more? Click the button below and let’s discuss the next phase of your digital strategy.",
      "No": "Skip for now",
      "Yes": "Yes, I am interested",
      "Close": "Close"
    },
    "JewelerPagesModal": {
      "Title": "Build Your Online Experience",
      "TitleText": "Enhance your web presence with a stunning web page.",
      "InfoText": "An engaging web presence is important because:",
      "FirstBullet": "Shoppers start online. So, an online web presence entices customers to learn more about your products and services.",
      "SecondBullet": "Unlike brick-and-mortar stores, websites give the opportunity to present and highlight your jewelry 24/7.",
      "ThirdBullet": "It allows you to stand out from your competition. Tell your story in your own words and own the customer relationship.",
      "FourthBullet": "It extends your reach and increases retention leading to greater sales and higher customer satisfaction.",
      "ComingSoon": "Coming Soon!",
      "ComingSoonText": "We’ll be adding eCommerce functionality to make it even easier for shoppers to browse and buy.",
      "Yes": "Yes, I am interested",
      "Close": "Close"
    },
    "JmccRegisterModal": {
      "Title": "Register for JM™ Customer Connect",
      "TitleText": "Let's find the best fit for your business. Tell us a bit about yourself and one of our expert advisors will help you build a program that meets your needs.",
      "PreferredContactMethod": "Preferred Contact Method",
      "PreferredContactMethodPlaceholder": "Select Preferred Contact Method",
      "PreferredContactMethodError": "Preferred Contact is required",
      "PreferredContactMethodValues": {
        "Email": "Email",
        "Phone": "Phone"
      },
      "PosProvider": "Point of Sale (POS) provider",
      "PosProviderPlaceholder": "Select Point of Sale Provider",
      "PosProviderError": "Point of Sale (POS) provider is required",
      "PosProviderValues": {
        "TheEdge": "The Edge",
        "Jewel360": "Jewel360",
        "LogicMate": "Logic Mate",
        "Adaptive": "Adaptive",
        "Other": "Other"
      },
      "ECommerceProvider": "eCommerce Provider (e.g Shopify, Magento)",
      "ECommerceProviderPlaceholder": "Select eCommerce Provide",
      "ECommerceProviderError": "eCommerce Provider is required",
      "ECommerceProviderValues": {
        "Shopify": "Shopify",
        "Magento": "Magento",
        "Other": "Other",
        "None": "None / I don't have one"
      },
      "Website": "Website",
      "WebsitePlaceholder": "Website URL",
      "WebsiteError": "Please enter valid Website URL (100-character limit)",
      "InterestedInPrograms": "I'm Interested in Programs for:",
      "PleaseSelect": "Please select at least one",
      "InterestedInProgramsError": "Please make a selection",
      "InterestedInProgramsValues": {
        "Online": "Online (Website)",
        "InStore": "In-store"
      },
      "Cancel": "Cancel",
      "Register": "Register"
    },
    "ConsolidatedFooter": {
      "PrivacyLink": "Privacy Policy",
      "PrivacyRequestLink": "Privacy Request Form",
      "AccessibilityLink": "Accessibility",
      "AccessibilityLinkLabel": "Click to view our statement on Accessibility",
      "TermsOfUseLink": "Terms of Use",
      "JewlelersMutualCopyright": " Jewelers Mutual Group - All Rights Reserved",
      "CLViewAndPayUnderwritingCompaniesStatement": "Coverage is offered by a member insurer of the Jewelers Mutual Group, either Jewelers Mutual Insurance Company, SI (a stock insurer) or JM Specialty Insurance Company. Policyholders of both insurers are members of Jewelers Mutual Holding Company.",
      "Disclaimer": "Coverage is offered by a member insurer of Jewelers Mutual Insurance Group and is subject to underwriting review and approval, and to the actual policy terms and conditions. Any descriptions are a brief summary of coverage and are not part of any policies, nor a substitute for the actual policy language.",
      "ContactUs": "Contact Us:",
      "ContactPhone": "1-833-970-9464",
      "ContactEmail": "zingInfo@ZingJM.com",
      "ContactAddress1": "24 Jewelers Park Drive",
      "ContactAddress2": "PO Box 468",
      "ContactAddress3": "Neenah, WI 54957-046"
    },
    "MarketDataWidget": {
      "MarketInformation": "Market Information"
    },
    "PartnerContentWidget": {
      "Title": "AGS News",
      "LearnMoreLink": "Learn more >",
      "FindJewelerTitle": "Find a Jeweler"
    },
    "ZingDashboard": {
      "DashboardLink": "-Dashboard-",
      "PendingMessage": "Your application is being processed",
      "NotApprovedMessage": "You don't have access.  Please contact your Business Administrator."
    },
    "EmailConsent": {
      "Consent": "<strong>Yes, I consent to receive news, updates or promotions from Jewelers Mutual Group.</strong> I understand that I can unsubscribe at any time. Please refer to our",
      "PrivacyPolicy": "Privacy Policy",
      "Details": "for more details."
    },
    "ParticipantAgreementConsent": {
      "Consent": "<strong> By checking this box, you are accepting the terms and conditions of the</strong> ",
      "ParticipantAgreement": "Participant Agreement.",
      "ParticipantAgreementLink": "/legal/participant-agreement"
    },
    "Register": {
      "PromotionalMessage": "New users who register between March 1 and March 17 will be entered for a chance to win a $100 Amazon gift card!",
      "ViewFullDetails": "View the full details here.",
      "RegisterToZing": "Register for the Zing<sup>®</sup> Marketplace",
      "Message": "Welcome! Thank you for choosing to register with <i>Zing</i>. Please complete your details below.",
      "IdentifyCountry": "To help us identify your company please start by entering the country.",
      "CompanyDoesntHave": "My company doesn't have the",
      "NextStep": "Next Step",
      "Province": "Province",
      "ZipCode": "Zip Code",
      "PostalCode": "Postal Code",
      "NoShippingBannerMessage": "Shipping services are only available in the United States",
      "CompanyNotFound": {
        "Header": "Company not found",
        "Body": "We were not able to find a company match.<br><br>Choose <b>Try Again</b> to modify the information you provided.<br><br>Choose <b>Enter Manually</b> to enter your company's information manually.",
        "ButtonText": "Enter Manually",
        "LinkText": "Try Again"
      },
      "UserEmailRegisteredModal": {
        "Header": "Email Already In Use",
        "Body": "The email, <span class='roboto-bold'>{{email}},</span> is associated with a registered user. Please select log in or continue by entering a different email.",
        "ButtonText": "Go to Login",
        "LinkText": "Enter Another Email"
      },
      "UserEmailInvitedModal": {
        "Header": "Pending Invite Exists",
        "Body": "The email, <span class='roboto-bold'>{{email}},</span> you entered was previously sent an invitation to the Zing&reg; Marketplace. Please use previously sent invite to your email address or contact the Customer Helpline at <a class='helpdesk-phone' href='tel:{{helpDeskPhoneNumber}}'>{{helpDeskPhoneNumber}}</a>.",
        "ButtonText": "OK"
      },
      "CLRegistrationModal": {
        "Header": "Complete Your Registration",
        "Body": "<span class='heading-20-bold-zing-blue'>You're almost done!</span><br><br>Check your email inbox to complete your registration and log in.",
        "ButtonText": "OK"
      },
      "SimilarCompanies": {
        "Header": "Similar Companies Found",
        "SingleCompanyHeader": "Search Result Found",
        "Body": "We located existing accounts that resemble the information you provided. Please select the account that applies to your company. If these do not apply, then please contact us at <strong>1-833-970-9464</strong>.",
        "LimitReachedMessage": "We located more than 25 results from the information you provided. If your company is not listed, please refine your search and try again.",
        "CompanyName": "Legal Company Name",
        "Address": "Address",
        "Location": "Location",
        "PostalCode": "Postal code",
        "Phone": "Phone"
      }
    },
    "HighRiskLocationWarning": "Use of this non-owned carrier location comes with an increased chance for loss. If a value was declared, insurance coverage concludes upon carrier delivery to such location, rather than upon pickup by your recipient.",
    "HighRiskLocationChoice": "If you would like to proceed with knowledge of the risk, choose Continue below. Choose Cancel if you'd like to go back and modify the destination address.",
    "Presets": "Presets",
    "DefaultPreset": "Default preset",
    "FedExOnly": "FedEx Only",
    "FedExOnlyUseOneRate": "Use FedEx One Rate<sup>®</sup>",
    "FedExOnlyOneRateInfo": "Quotes and purchases are reflective of your FedEx account rates. FedEx will invoice you for freight costs. Insurance, if requested from this platform, will be billed by us.",
    "PersonalInformation": "Personal Information",
    "BusinessInformation": "Business Information",
    "EditInformation": "Edit Information",
    "SelectYourOption": "Select your option",
    "Accepted": "Accepted",
    "Rejected": "Rejected",
    "NotAccepted": "Not Accepted",
    "TermsAndConditions": "Terms and Conditions",
    "View": "View",
    "IUnderstand": "I understand",
    "AcceptedTermsAgreementPrepend": "View the accepted",
    "TermsAgreementPrepend": "You must accept the",
    "TermsAgreementAppend": " before you can buy",
    "Select": "Select",
    "SelectState": "Select State",
    "SelectStateOrProvince": "Select State/Province",
    "EnterState": "Enter State",
    "Carriers": "Carriers",
    "ServiceClass": "Service Class",
    "FirstName": "First Name",
    "LastName": "Last Name",
    "MiddleName": "Middle Name",
    "Contact": "Contact",
    "EnterContact": "Enter Contact",
    "EmailContent": "Email Content",
    "ContactDetails": "Contact Details",
    "EmailAddress": "Email Address",
    "EmailAddresses": "Email Addresses",
    "EmailInstructions": "To add more than one email please separate them using a semi colon.",
    "RequestReturnEligibilityMessage": "We will contact you as soon as possible whether this diamond is eligible to be returned.  Send the request?",
    "Email": "Email",
    "Address": "Address",
    "AddressDetails": "Address Details",
    "ClearAddressDetails": "Clear address details",
    "SearchAddress": "Search Address",
    "Country": "Country",
    "SelectCountry": "Select Country",
    "City": "City",
    "State": "State",
    "StateProvince": "State/Province",
    "ZipCode": "Zipcode",
    "PostalCode": "Postal Code",
    "AddressLineOne": "Address Line 1",
    "AddressLineTwo": "Address Line 2",
    "PhoneNumber": "Phone Number",
    "Phone": "Phone",
    "MobileNumber": "Mobile Number",
    "OtherPhoneNumber": "Other Phone",
    "CompanyPhoneNumber": "Company Phone Number",
    "FeinId": "FEIN Id",
    "Company": "Company",
    "LegalCompanyName": "Legal Company Name",
    "CompanyName": "Company Name",
    "ContactName": "Contact Name",
    "CompanyOwner": "I am fully authorized by the above company to register and administer this account.",
    "CurrentPassword": "Current Password",
    "ChangePassword": "Change Password",
    "TermUse": "Terms of Use",
    "PlatformTermUse": "Zing Marketplace Terms of Use",
    "PlatformParticipantAgreement": "Zing Marketplace Participant Agreement",
    "PrintAndDownloadAsPDF": "Print and Download as PDF",
    "ShippingTermUse": "Shipping Terms & Conditions",
    "PrivacySecurity": "Privacy & Security",
    "NewPassword": "New Password",
    "ConfirmPassword": "Confirm Password",
    "PasswordStrength": "Password Strength",
    "SelectQuestion": "Select Question",
    "AssignLocation": "Assign Location",
    "AssignRole": "Assign Role",
    "RemoveUnverifiedPhone": "Are you sure you want to remove unverified phone number?",
    "RemoveUnverifiedEmail": "Are you sure you want to remove unverified email address?",
    "VoidShipmentTitle": "Void Shipment",
    "VoidShipment": "Are you sure you want to void this shipment?",
    "DeleteShipmentTitle": "Delete Shipment",
    "DeleteShipment": "Are you sure you want to delete this shipment?",
    "OnOccurrence": "On Occurrence",
    "Daily": "Daily",
    "Never": "Never",
    "Weekly": "Weekly",
    "EveryShipment": "Every Shipment",
    "SearchForPresets": "Search for presets",
    "ShipmentTrackingId": "Carrier Tracking Number",
    "CarrierTrackingNumber": "Carrier Tracking #",
    "ShipmentTrackingNumber": "Tracking Number",
    "ShipmentRecipient": "Recipient",
    "ShipmentOrigin": "Origin",
    "ShipmentOriginLocation": "Origin Location",
    "ShipmentInsurance": "Insurance",
    "Pricing": "Pricing",
    "ViewDetails": "View Details",
    "WebStoreSource": "Source",
    "ReconciliationsApplyLabel": "Reconciliations apply",
    "ShipmentDestination": "Destination",
    "RecipientTypeQuestion": "Who is this going to?",
    "RecipientTypeBusiness": "A business",
    "RecipientTypeIndividual": "An individual",
    "ShipmentDestinationLocation": "Destination Location",
    "ShipmentSender": "Sender",
    "ShipmentCarrier": "Carrier",
    "ShipmentCourier": "Courier",
    "ShipmentDispatch": "Dispatched",
    "ShipmentStatus": "Shipment Status",
    "ShipmentNotes": "Notes",
    "ShipmentEstimatedArrival": "Estimated Arrival",
    "ShipmentActivity": "Activity",
    "ShipmentService": "Service",
    "ShipmentPackaging": "Packaging",
    "ShipmentInsuranceValue": "Insurance Value",
    "ShipmentAccount": "Account",
    "ShipmentDetails": "Shipment Details",
    "SaveAsPDF": "Save as PDF",
    "ShipmentClient": "Client",
    "ShipmentTo": "To",
    "ShipmentFrom": "From",
    "Origin": "Origin",
    "Destination": "Destination",
    "ShipmentSignature": "Signature",
    "ReferenceOne": "Reference 1",
    "ReferenceTwo": "Reference 2",
    "InfoNotAvailable": "Information available upon purchase",
    "TotalPrice": "Total Price",
    "IncludedDutiesTaxes": "Incl. Duties & Taxes",
    "InvoiceId": "Invoice ID",
    "ShippingDate": "Ship Date",
    "ReturnDate": "Return Date",
    "ShipmentAcceptanceScan": "Acceptance Scan",
    "Weight": "Weight",
    "WeightPounds": "Pounds (Lbs)",
    "Pounds": "lbs",
    "WeightOunces": "Ounces (Oz)",
    "Ounces": "oz",
    "WeightUnit": "Weight Unit",
    "DimensionUnitImperial": "in",
    "DimensionSizeLength": "Size - Length",
    "DimensionLength": "Length",
    "DimensionWidth": "Width",
    "DimensionHeight": "Height",
    "ResidentialAddress": "Residential Address",
    "None": "None",
    "Confirmation": "Confirmation",
    "NoConfirmation": "None",
    "DeliveryConfirmation": "Delivery Confirmation",
    "SignatureType": "Signature Type",
    "SignatureConfirmation": "Signature Confirmation",
    "AdultSignature": "Adult Signature",
    "Restricted": "Restricted",
    "AdultRestricted": "Adult Restricted",
    "NoAddressContacts": "No records found.",
    "SaveToAddressBook": "Save to Address Book",
    "DeliverySpeed": "Select a Delivery Speed",
    "Residential": "Residential",
    "ResidentialCheckboxLabel": "This is a residential address",
    "SuggestedAddressTitle": "Standardized Address Found",
    "SuggestedAddressInfo": "The address you entered is valid, however a standardized version was found and is recommended to ensure accuracy of delivery.",
    "SuggestedAddress": "Standardized Address",
    "Recommended": "Recommended",
    "EnteredAddress": "Entered Address",
    "FriendlyName": "Add a friendly name",
    "IncludePackageSignature": "Include a signature to your package",
    "ApprovalCode": "I have an approval code from the logistics company",
    "USPSOnly": "USPS Only",
    "RegisteredMail": "Registered Mail",
    "RegisteredMailWithTrademark": "Registered Mail&trade;",
    "USPSRegisteredMailWithTrademark": "USPS Registered Mail&trade;",
    "USPSRegisteredMail": "USPS: Registered Mail&trade;",
    "USPSPriorityMailNextDay": "USPS Priority Mail Express (Next Day) can take 1-3 days",
    "ExpectedDelivery": "Expected Delivery",
    "InsuranceDeclaredValue": "Value Declared for Insurance",
    "BlockUsedValue": "Block",
    "AdditionalInsuranceValue": "Additional",
    "GetItToday": "Get it today!",
    "GetItTommorow": "Tomorrow",
    "GetItOn": "Get it on",
    "Unavailable": "Unavailable",
    "NoCommitment": "No commitment",
    "DeliveryConfirmationOptions": "Delivery Confirmation Options",
    "InviteAnotherUser": "Invite Another User",
    "BackToTeams": "Back To Teams",
    "CargoType": "Cargo Type",
    "SelectCarriers": "Select Carriers",
    "SelectService": "Select Service",
    "SelectPackaging": "Select Packaging",
    "PackagingDetails": "Packaging Details",
    "PackageWeight": "Package Weight",
    "TariffCode": "Tariff Code",
    "SenderReference": "Reference 1",
    "ReceiverReference": "Reference 2",
    "ReferenceOnLabel": "Include on the Label",
    "SealNumber": "Seal # from Security Packaging",
    "SecurityBagSealNum": "Security Bag Seal #",
    "SecondSecurityBagSealNum": "Second Security Bag Seal #",
    "EnterSealNumber": "Enter Seal Number",
    "EnterCodeSeal": "Enter Code / Seal",
    "ApprovalCodeOrSecondarySeal": "Approval Code / Secondary Seal",
    "UseDefaultAddress": "Use default address",
    "GoToShippingDashboard": "Go to shipping dashboard",
    "Payment": "Payment",
    "ShipmentCostMessage": "The cost of this shipment will be applied to your default payment method.",
    "InsuranceOnlyCostMessage": "The cost of this transaction will be applied to your default payment method.",
    "CreateNewIOShipment": "Create a New Insurance Only Shipment",
    "YourShipmentId": "Your Shipment ID:",
    "TrackingID": "Carrier Tracking Number:",
    "ClaimBannerText": "This form is used for loss, damage or theft of a package shipped under <i>JM</i> Shipping Solution. If you need any other help, please contact us at <a href=\"mailto:shipping@jminsure.com\"><u>shipping@jminsure.com</u></a> or 855-474-4756.",
    "AuctionTaxBannerTitle": "Update your tax exemption information",
    "AuctionTaxBannerMessage": "Your tax exemption certificate has expired or is about to expire. Please update your tax exemption information to shop tax-free on the Diamond Marketplace and JM® Auction.",
    "SearchByTrackingID": "Tracking ID",
    "ShareLabel": " Share this Label",
    "NewShipment": "Create New Shipment",
    "DocumentsAndOtherActions": "Documents and Other Actions",
    "DocumentsAndSettings": "Documents & Settings",
    "USPSFirmBook": "USPS FIRM Book",
    "SchedulePickup": "Schedule a Pickup",
    "USPSPickup": "Schedule USPS Pickup",
    "DocumentsAndForms": "Documents and Forms",
    "OtherActions": "Other Actions",
    "SupplyOrder": "Supply Order",
    "AdditionalSupplies": "Additional Supplies",
    "OrderSupplies": "Order Supplies",
    "Integrations": "Integrations",
    "EditShipment": "Edit Shipment",
    "BoomerangShipment": "Boomerang Shipment",
    "ShipmentName": "Shipment Name",
    "OriginalShipmentId": "Original Shipment ID",
    "TrackingInfo": "Tracking Info",
    "SendersReference": "Sender’s Reference",
    "ReceiversReference": "Receiver’s Reference",
    "EmailLabelPrintingInstructions": "Email Label Printing Instructions",
    "ClickToGenerateLabel": "Click to Generate Label",
    "DescribeWhatWasInThePackage": "Describe what was in the package",
    "WhatWasInThePackage": "What was in the package?",
    "ClaimValue": "Value of Claim",
    "CarrierValue": "Value Declared to Carrier",
    "CarrierLiability": "Carrier Liability",
    "InvoiceValue": "Value on Invoice to Recipient",
    "InvoiceValueCustomsRequirement": "Invoice Value (Customs Requirement)",
    "CustomsValue": "Value Declared to Customs",
    "ReplacementValue": "Replacement Value",
    "TransGuardianValue": "Value Declared",
    "CarrerClaimVaule": "Carrier Cargo Claim Number",
    "PackagerNumber": "Number of Packages",
    "OuterPackageDamage": "Outer Package Damage",
    "OuterPackageDetails": "Outer Package Details",
    "InnerPackageDamage": "Inner Package Damage",
    "InnerPackagingDamage": "Inner Packaging Damage",
    "InnerPackageDescription": "Describe Inner Packaging",
    "PoliceReportLabel": "Police Report Number, City, State",
    "PoliceReportInformation": "Please enter police report information here",
    "ExtentOfTheLoss": "What is the extent of the loss or damage you're reporting?",
    "LossOrTheftOfRolexOrGia": "Does this claim include loss or theft of a Rolex or GIA product?",
    "150MaxCharacters": "150 characters maximum",
    "150Characters": "150 character limit",
    "1000Characters": "1000 character limit",
    "Comments": "Comments",
    "ReasonForClaim": "Reason for claim",
    "ReasonForClaimRequired": "Reason for claim is required",
    "StateWhatHappened": "Please state what happened here",
    "CircumstancesOfTheLoss": "Describe the circumstances of the loss you're reporting",
    "CircumstancesAreRequired": "Circumstances of the loss you are reporting is required",
    "JMShippingContactMessagePart1": "This form is used for loss, damage or theft of a package shipped under JM Shipping Solution. If you need any other help, please contact us at",
    "JMShippingMailTo": "<a class=\"text-underline\" href=\"mailto:shipping@jminsure.com\">shipping@jminsure.com</a>",
    "JMShippingContactMessagePart2": "or 855-474-4756.",
    "Loss": "Loss",
    "Damage": "Damage",
    "CompleteContentsLost": "Complete: All contents are lost or damaged.",
    "PartialContentsLost": "Partial: Only some of the contents are lost or damaged.",
    "PresetName": "Preset Name",
    "MarkPresetFavorite": "Set as a Favorite Preset",
    "EnterTrackingId": " Begin filling your claim by entering a tracking ID below",
    "ClaimantInformation": "Claimant Information",
    "Zero": "Zero",
    "PackageInformation": "Package Travel Information",
    "ClaimDetails": "Shipment Claim details",
    "ShipmentId": "Shipment ID",
    "ShipmentIdColon": "Shipment ID:",
    "PurchasedOn": "Shipping Date",
    "ReconciledOn": "Reconciliation Date",
    "ReconAmount": "Recon Amount",
    "ClaimId": "Claim ID",
    "ClaimDueDate": "Claims Due Date",
    "ClaimPaymentId": "Claim Payment Shipment ID",
    "SubmissionDate": "Submission Date",
    "ClaimsStatus": "Claims Status",
    "Postage": "Postage",
    "YourClientId": "Your Client ID",
    "ClaimTrackingNumber": "Claim Payment Tracking Number",
    "AdditionalComments": "Additional Comments",
    "ShipFrom": "Ship From",
    "ShipTo": "Ship To",
    "YourClaimId": "Your Claim ID",
    "SupportingDocumentation": "Supporting Documentation",
    "ClaimWarning1": "Upon submitting you will not be able to return to edit the above information.",
    "ClaimWarning2": "Please review the information carefully before submitting.",
    "ClaimSubmitted": "Claim submitted successfully. Your <i>JM</i> Shipping Solution Reference ID is {{claimNumber}}.",
    "ClaimSubmitThanks": "Thank you for submitting your Claim Details.",
    "ClaimSuccessInfo": "We will be processing the information and will get back to you at the earliest. If you have made any mistakes while entering the claims details, please inform us via email as you will not be able to modify the data once entered due to security purposes.",
    "ClaimSupportingDocumentation": "Supporting Documentation for your Claim",
    "ClaimSupportingDocumentationDescription": "Please attach documentation to support the loss and value of your claim. If you will be submitting documentation later, please send it with your claim number (which will be provided upon clicking submit) to shippingclaims@jminsure.com.",
    "ClaimValueDocumentation": "Value documentation (invoice, memo, receipt, etc.).",
    "ClaimPhotos": "Photos of packaging and contents that are damaged, lost, or missing. For lost or missing items, please provide photos of the original contents.",
    "ClaimPoliceReport": "Police report, if applicable (required if a crime was committed and for loss of Rolex or GIA products).",
    "GoToDashboard": "Go to dashboard",
    "DocumentReminderPopUpHeader": "Did you attach all supporting documents?",
    "DocumentReminderPopUpBody": "To expedite your claim, please make sure you've uploaded all relevant supporting documentation including photos.",
    "DocumentReminderGoBack": "No, go back",
    "DocumentReminderYes": "Yes, submit claim",
    "TotalAmount": "Total Amount Billed",
    "PaidAmount": "Paid Amount",
    "BalanceAmount": "Balance Amount",
    "RequestReview": "Request Review",
    "PaymentDetails": "Payment Details",
    "Transactions": "Transaction",
    "CommunicationPreferencesGeneral": "General Communication",
    "CommunicationPreferencesBilling": "Billing",
    "CommunicationPreferencesCarePlan": "Care Plan",
    "CommunicationPreferencesShipping": "Shipping",
    "CommunicationPreferencesMarketplace": "Marketplace",
    "EmailNotifications": "Email Notifications",
    "TextNotifications": "Text Notifications",
    "TrackingUpdates": "Tracking Updates",
    "ExceptionsUpdates": "Exceptions Updates",
    "CopyToOtherEmailAddresses": "Copy to other Email Addresses",
    "AccountInformation": "Account Information",
    "InvoiceRaised": "Invoice Raised",
    "PaymentChanged": "Payment Changed",
    "PaymentExceptions": "Payment Exceptions",
    "CarePlanNotifications": "Care Plan Notifications (Except Upload of Sales File)",
    "AdditionalCompanyInfo": "New Customer Questionnaire",
    "AdditionalCompanyInfoBodyTitle": "Please answer the following questions to obtain your first quote:",
    "CurrentShipmentProviders": "How do you currently ship?(Check all that apply)",
    "AverageShipments": "What is your average number of shipments per week?",
    "CLPolicyHolder": "Is your business insured with Jewelers Mutual?",
    "JMpolicyNumber": "Jewelers Mutual Policy Number",
    "PolicyNumber": "Policy Number",
    "PolicyNumberContent": "You did not enter your policy number, which will delay your account activation. Please go back to enter your policy number or continue without it.",
    "GoBack": "Go Back",
    "ContinueWithoutPolicyNumber": "Continue without policy number",
    "AGSMember": "Are you an AGS member?",
    "GroundOrFirstClass": "Ground/1st Class",
    "ShippingInsurance": "Shipping Insurance",
    "JMBlockPolicy": "Jewelers Mutual Block Policy",
    "SmallParcelInsurance": "Small Parcel Insurance",
    "Included": "Included",
    "SecurityLogin": "Security & Login",
    "PlatformPreferences": "Zing Marketplace Preferences",
    "DeclaredValue": "Declared Value",
    "FilterBy": "Filter by",
    "SortBy": "Sort by",
    "ReQuote": "Re-quote",
    "EstimatedCost": "Estimated Cost",
    "NoQuotes": "No quotes",
    "Optional": "(optional)",
    "ProfileSetupComplete": "Profile setup is complete. To begin shipping, select the Start button",
    "TrackShipment": "Track a Shipment",
    "TrackShipmentPlaceholder": "Enter Tracking #",
    "Minimum5Characters": "Minimum last 5 characters",
    "StartDate": "Start Date",
    "EndDate": "End Date",
    "Apply": "Apply",
    "Cancel": "Cancel",
    "More": "More",
    "ClearDates": "Clear Dates",
    "Dot": ".",
    "CustomizeColumnsModal": {
      "ColumnVisible": "Column visible in the table",
      "DragToReorder": "Drag to reorder",
      "IsFilterable": "Filterable in Shipment Summary table",
      "ColumnLocked": "Column can not be moved"
    },
    "ChangeCountryModal": {
      "Header": "Country Change",
      "BodyText": "By changing the country, you will lose the Shipment Details you have entered.<br><br>Are you sure you want to change the country?"
    },
    "ListOfEUCountriesModal": {
      "ListOfEUCountries": "List of EU Countries"
    },
    "UnsavedChangesModal": {
      "Header": "Unsaved Changes ",
      "BodyText": "You have unsaved changes that will be lost if you leave this page.<br><br>Would you like to leave this page?"
    },
    "InternationalImportantNotice": {
      "Header": "Important Notice",
      "DutiesTaxes": "Duties and Taxes",
      "DutiesTaxesText1": "Duties/Taxes are due from your recipient upon delivery. Please be sure your recipient is willing to pay this additional amount, which can be substantial.",
      "DutiesTaxesText2": "Shipment price does not include duties/taxes.",
      "DutiesTaxesText3": "For duty/tax amounts or other information, please contact the carrier.",
      "DutiesTaxesText4": "There is no insurance coverage for losses related to confiscation due to unpaid duties/taxes.",
      "CustomsDocuments": "Customs Documents",
      "CustomsDocumentsText1": "You are responsible for knowing which customs documents apply to your shipment.",
      "CustomsDocumentsText2": "Failure to accurately complete and include required documents can result in delays, returns (including fees) at your expense, or confiscation at your expense."
    },
    "ExternalBoomerang": {
      "GetReturnLabel": "Boomerang: Get your Return Label",
      "EnterIDLabel": "Enter the Shipment ID provided to continue with the request",
      "VerifyID": "Verify Shipment ID",
      "EnterShipmentID": "Enter Shipment ID",
      "DestinationAddress": "Destination Address",
      "OriginAddress": "Origin Address",
      "SelectedCarrier": "Selected Carrier",
      "ReturnLabel": "Return Label",
      "FieldsUpdate": "The following fields can be updated, if necessary.",
      "PackagingDetails": "Packaging Details",
      "PackageWeight": "Package Weight",
      "CreateLabel": "Create Label",
      "VerifyAddresses": "Please verify the origin & destination addresses, carriers, weight, and packaging, then select",
      "JoinToday": "Join today to enhance your business",
      "RegisterNow": "Register Now",
      "LabelGenerated": "Label generated!"
    },
    "GenerateReturnLabel": "Generate Return Label",
    "SelectOptions": "Please select from the following options to proceed.",
    "EmailPrintingInstructionsToRecipient": "1. Email Label Printing Instructions to Shipment Recipient",
    "PurchaseReturnLabel": "2. Purchase Return Label Now",
    "BuyReturnLabel": "Buy return label",
    "PrintInstructions": "Print instructions",
    "ShareDetails": "Share",
    "ShareWithEmails": "Email Shipment Details",
    "Shipping": {
      "CreatedBy": "Created By"
    },
    "ShipmentSummary": {
      "CreateEndOfDayReport": "Create End of Day Report",
      "DeclaredValue": "Declared Value",
      "InsuredValue": "Insured Value",
      "ShipmentCreated": "Transaction Date",
      "CreatedDate": "Created Date",
      "UserFullName": "Created By",
      "ZingTrackingNumber": "Shipment ID",
      "ShipToCompany": "Ship to Company",
      "Destination": "Destination",
      "CarrierTrackingId": "Carrier Tracking #",
      "Carrier": "Carrier",
      "Service": "Service",
      "CarrierService": "Carrier - Service",
      "Status": "Status",
      "Value": "Value",
      "ClientId": "Client ID",
      "AccountName": "Account Name",
      "Zone": "Zone",
      "DeliveryDate": "Delivery Date",
      "Signature": "Signature",
      "Packaging": "Packaging",
      "Dimensions": "Dimensions",
      "ShipmentName": "Shipment Name",
      "ShipmentService": "Shipment Service",
      "ECommOrders": "Source",
      "ShipVia": "Ship Via",
      "TotalDeclaredCost": "Total Declared Cost",
      "FreightAccountCharge": "Freight Account Charge",
      "Weight": "Weight",
      "ShipmentCost": "Shipment Cost",
      "SendersReference": "Reference 1",
      "ShipFromCompany": "Ship from Company",
      "ShipFromContact": "Ship from Contact",
      "OriginCityAndState": "Origin",
      "ShipFromAddress": "Ship from Address",
      "ShipFromZipCode": "Ship from Zip Code",
      "ShipFromCountry": "Ship from Country",
      "ReceiversReference": "Reference 2",
      "Residential": "Residential",
      "ShipToContact": "Ship to Contact",
      "ShipToAddress": "Ship to Address",
      "ShipToZipCode": "Ship to Zip Code",
      "ShipToCountry": "Ship to Country",
      "View": "View",
      "Delete": "Delete",
      "Track": "Track",
      "Void": "Void",
      "VoidedOn": "Voided On",
      "BillingDetails": "Billing Details",
      "SizeLength": "Size - Length (in)",
      "Length": "Length (in)",
      "Width": "Width (in)",
      "Height": "Height (in)",
      "BuyShipment": "Buy",
      "Actions": "Actions",
      "CustomizeColumns": "Customize Columns",
      "CustomizeColumnsProcessedShipments": "Customize Columns - Processed Shipments",
      "CustomizeColumnsSavedShipments": "Customize Columns - Saved Shipments",
      "ExportToExcel": "Export to Excel",
      "ActiveFilters": "Active Filters",
      "NoActiveFilter": "No Active Filter",
      "ClearFilters": "Clear Filters",
      "Clear": "Clear",
      "ScanBasedBilling": "Scan-Based Billing",
      "ShipFromCity": "Ship From City",
      "ShipFromState": "Ship From State",
      "ShipToCity": "Ship To City",
      "ShipToState": "Ship To State",
      "CarrierShipDate": "Carrier Ship Date",
      "CarrierDeliveryDate": "Carrier Delivery Date",
      "Edit": "Edit",
      "ClaimReportingPeriod": "Coverage Option",
      "BatchId": "Batch ID",
      "ClaimFiled": "Claim Filed",
      "ClaimNumber": "Claim Number",
      "ReferenceId": "Reference ID",
      "Claimant": "Claimant",
      "DateFiled": "Date Filed",
      "CarrierTracking": "Carrier Tracking",
      "CoverageOption": "Coverage Option"
    },
    "BusinessName": "Business Name (DBA)",
    "MailingAddress": "Mailing Address",
    "Autopay": "Autopay",
    "EnrolledAccount": "This account is enrolled in autopay",
    "NotEnrolledAccount": "This account is not enrolled in autopay",
    "PaymentPlan": "Payment Plan:",
    "ContactAgencyTitle": "Contact Agency",
    "ContactAgencyText": "For Questions, Concerns, or To File a Claim",
    "AgencyName": "Agency Name",
    "AgencyContact": "Agency Contact #",
    "ClaimsAdjuster": "Claims Adjuster",
    "ClaimsExaminer": "Claims Examiner",
    "ClaimNo": "Claim No.",
    "AmountPaid": "Amount Paid",
    "DateOfLoss": "Date of Loss",
    "Description": "Description",
    "Status": "Status",
    "CurrentAmountDue": "Current Amount Due",
    "DueBy": "Due By:",
    "MakePayment": "Make Payment",
    "PastDueAmount": "Past Due Amount",
    "CurrentBilledAmount": "Current Billed Amount",
    "PolicyAlreadyLinked": "Policy is already linked.",
    "MissingAccountNumber": "Missing Account Number / Policy Number.",
    "LinkYourPolicy": "Link your Policy/Account",
    "EnterTheInformation": "Enter the information below to link your Jewelers Mutual account.",
    "AccountNumberPolicyNumber": "Account Number / Policy Number",
    "LinkAccount": "Link Account",
    "NeedHelp": "Need help? Call us at",
    "DatePaid": "date paid:",
    "PastDuePending": "Past Due - Pending",
    "DueImmediately": "Due Immediately",
    "Active": "Active",
    "Inactive": "Inactive",
    "Penidng": "Pending",
    "Policy": "Policy #",
    "EffectiveDate": "Effective Date",
    "EffectiveDates": "Effective Dates",
    "ExpirationDate": "Expiration Date",
    "PolicyType": "Policy Type",
    "TermPremium": "Term Premium",
    "FullAmountDue": "Full Amount Due",
    "Locations": "Locations",
    "Billed": "Billed",
    "Unbilled": "Unbilled",
    "PastDue": "Past Due",
    "Account": "Account #",
    "AddAccount": "Add Account",
    "ViewingAccount": "Viewing Account:",
    "SelectAccount": "Please select an account to view your policy(s)",
    "Limit": "Limit",
    "Deductible": "Deductible",
    "Coverage": "Coverage",
    "Date": "Date",
    "Type": "Type",
    "Amount": "Amount",
    "UpcomingPayment": "Upcoming Payment",
    "UpcomingPaymentDisclaimer": "Amount may not include installment fees or late fees",
    "FutureDueDates": "Future Due Dates",
    "PaymentActivity": "Payment Activity",
    "Pending": "Pending",
    "TransactionHistory": "Transaction History",
    "ShippingInsurancesList": "This may not be a complete list. Custom coverages may not be displayed.",
    "ViewLastYear": "Viewing: <span>last {{years}} years</span>",
    "ViewPastYear": "Viewing: <span>past {{years}} year</span>",
    "MaximumResultsDisplayed": "Maximum of 50 results will be displayed",
    "SelectReason": "Select Reason",
    "Billing": {
      "NameOnCard": "Name on Card",
      "NickName": "Nick Name",
      "CardNumber": "Card Number",
      "ExpirationDate": "Expiration Date",
      "ExpiryDate": "Expiry Date",
      "CVVNumber": "CVV Number",
      "MethodUsagesTitle": "What can this payment method be used for?",
      "CardUsage": "Card Usage",
      "PlatformModules": "Zing Marketplace Modules",
      "CardUsageType": "Select card usage type",
      "PaymentMethodUsageType": "Select payment method usage type",
      "CardHolder": "CARD HOLDER",
      "Expires": "EXPIRES",
      "Edit": "Edit",
      "Create": "Create",
      "Card": "Card",
      "CreditCard": "Credit Card",
      "PaymentMethod": "Payment Method",
      "PaymentMethods": "Payment Methods",
      "SelectedPaymentMethod": "Selected Payment Method",
      "SelectPaymentMethod": "Select payment method:",
      "BankAccount": "Bank Account",
      "Ach": "ACH",
      "PayPal": "PayPal",
      "NicknameInfo": "Nickname",
      "AddressInfo": "Address",
      "EndingIn": "ending in",
      "Usage": "Usage",
      "DefaultMethod": "Default Method",
      "NoDefaultMethod": "No Default Method",
      "ChangeDefault": "Change Default",
      "SelectDefault": "Select Default",
      "Active": "Active",
      "NoCreditCardAdded": "No Credit Card Added",
      "Change": "Change",
      "AddCreditCard": "Add Credit Card",
      "YourSavedCards": "Your Saved Cards",
      "OtherMethods": "Other Methods",
      "AddNew": "Add New",
      "NoCardDetailsSet": "No Card Details Set",
      "EnterPaymentMethod": "Please add a payment method to continue",
      "AddPaymentMethod": "Add Payment Method",
      "PleaseEnterDetails": "Please enter your credit card details, which will remain on file for future purchases. A $1.00 charge will be temporarily applied to your card as we secure preauthorization from your credit card company for potential future payments. This charge will be reversed within 2-5 days. Our shipping solution has no fees beyond the cost of label purchase.",
      "ForAnyAssistance": "For any assistance, please call our Customer Helpline at 1-833-970-9464.",
      "Save": "Save",
      "Cancel": "Cancel",
      "CreditCardInformation": "Credit Card Information",
      "BillingInformation": "Billing Information",
      "ThereWasAProblem": "There was a problem saving your credit card information. Try again or call our helpline at 1-833-970-9464 for assistance.",
      "PaymentMethodDetails": "Payment Method Details",
      "YouMayNowClose": "You may now close this modal to return to your shipment Quotes where this payment method will be used to make your purchase.",
      "Close": "Close",
      "PaymentMethodRequiredModalTitle": "Payment Method Required",
      "PaymentMethodRequiredModalBody": "We are unable to complete your transaction as there is no payment method on file for your company's JM<sup>®</sup> Shipping Solution account. Please ask the Business Administrator for your company in the Zing® Marketplace to log into their account profile and add payment method details to proceed.",
      "OK": "OK",
      "PaymentMethodShipping": "Payment Method - Shipping",
      "ThereIsNoCC": "There is no credit card on file",
      "Add": "Add"
    },
    "PaymentDetailsGrid": {
      "TransactionDate": "Transaction Date",
      "TransaactionTime": "Transaction Time",
      "ID": "ID",
      "CardNumber": "Card #",
      "ChargedAmount": "Charged Amount",
      "Amount": "Amount"
    },
    "TransactionsDetailsGrid": {
      "TransactionDate": "Transaction Date",
      "ID": "ID",
      "Source": "Source",
      "Details": "Details",
      "Amount": "Amount",
      "PaymentMethod": "Payment Method"
    },
    "TransactionsSummaryGrid": {
      "InvoiceNumber": "Invoice Number",
      "TransactionID": "Transaction ID",
      "Date": "Date",
      "Type": "Type",
      "Details": "Details",
      "Status": "Status",
      "Amount": "Amount"
    },
    "PaymentsSummaryGrid": {
      "TransactionDate": "Transaction Date",
      "ID": "ID",
      "CardNumber": "Card #",
      "Details": "Details",
      "Status": "Status",
      "Amount": "Amount",
      "Invoice": "Invoice:"
    },
    "InvoicesSummaryGrid": {
      "InvoiceNo": "Invoice No",
      "InvoiceDate": "Invoice Date",
      "InvoiceAmount": "Invoice Amount",
      "Balance": "Balance",
      "Type": "Type",
      "Status": "Status",
      "Empty": "_",
      "PaymentMethod": "Payment Method"
    },
    "InvoiceInfo": {
      "InvoiceNumber": "Invoice#",
      "TotalTransactions": "Total Transactions",
      "BillingDate": "Billing Date",
      "BillTo": "Bill To",
      "InvoicePeriod": "Invoice Period",
      "TotalAmountBIlled": "Total Amount Billed",
      "PaidAmount": "Paid Amount",
      "BalanceAmount": "Balance Amount",
      "RequestReview": "Request Review"
    },
    "ShippingBilling": {
      "PaidStatements": "Paid Statements",
      "PendingCharges": "Pending Charges",
      "Reconciliations": "Reconciliations",
      "PaidStatementsInfo": "Expand a statement to view transactions",
      "StatementNumber": "Statement Number",
      "StatementDate": "Statement Date",
      "TransactionsNumber": "Number of Transactions",
      "StatementAmount": "Statement Amount",
      "ShipmentId": "Shipment ID",
      "ClientId": "Client ID",
      "Type": "Type",
      "TransactionDate": "Transaction Date",
      "Recipient": "Recipient",
      "Service": "Service",
      "TrackingNumber": "Tracking Number",
      "Amount": "Amount",
      "Statement": "Statement",
      "Date": "Date",
      "ExportToExcel": "Export to Excel",
      "SaveAsPdf": "Save as PDF",
      "Search": "Search Statements",
      "SearchInfo": "Enter Tracking Number",
      "NoRecords": "No records found within selected date range.",
      "TotalOutstandingCharges": "Total Outstanding Charges",
      "PaymentInfo": "Payment Info"
    },
    "AML": {
      "WhatIsJewelPac": "What is JewelPAC<sup>®</sup>?",
      "AMLDescription": "Almost all jewelry businesses in the United States must comply with Anti-Money Laundering laws and regulations from the USA PATRIOT Act and the Bank Secrecy Act.",
      "JewelPac": "To support jewelers in their compliance efforts, Jewelers Mutual and Jewelers Vigilance Committee (JVC) offer <em font-style:italic;>JewelPAC</em>. The <em font-style:italic;>JewelPAC</em> program combines JVC's expertise regarding legal issues impacting the jewelry industry with Jewelers Mutual Group's trusted guidance. The program is comprised of a series of modules that educate you on AML regulation and create customized documentation, including an AML policy and certificate of training.",
      "SaveTimeWithJewelPac": "Save time and reduce the risks associated with developing your own program. Make the <em font-style:italic;>JewelPAC</em> program one of your most valuable business resources.",
      "LearnMore": "Learn More",
      "JewelPacItalic": "<em font-style:italic;>JewelPAC </em>",
      "Programs": "Programs",
      "FirstTimeFullProgram": {
        "Subtitle": "First-Time Full Program",
        "ForUsers": "For first-time <em font-style:italic;>JewelPAC</em> users.",
        "Description": "Includes complete set of training and program creation for overall business compliance.",
        "Prerequisites": "Prerequisite: None"
      },
      "AnnualRenewalProgram": {
        "Subtitle": "Annual Renewal Program",
        "ForUsers": "For existing <em font-style:italic;>JewelPAC</em> users.",
        "Description": "To maintain an active compliance program for another year.",
        "Prerequisites": "Prerequisite: First-Time Full Program"
      },
      "EmployeeTraining": {
        "Subtitle": "Employee Training",
        "ForUsers": "Training for individual employees who must comply with regulations.",
        "Prerequisites": "Prerequisite: First-Time Full Program"
      },
      "MySessions": "My Sessions",
      "PurchaseAProgram": "Purchase a Program",
      "PopUpModalHeader": "Redirecting to <em font-style:italic;>JM</em> Shipping Solution Site",
      "PopUpModalBody": "<div>A new tab will open for access to <em font-style:italic;>JewelPAC</em> on our host site, iShipJM.com.</div><div class='pt-2'>Please log in with your <em font-style:italic;>Zing</em> user name and password.</div>"
    },
    "TransactionRequirements": {
      "PopUpModalHeader": "Commercial Cash Transaction Requirements",
      "PopUpModalBody": "<div>Per USPS requirements, cash/currency from commercial transactions over $500 being sent through the mail <b>must</b> be sent as Registered Mail.</div><div class='pt-2'>Additionally, USPS branded packaging may <b>not</b> be used for cash shipments of any value. You must use custom packaging. To comply with these requirements, please ensure you select the appropriate shipment details. FedEx and UPS do not accept cash shipments.</div>",
      "CheckboxText": "I agree to comply with these USPS requirements"
    },
    "AvailableDocuments": "Available Documents",
    "TransactionReceipt": "Transaction Receipt",
    "InsuranceCertificate": "Insurance Certificate",
    "InternationalDocument": "International Documents",
    "ShipmentLabel": "Shipment Label",
    "Unknown": "Unknown",
    "ShipmentIsVoided": "Shipment Voided",
    "ClaimIsFiled": "Claim Filed",
    "TrackAnotherShipment": "Track Another Shipment",
    "NoShipmentFound": "No Shipment Found with the Tracking ID",
    "BlockCoverage": "Block Coverage",
    "ClaimReportingWindow": "Claim Reporting Window",
    "ClaimReportingWindow30Days": "30 Days",
    "ClaimReportingWindow6Months": "6 Months",
    "ClaimReportingWindowEssential": "Essential",
    "ClaimReportingWindowExpanded": "Expanded",
    "CoverageOption": "Coverage Option",
    "ThroughThisPlatform": "Through <em font-style:italic;>JM</em> Shipping Solution",
    "ViewClaimDetails": "View Claim Details",
    "ViewClaim": "View Claim",
    "TotalDeclaredValue": "Total Declared Value",
    "MandatoryStepsModal": {
      "UpdateProfile": "Update Profile: Complete Company Setup",
      "CompanyAddress": "Add Company address",
      "PaymentMethod": "Add a Payment Method",
      "AskBusinessAdministrator": "Please ask your company's Business Administrator to complete your company’s profile to be able to use Zing by Jewelers Mutual Group<sup>®</sup> to its full potential",
      "CompleteProfile": "Please complete your company’s profile to be able to use Zing by Jewelers Mutual Group<sup>®</sup> to its full potential",
      "Helpline": "For any assistance, please call our Customer Helpline:",
      "LogOut": "Click to Logout",
      "ChargeInfo": "A $1.00 charge will be temporarily applied to your card as we secure preauthorization from your credit card company for potential future payments. This charge will be reversed within 2-5 days.",
      "FeesInfo": "Our shipping solution has no fees beyond the cost of label purchase."
    },
    "AddressValidationFailedTitle": "The address you entered could not be validated",
    "DownloadLabel": "Download/Share Label",
    "DownloadPdf": "Download PDF",
    "ShareViaEmail": "Share via Email",
    "DownloadDocuments": "Download Documents",
    "ChooseAFedExLocation": "Choose a FedEx Location",
    "UseThisLocation": "Use This Location",
    "LocationSelected": "Location Selected",
    "GroundAndExpressShipments": "Express and Ground Shipments",
    "GroundShipmentsOnly": "Ground Shipments Only",
    "ExpressShipmentsOnly": "Express Shipments Only",
    "BlockPolicyLimits": {
      "BlockPolicyLimits": "Block Policy Limits",
      "AccountNumber": "Account Number",
      "PolicyNumber": "Policy Number",
      "Description": "Carrier",
      "Limit": "Limit",
      "Deductible": "Deductible",
      "EffectiveDate": "Effective Date",
      "ExpirationDate": "Expiration Date",
      "NoData": "Either no shipping coverage was found on your policy, or no active policy was found, or there are special insurance rules that cannot be displayed. Please review all quotes for accuracy and contact us if you have any questions.",
      "NotAvailableForInternational": "Block coverage detail for international shipments is not available for display. Please review your insurance policy or contact your agent."
    },
    "AddressValidationOrigin": "From Address",
    "AddressValidationDestination": "To Address",
    "UseEnteredAddress": "Use entered address",
    "UseStandardizedAddress": "Use standardized address",
    "UseThisAddressAndContinue": "Use This Address",
    "AddressCannotBeValidated": "Address cannot be validated",
    "EditAddress": "Edit Address",
    "ColumnSelection": "Column Selection",
    "NoUpcomingPayments": "There are no upcoming payments scheduled for this account",
    "Summary": "Summary",
    "ASummaryOfYourSelections": "A summary of your selections appears below. If you need to make any changes, please do so now and complete your purchase when you are ready.",
    "OriginAndDestination": "Origin and Destination",
    "CompletePurchase": "Complete Purchase",
    "ShipDate": "Ship Date",
    "InvoiceValueLabel": "Invoice Value",
    "CustomsDocuments": "Customs Documents",
    "SEDLongLabel": "Shipper's Export Declaration (SED)",
    "Purchase": "Purchase",
    "ShowMore": "Show More",
    "ShowLess": "Show Less",
    "CurrentPaymentDeliveryMethod": {
      "email": "Email",
      "mail": "Mail",
      "both": "Email and Mail"
    },
    "IdleMessage": "Your session will logout in 5 minutes.",
    "ContinueSession": "Continue Session",
    "LogoutButton": "Logout",
    "NoContactSelected": "No contact selected",
    "ClaimStatus": {
      "Closed": "Closed",
      "Open": "Open",
      "Pending": "Pending"
    },
    "NoClaims": "There are currently no claims on this policy.",
    "Claims": "Claims",
    "ClaimsTable": {
      "ClaimNumber": "Claim No.",
      "AmountPaid": "Amount Paid",
      "DateofLoss": "Date of Loss",
      "Description": "Description",
      "Status": "Status"
    },
    "ShippingInsuranceTable": {
      "Coverage": "Coverage",
      "Limit": "Limit",
      "Deductible": "Deductible"
    },
    "FileUpload": {
      "AddDocumentHover": "PDF documents only",
      "AddPictureHover": "Upload pictures of the watch, warranty cards or certificates"
    },
    "InTrialAppraisalDisclaimer": "This is a sample appraisal that can be created from the Jewelry Appraisal Solution.   After registering, you will be able to access your appraisal dashboard, upload your customized logo, print the appraisal, and receive payment for each appraisal accompanying a completed application through the system.",
    "NoRetailValue": "Pricing currently not available for your entry.<br/> Please enter a retail price manually.",
    "CheckRetailValue": "Please check the retail value for accuracy.",
    "NoShipmentCoverages": "There are no shipping coverages on this policy.",
    "EditPaymentMethod": "A payment method is required to continue with this action. Please click “Edit” to input your credit card information.",
    "EditPaymentMethodAskBusinessAdministrator": "A payment method is required to continue with this action. Please ask your Business Administrator to add credit card information.",
    "LocationNameSelectionTitle": "Select a location or enter a new one.",
    "WhatGemsAreAdded": "What gems are in this item?",
    "UpdateUserPreferences": "Update User Preferences",
    "SuccessfullyUpdatedUserPreferences": "User preferences are updated successfully.",
    "SavePreferences": "Save Preferences",
    "RemoveLogoConfirmation": "Are you sure you want to remove the company logo?",
    "SelectDefaultLocation": "Select Default Location for Appraisal:",
    "LocationNamePreparedAt": "Prepared at Location",
    "SelectCurrency": "Select Currency to be used for appraisal",
    "KindOfJewelry": "What kind of jewelry is it?",
    "AppraisedItems": "Appraised Items",
    "ZeroItemsAdded": "0 items added",
    "ZeroGemsAdded": "0 gems added",
    "Items": "Items",
    "Item": "Item",
    "GemsWithTheItem": "Gems with the Item",
    "AddGemsToTheItem": "Add Gems to the Item",
    "TotalAppraisalValuation": "Total Appraisal Valuation",
    "ReviewAndComplete": "Review & Complete Appraisal",
    "MaximumItemsPerAppraisal": "The maximum number of items per appraisal is 15.<br/> After completing this appraisal, you can start another appraisal for any additional items.",
    "Watch": "Watch",
    "Brand": "Brand",
    "OtherBrand": "Other brand",
    "BrandNotListed": "Brand not listed",
    "OtherBrandPlaceholder": "Brand not listed",
    "Gender": "Gender",
    "Condition": "Condition",
    "Model": "Model",
    "Color": "Color",
    "OtherModel": "Other Model",
    "OtherModelPlaceholder": "Other Model",
    "JewelryDescription": "Jewelry Description",
    "WatchDescription": "Watch Description",
    "Material": "Material",
    "OtherMaterial": "Other Material",
    "OtherMaterialPlaceholder": "Other Material",
    "ReferenceNumber": "Reference Number",
    "SerialNumber": "Serial Number",
    "AftermarketCustomization": "Aftermarket Customization",
    "WatchDetailsHeader": "Tell us a little about your watch",
    "DescribeTheWatch": "Describe the watch and attach any pictures and documentation",
    "BrandOfTheWatch": "What brand is the watch?",
    "Step": "Step",
    "Customer": "Customer",
    "CustomerInformation": "Customer Information",
    "Jewelry": "Jewelry",
    "Gems": "Gems",
    "Gem": "Gem",
    "Valuation": "Valuation",
    "DescribeJewelryAttachDocumentation": "Describe the jewelry and attach any pictures and documentation.",
    "JewelryAdditionalInformation": "Enter any additional description of jewelry item including grading report(s)",
    "WatchAdditionalInformation": "Enter any additional descriptions of the watch",
    "JewelryStyle": "Jewelry Style",
    "OtherJewelryStyle": "Other Jewelry Style",
    "JewelryType": "Jewelry Type",
    "EnterJewelryStyle": "Enter Jewelry Style",
    "MetalType": "Metal Type",
    "TotalWeightPiece": "Total Weight of Piece",
    "TotalWeight": "Total Weight",
    "AddDocument": "Add Document",
    "AddPicture": "Add Picture",
    "LogoForAppraisals": "Logo for Appraisals",
    "AddAppraisalLogo": "Add Logo",
    "UpdateAppraisalLogo": "Update Logo",
    "RemoveAppraisalLogo": "Remove Logo",
    "EnterGradingReport": "Enter description of item including grading reports.",
    "FieldRequired": "Please choose an option",
    "DescriptionRequired": "Please enter Description",
    "NumberRequired": "Please enter a number",
    "EnterTotalWeight": "Please enter total weight",
    "MountingWeightWarning": "A value for the item may not calculate accurately with no weight entered",
    "Pearl": "Pearl",
    "Pearls": "Pearls",
    "UnitForMillimeter": "mm",
    "MaxCantBeLessThanMin": "Max can’t be less than min",
    "Strand": "Strand",
    "Strands": "Strands",
    "CompleteValuation": "Complete Valuation",
    "Draft": "Draft",
    "TypeJewelry": "Jewelry",
    "TypeWatch": "Watch",
    "EditOrDeleteDraft": "Edit or Delete Draft",
    "SaveOrDeleteDraft": "Save or Delete Draft",
    "SaveDraft": "Save Draft",
    "DeleteDraft": "Delete Draft",
    "Grams": "Grams",
    "DWT": "DWT",
    "KaratContent": "Karat Content",
    "SilverType": "Silver Type",
    "PlatinumType": "Platinum Type",
    "OtherMetalTypeLabel": "Other Metal Type",
    "Quantity": "Quantity",
    "ItemQuantity": "Item Quantity",
    "QuantityUnit": "Quantity Unit",
    "GemType": "Gem Type",
    "RetailValue": "Retail Value",
    "EnterStreetAddressOrAddressBookContact": "Enter Street Address or Address Book Contact",
    "TotalRetailReplacementValue": "Total Retail Replacement Value",
    "PleaseFillIncompleteDetails": "Please fill incomplete details",
    "CancelAndClose": "Cancel and Close",
    "SaveToTheAppraisal": "Save to the Appraisal",
    "Carat": "Carat",
    "CaratUnit": "ct",
    "Species": "Species",
    "Diamond": "Diamond",
    "ColoredStone": "Colored Stone",
    "Mounting": "Mounting",
    "NoGems": "no gems",
    "RetailInsuranceAppraisalValue": "Retail Insurance Appraisal Value for Document",
    "SubmittedBy": "Submitted By",
    "EnterFullName": "Enter Full Name",
    "PreparerTitle": "Preparer Title",
    "AppraisalDocumentTitle": "Appraisal Document Title",
    "UserPreferencesAppraiserName": "Appraiser's Full Name",
    "AppraiserTitle": "Appraiser's Title",
    "UserPreferencesDisplayWholesale": "Display wholesale values to",
    "AppraisalQRCode": "QR Code",
    "AppraisalQRCodeCheckbox": "Add a scannable QR code for an insurance quote to the downloaded Appraisal PDF",
    "AppraisalInclude": "Include in appraisal",
    "AppraisalDisplayItemTotalMetalWeightCheckbox": "Total Weight of Item",
    "AppraisalDisplayItemTotalMetalPriceCheckbox": "Metals Market Price",
    "BusinessUser": "Business Users",
    "BusinessLocationAdministrator": "Business Location Administrators",
    "Title": "Title",
    "DownloadAppraisal": "Download Appraisal",
    "PrintAppraisal": "Print Appraisal",
    "CompleteAppraisal": "Complete Appraisal",
    "DeleteDraftConfirmationMessage": "Are you sure you want to delete the draft appraisal?",
    "PreviewAppraisal": "Preview Appraisal",
    "AppraisalPreview": "Appraisal Preview",
    "AppraisalExpired": "To ensure proper market valuations - Appraisals over {{validityPeriodInDays}} days old cannot be edited.",
    "ClickForNew": "Click the Create New Appraisal button below to start a new appraisal for this customer.",
    "EditAppraisal": "Edit Appraisal",
    "StartNewForSameCustomer": "Start New Appraisal For This Customer",
    "StartNew": "Start New",
    "NewAppraisal": "Create New Appraisal",
    "NewForSameCustomer": "New Appraisal For This Customer",
    "NewAppraisalForSameCustomer": "New Appraisal",
    "SaveAndPreview": "Save And Preview Appraisal",
    "SaveAndPrint": "Save And Print",
    "EmailAppraisal": "Email Appraisal",
    "ResendEmail": "Resend Email",
    "SendEmail": "Send Email",
    "StartAnother": "Start Another",
    "StartNewCustomer": "Start New Customer",
    "Reset": "Reset",
    "NoUpdateMadeToValue": "No update made to the final value. <br/> Please check for accuracy.",
    "DocumentLimit": "There is a 5MB limit per image or document.",
    "SpecialCharacterWarning": "File names cannot contain special characters: {{characters}}",
    "FileNameDigitsWarning" : "Also avoid combining ‘0x’ with 3 or more letters or numbers (for example, 0x1A2B) in the file name.",
    "ImagesDisclaimer": "The first three pictures uploaded will be added to your appraisal document.",
    "ImageLimit": "There is a 5MB limit per image.",
    "ImageWidthHeightLimit": "Maximum image size is 2048 X 2048 pixels.",
    "CreateNewAppraisal": "Create New Appraisal",
    "FindAppraisal": "Find an Appraisal",
    "EnterSearchAppraisal": "Find appraisals using name, email, phone, or appraisal #",
    "Search": "Search",
    "EnterAppraiserName": "Please enter Appraiser Name",
    "Shape": "Shape",
    "AppraisalDashboard": "Appraisal Dashboard",
    "GoToMainDashboard": "Go to Dashboard",
    "Newsfeed": "News From JCK",
    "LoadingPleaseWait": "Loading. Please wait.",
    "ExchangeRate": {
      "Refresh": "Refresh Exchange Rate",
      "UpdatedExchangeRate": "Updated Exchange Rate:",
      "AppliedExchangeRate": "Applied Exchange Rate:"
    },
    "GemsGrid": {
      "EditGem": "Edit",
      "RemoveGem": "Remove"
    },
    "AppraisalGrid": {
      "CreatedOn": "Created",
      "FirstName": "First",
      "LastName": "Last",
      "Email": "Email",
      "PhoneNumber": "Phone",
      "Id": "Appraisal #",
      "TotalValue": "Total Appraised Value",
      "Type": "Type"
    },
    "AppraisalEmailPreview": "Personalized Email Preview",
    "Notifications": {
      "MenuItemText": "Notifications",
      "Title": "Notifications",
      "NoUnread": "No unread notifications",
      "ViewAll": "View all",
      "Today": "Today",
      "Yesterday": "Yesterday",
      "ThisWeek": "This Week",
      "LastWeek": "Last Week",
      "WithinThirtyDays": "Within Thirty Days",
      "Older": "Older"
    },
    "Helpdesk": "Helpdesk",
    "AddContact": "Add A Contact",
    "SearchContact": "Search All Contacts",
    "ImportContact": "Import Contacts",
    "Profile": "Profile",
    "IdexSearchForm": {
      "MainTitle": "Search for Diamonds",
      "Shape": "Select a Shape(s)",
      "Color": "Color",
      "Intensity": "Intensity",
      "Overtone": "Overtone",
      "CutGrade": "Cut grade",
      "Polish": "Polish",
      "Symmetry": "Symmetry",
      "To": "to",
      "FluorescenceColor": "Fluorescence Color",
      "Width": "Width",
      "Height": "Height",
      "Girdle": "Girdle",
      "Shade": "Shade",
      "Milky": "Milky",
      "BlackInclusion": "Black inclusion",
      "EyeClean": "Eye clean",
      "NoItems": "Sorry, no results matched your selections. <br/>Please modify your search criteria and click search diamonds again.",
      "InvalidItemId": "Max 10 characters",
      "IncludeProvenanceReport": "Include Provenance Report",
      "ItemIdPlaceholder": "Item ID #",
      "ItemIdDropdown": "Item ID",
      "ViewSearchPresets": "View your saved searches",
      "YourSearchPresets": "Your Saved Searches",
      "CutGradeAvailable": "Cut Grade Available",
      "MoreFilters": {
        "MakeAndFlourescence": "Make and Fluorescence",
        "Fluorescence": "Fluorescence",
        "CuletSize": "Culet Size",
        "CuletCondition": "Culet Condition",
        "ShadeAndLuster": "Shade and Luster",
        "Other": "Other"
      }
    },
    "LabGrownSearchForm": {
      "MoreFilters": {
        "MakeAndFluorescence": "Make and Fluorescence",
        "CutGrade": "Cut Grade",
        "Polish": "Polish",
        "Symmetry": "Symmetry",
        "Fluorescence": "Fluorescence",
        "FluorescenceColor": "Fluorescence Color",
        "FancyColor": "Fancy Color",
        "Color": "Color",
        "Intensity": "Intensity",
        "Overtone": "Overtone",
        "ShadeAndLuster": "Shade and Luster",
        "Brown": "Brown",
        "Green": "Green",
        "Blue": "Blue",
        "Gray": "Gray",
        "OtherShade": "Other Shade",
        "Luster": "Luster",
        "Other": "Other",
        "Girdle": "Girdle",
        "TreatmentType": "Treatment Type",
        "EyeClean": "Eye Clean",
        "Parameters": "Parameters"
      }
    },
    "FindOutMore": "Find out more",
    "ClearAll": "Clear All",
    "Notification": "Notification",
    "ViewAll": "View All",
    "ViewAllNotifications": "View all notifications",
    "StartShipping": "Start Shipping",
    "MarketplaceDashboard": {
      "SearchCriteria": "Search Criteria:",
      "ShoppingCart": "Shopping Cart",
      "EmailZing": "e-MAIL ZING",
      "Actions": "Actions",
      "SelectAction": "Select Action",
      "EmailDiamonds": "E-mail Selected Diamonds",
      "ExportDiamondsToExcel": "Export Selected Diamonds to Excel",
      "ExportPageToExcel": "Export this page to Excel",
      "StartNewSearch": "Start New Search",
      "NoResults": "0 items found - Try another search",
      "DiamondSearchResults": "Diamond Search Results",
      "Orders": "Orders",
      "DiamondMarketplace": "Diamond Marketplace",
      "DiamondsFoundOne": "Diamond Found",
      "DiamondsFoundOther": "Diamonds Found",
      "YourDiamondSearchResults": "Your Diamond Search Results",
      "OrderStatus": "Order Status",
      "BasicInfo": "Basic Info",
      "More": "More",
      "Compare": "Compare {{compareCount}}",
      "MaxCompareMessage": "A maximum of {{maxDiamondItems}} diamonds can be compared at a time.",
      "MinPrice": "Min Price Per Carat: ",
      "MaxPrice": "Max Price Per Carat: ",
      "AvgPrice": "Avg Price Per Carat: "
    },
    "DiamondsSearchGrid": {
      "Ags": "AGS Supplier Diamond",
      "Shape": "Shape",
      "LightPerformance": "Light Performance",
      "ProportionFactors": "Proportion Factors",
      "Carat": "Carat",
      "Color": "Color",
      "Clarity": "Clarity",
      "CutGrade": "Cut Grade",
      "Polish": "Polish",
      "Symmetry": "Symmetry",
      "Fluorescence": "Fluorescence",
      "GradingLab": "Grading Lab",
      "PricePerCarat": "Price Per Carat",
      "Location": "Diamond Location",
      "TotalPrice": "Diamond Price",
      "Order": "Order",
      "Buy": "Buy",
      "AddToCart": "Add to Cart",
      "RemoveFromCart": "Remove from Cart",
      "ItemInCart": "Item in Cart",
      "AGS": "AGS",
      "ProportionFactor": "Proportion Factor",
      "AgsReportType": "AGS Report type",
      "AgsSupplierTooltip": "AGS Supplier Diamond",
      "EstimatedTotalPriceTooltip": "Additional shipping and handling fees and taxes may apply"
    },
    "CompareDiamondsModal": {
      "Title": "Compare Diamonds - {{count}}",
      "MaxAddMessage": "A maximum of {{maxAdd}} diamonds are allowed in the shopping cart.",
      "ButtonAddItem": "Add to Cart",
      "ButtonRemoveItem": "Remove from Cart",
      "ItemNum": "Item #",
      "Image": "Image(s)",
      "DeliveredPriceStartingAt": "Delivered Price starting at",
      "DeliveredPriceStartingAtTooltip": "Delivered Price is based on ACH payment method and includes all fulfillment and servicing fees. Tax, if applicable, is not included. Fulfillment fees are less when an order contains more than one diamond.",
      "DiamondLocation": "Location",
      "ItemNumber": "Item Number",
      "ReportNumber": "Report Number",
      "Carat": "Carat",
      "PricePerCarat": "Price per carat",
      "OffIdexList": "Off IDEX List"
    },
    "CompareLabDiamondsModal": {
      "Title": "Compare Diamonds ({{count}})",
      "RemoveFromCompare": "Remove from Compare",
      "Image": "Image",
      "ReportNumber": "Report Number",
      "InCart": "IN CART",
      "Returnable": "Returnable"
    },
    "NoImageAvailable": "No image available",
    "RequestImage": "Request Image",
    "ImageRequestSent": "Image request sent",
    "PreviewUnavailable": "Preview Unavailable",
    "NoPreviewImage": "Click View Details for image/video",
    "RequestImageInDetails": "Click View Details to request image",
    "AdditionalLinks": "Additional images",
    "ViewImageText": "View Image",
    "3DVideoText": "View 3D Video",
    "VideoText": "View Video",
    "360VideoText": "View 360° Video",
    "ASETText": "View ASET",
    "OPMHeartsText": "View OPM Heart",
    "OPMArrowsText": "View OPM Arrows",
    "LightPerfText": "View Light Perf Graph",
    "OrderStatusGrid": {
      "ZingOrderId": "Zing Order ID",
      "OrderCancelled": "Order Cancelled",
      "DateOfSale": "Date of Sale",
      "ItemId": "Item ID",
      "IdexId": "IDEX ID",
      "TotalTransactionCost": "Total Transaction Cost",
      "OrderStatus": "Order Status",
      "Search": "Search",
      "SearchForOrders": "Search for an Order",
      "SearchByStatus": "Search by Status",
      "StartANewSearch": "Start a New Search",
      "YourDiamondOrders": "Your Diamond Orders",
      "SearchByDateOfSale": "Search by Date of Sale",
      "NoOrdersMessage": "Currently, there are no orders to be viewed",
      "TrackingNumber": "Tracking Number",
      "PriceUpdated": "The price was updated on {{date}} {{reason}}",
      "PaymentDetails": "Payment Details",
      "PaymentType": "Payment Type:",
      "PaymentStatus": "Payment Status:",
      "ACHPaymentErrorWithReason": "<b>Your ACH payment was not successful for the following reason: {{reason}}</b> A team member will send you a separate email with details on how to pay via wire transfer. If additional assistance is needed please call 1-833-970-9464.",
      "ACHPaymentError": "<b>Your ACH payment was not successful. A team member will send you a separate email with details on how to pay via wire transfer. If additional assistance is needed please call 1-833-970-9464.",
      "LgdTrackingColumn": "Expand for tracking info"
    },
    "TaxDocumentNavigation": {
      "Title": "Tax Documents",
      "Message": "View or manage your state tax exemption documents for taxable locations.",
      "GoToTaxDocs": "Go to Tax Documents"
    },
    "ProductDetails": {
      "DeliveredPriceStartingAt": "Delivered Price Starting at: ",
      "Carat": "Carat:",
      "ReturnPolicy": "Our Return Policy",
      "InCart": "IN CART",
      "Location": "Location:",
      "ItemNumber": "Item Number:",
      "Shape": "Shape:",
      "Title": "Diamond Specifications",
      "Natural": "Natural",
      "LabGrown": "Lab Grown",
      "Culet": "Culet",
      "AgsReportType": "AGS Report Type:",
      "snackBarSuccessMsg": "Your email has been sent sucessfully!",
      "ImageRequestSent": "Image Request Sent"
    },
    "FilterSelections": {
      "NaturalSavedSearches": "Natural Saved Searches ({{count}})",
      "LabGrownSavedSearches": "Lab Saved Searches ({{count}})",
      "YourSelectionsTitle": "Your Selections",
      "Shapes": "Shape",
      "SpecialShapes": "Special Shape",
      "Price": "Price",
      "Carat": "Carat",
      "ColorType": "Color Type",
      "PriceType": "Price Type",
      "FancyColorIntensity": "Intensity",
      "FancyColorOvertone": "Overtones",
      "FancyColor": "Color",
      "Color": "Color",
      "Clarity": "Clarity",
      "SourceCountryCodes": "Location",
      "GradingLabs": "Grading Lab",
      "SearchByOptions": "Search By Option",
      "SearchBy": "Search By Value",
      "Cut": "Cut Grade",
      "Polish": "Polish",
      "Symmetry": "Symmetry",
      "Fluorescence": "Fluorescence",
      "FluorescenceColor": "Fluorescence Color",
      "Shade": "Shade",
      "Milky": "Milky",
      "BlackInclusion": "Black Inclusion",
      "EyeClean": "Eye Clean",
      "IncludeProvenanceReport": "Provenance Report",
      "Table": "Table",
      "Depth": "Depth",
      "Length": "Length",
      "Width": "Width",
      "Height": "Height",
      "Ratio": "Ratio",
      "Crown": "Crown",
      "Pavilion": "Pavilion",
      "CuletSize": "Culet size",
      "CuletCondition": "Culet Condition",
      "Girdle": "Girdle",
      "DiamondsWithImageOrVideo": "Diamonds with Image/Video",
      "ReturnableDiamonds": "Returnable Diamonds",
      "Make": "Make",
      "Sub": "Show unknown Shade",
      "Sul": "Show unknown Luster",
      "Brown": "Brown",
      "Blue": "Blue",
      "Green": "Green",
      "Gray": "Gray",
      "OtherShade": "Other Shade",
      "Luster": "Luster",
      "TreatmentType": "Treatment Type",
      "PresetRatio": "Preset Ratio",
      "Disabled": "Disabled",
      "Enabled": "Enabled"
    },
    "DiamondDetails": {
      "EmailDiamondDetails": "E-mail Diamond Details",
      "SaveAsPdf": "Save as PDF",
      "EmailZing": "E-mail Zing",
      "Questions": "Questions?",
      "RequestReturnEligibility": "Request Return Eligibility",
      "ItemId": "Item #:",
      "Measurements": "Measurements",
      "FluorescenceIntesity": "Fluorescence Intensity",
      "Girdle": "Girdle",
      "ReportNumber": "Report Number:",
      "AgsNumber": "AGS Number:",
      "ProvenanceReport": "Provenance Report:",
      "Depth": "Depth",
      "Fluorescence": "Fluorescence Color",
      "Shade": "Shade",
      "Location": "Location",
      "GradingLab": "Grading Lab:",
      "CutGrade": "Cut Grade:",
      "Polish": "Polish:",
      "Symmetry": "Symmetry:",
      "LightPerformance": "Light Performance:",
      "ProportionFactor": "Proportion Factors:",
      "ReportType": "Report Type:",
      "AgsReportType": "AGS Report Type:",
      "PavilionDepth": "Pavilion Depth",
      "Milky": "Milky",
      "GuaranteedAvailability": "Guaranteed Availability",
      "CrownHeight": "Crown Height",
      "PavilionAngle": "Pavilion Angle",
      "BlackInclusion": "Black Inclusion",
      "DiamondPrice": "Diamond Price:",
      "DeliveredPriceStartingAt": "Delivered Price starting at",
      "AchDiscountedPrice": "ACH Discounted Price*",
      "WtDiscountedPrice": "Wire Transfer Discounted Price*",
      "WtDiscountPrice": "Wire Transfer Discount Price*",
      "CrownAngle": "Crown Angle",
      "CuletSize": "Culet Size",
      "EyeClean": "Eye Clean",
      "OffIdexList": "Off IDEX List",
      "PricePerCarat": "Price Per Carat:",
      "Table": "Table",
      "CuletCondition": "Culet Condition",
      "GradingLabLinkTooltip": "View grading report",
      "Clarity": "Clarity:",
      "Carats": "Carats",
      "Color": "Color:",
      "Buy": "Buy",
      "Saves": "Saves",
      "AddToCart": "Add to Cart",
      "RemoveFromCart": "Remove from Cart",
      "PriceTotalUpdateTooltip": "The price is updated.",
      "DeliveredPriceStartingAtTooltip": "Delivered Price is based on ACH payment method and includes all fulfillment and servicing fees. Tax, if applicable, is not included. Fulfillment fees are less when an order contains more than one diamond.",
      "PaymentMethodSavingsMessage": "*Price reflected when payment method selected. Savings may vary on orders of multiple diamonds.",
      "TariffTooltipLabel": "Subject to Tariffs",
      "TariffTooltipSubtitle": "Import tariffs are charged after checkout",
      "TariffTooltipContentPart1": "Non-U.S. natural diamonds are subject to import tariffs.",
      "TariffTooltipContentPart2": "After checkout, you'll be contacted with the tariff amount and payment instructions.",
      "TariffTooltipContentPart3": "To bypass tariffs, select U.S. location in your search filters.",
      "TariffTooltipContentPart4": "Questions? ",
      "TariffTooltipContentPart5": "Message us."
    },
    "DiamondOrderDetails": {
      "ZingOrder": "Order ID:",
      "ItemId": "Item ID:",
      "Shape": "Shape:",
      "Carat": "Carat:",
      "Color": "Color:",
      "Clarity": "Clarity:",
      "CutGrade": "Cut Grade:",
      "LightPerformance": "Light Performance:",
      "ProportionFactor": "Proportion Factors:",
      "Polish": "Polish:",
      "Symmetry": "Symmetry:",
      "AgsReportType": "AGS Report type:",
      "ReportType": "Report Type:",
      "GradingLab": "Grading Lab:",
      "GradingReport": "Grading Report #:",
      "OrderDetails": "Order Details",
      "DiamondDetails": "Diamond Details",
      "NaturalDiamondDetails": "Natural Diamond Details",
      "DeliveryDetails": "Delivery Details",
      "SelectLocation": "Select a Location",
      "LocationName": "Location{{num}}:",
      "Company": "Company:",
      "Contact": "Contact:",
      "Address": "Address:",
      "Phone": "Phone {{num}}:",
      "Email": "Email:",
      "TotalDiamondPrice": "Total Diamond Price",
      "DiamondAuthenticationFee": "Diamond Authentication Fee",
      "ShippingHandling": "Shipping and Handling",
      "AuthenticationAndShipping": "Authentication & Shipping",
      "TransactionFee": "Service Fee",
      "PaymentProcessing": "Funds Transfer Fee",
      "ServicingFee": "Servicing Fee",
      "TotalTransactionCost": "Total Transaction Cost",
      "TotalTaxAmount": "Tax",
      "WireTransferDiscount": "Wire Transfer Discount",
      "ACHDiscount": "ACH Discount",
      "OrderExempted": "Your order qualifies for tax exemption",
      "Location": "Location:",
      "BackToSearch": "Back to Search Results",
      "NextStep": "Next Step",
      "CompleteYourOrder": "Complete Your Order",
      "ReturnPolicy": "Return Policy",
      "ReturnPolicyMsg": "<p>Returns may be available on select diamonds.</p><p>Please use the <strong><q>Request Return Eligibility</q></strong> link in the diamond details to submit a request prior to purchase. Requests <strong><u>will not</u></strong> be accepted after purchase.</p><p>After we review your request, you’ll be notified via email of the return eligibility of the selected diamond.</p>",
      "AuthenticationGuarantee": "Authentication Guarantee",
      "AuthenticationGuaranteeMsg": "All diamonds are authenticated before shipping. Please email the Zing<sup>®</sup> Marketplace team before purchase for images, videos, details not in the listing, or specific quality control preferences. Buyers will be notified of any quality discrepancies before shipping.",
      "NoLocations": "Presently, this item cannot be shipped to any of your locations.",
      "AdditionalNoteLine1": "Additional local charges may apply when shipping diamonds valued at $25,000 or more.  ",
      "AdditionalNoteLine2": "The buyer will be invoiced directly by the distributor IDEX, International Diamond Exchange.",
      "OrderConfirmationMessageText": "Are you sure you want to complete this order?",
      "OrderConfirmationMessageTitle": "Confirmation",
      "OrderConfirmationButtonCancel": "Cancel",
      "OrderConfirmationButtonConfirm": "Complete Order",
      "ZingOrderId": "Zing Order Id:",
      "NoShippingToLocationAlert": "Shipping is not available for US territories",
      "BackToShoppingCart": "Back to the Shopping Cart",
      "ShippingInformation": "Shipping Information",
      "NoShippingPriceLine1": "Shipping costs aren’t able to be calculated for the selected address.",
      "NoShippingPriceLine2": "You will be contacted shortly to confirm shipping cost for this transaction.",
      "ItemNotAvailTitle": "Items Unavailable",
      "ItemNotAvailMessage": "There are some items in your shopping cart that are no longer available. Please review before completing your order.",
      "ReviewYourOrder": "Review Your Order",
      "AvailableDeliveryMethod": "Available Delivery Method",
      "DeliveryMethod": "Delivery Method:",
      "Standard": "Standard",
      "Expedited": "Expedited",
      "StandardDelivery": "(7 - 10 days)",
      "ExpeditedDelivery": "(3 - 5 days)",
      "Mobile": "Mobile:",
      "PhoneInputPlaceholder": "(XXX) XXX-XXXX",
      "VerifyPhone": "Click to Verify",
      "VerifyPhoneTooltip": "Please verify your mobile number on your profile",
      "FeesInfo": "Learn more about the fees applied to the purchase",
      "TariffsNoticeTitle": "Tariffs Notice",
      "TariffsNoticeSubtitle": "Additional tariffs will be charged after checkout.",
      "ReturnPolicyMsgUpdated": "<p>Lab-grown diamonds are eligible for return to the supplier up to 20 days after receipt.</p><p>Original shipping costs are non-refundable.</p><p>Refunds are processed after supplier authentication.</p><p>A <strong>$35 return fee</strong> will be deducted from the refund per return shipment. Multiple items may be returned in the same shipment to avoid additional fees.</p>"
    },
    "FeesInformationModal": {
      "Header": "Information on the Fees Applied to the Purchase",
      "Body": "<div class='roboto-bold fees-info-subtitle'>Authentication & Shipping Fee</div><div class='fees-info-details'>Covers the cost of diamond authentication, freight, shipping insurance, custom duties, if applicable, and pickup and delivery.</div> <br> <div class='roboto-bold fees-info-subtitle'>Servicing Fee</div> <div class='fees-info-details'>A minimum $55 fee covers order processing and funds transfer to the supplier. Servicing fees vary per payment type.</div><br> <div class='roboto-bold'>Please note that all fees are subject to change without notice.</div>"
    },
    "ItemNotAvailModal": {
      "Content": "There are some items which are updated or no longer available.<br>Please review your shopping cart before completing your order. "
    },
    "EmailDiamondDetailModal": {
      "Title": "Email Details",
      "ConfirmText": "Ok",
      "DeclineText": "Cancel"
    },
    "RequestReturnEligibility": {
      "Title": "Send a Return Eligibility Request message to Zing® Marketplace?",
      "ConfirmText": "Yes",
      "DeclineText": "No"
    },
    "ThirdPartyConfirmationModal": {
      "Title": "Redirect Notice",
      "Content": "You will be transferred from the <i>Zing</i> Marketplace to a third-party site to view images, videos or documents for this diamond. Do you want to continue?",
      "Selection": "Don't show me this message again."
    },
    "EmailZingModal": {
      "ConfirmText": "Send Message",
      "DeclineText": "Cancel",
      "Title": "Send a message to Zing<sup>®</sup> Marketplace",
      "Instructions": "Enter your questions/comments below",
      "Info": "(200 Character Maximum)",
      "TextAreaPlaceHolder": "Write something..",
      "ErrorText": "Questions/comments are mandatory field"
    },
    "EmailZingSuccessModal": {
      "Title": "Message sent to Zing<sup>®</sup> Marketplace",
      "TitleError": "Message error",
      "CloseText": "Close",
      "MainMessage": "Thank you for your interest.",
      "SecondaryMessage": "We will be contacting you shortly.",
      "MainMessageError": "Sorry, there was an error.",
      "SecondaryMessageError": "Please try again later.",
      "Close": "Close",
      "GoToCart": "Go to Cart"
    },
    "OrderConfirmationEmail": "We've sent a confirmation email with your order details to <span class=\"fw-bold\">{{ email }}</span>",
    "DiamondOrderComplete": {
      "OrderComplete": "Your order is confirmed and the transaction has been initiated.",
      "OrderConfirmation": "Order Confirmation",
      "ThankYouMess": "Thank you for your purchase!",
      "ImportantInstructions": "Important instructions",
      "ProceedWithTransaction": " to proceed with this transaction.",
      "WireInstruction1": "Wire the total transaction cost (including fees) within 2 business days to this unique account.",
      "WireInstruction2": "Instruct your bank to subtract any wiring fees from your account.",
      "WireInstruction3": "Email Marketplace@jminsure.com a copy of the wire transfer within 2 business days.",
      "InstructionMessage": "If the order is not funded within 2 business days, we can not guarantee the availability of the diamonds.",
      "NeedAdditionalDiamonds": "Need to purchase additional diamonds?",
      "StartNewSearchNow": "Start a New Search Now",
      "Bank": "Bank Name:",
      "AccountName": "Account Name:",
      "Address": "Address:",
      "AccountNumber": "Account Number:",
      "RoutingNumber": "Routing Number:",
      "ShippingInformation": "Shipping Information",
      "TransactionDetails": "Transaction Details",
      "OrderDetails": "Order Details",
      "DateOfSale": "Date of Sale:",
      "OrderStatus": "Order Status",
      "AccountAddress": "Account Address:",
      "AccountAddressValue": "24 Jewelers Park Drive <br />Neenah, WI 54956",
      "Funded": "Funded"
    },
    "CartInfo": {
      "PaymentSavings": "Payment Savings",
      "PriceReflected": "Price reflected when payment method selected.",
      "Saves": "Saves {{amount}}",
      "AchDiscount": "ACH Discounted Price",
      "WireTransferDiscount": "Wire Transfer Discounted Price"
    },
    "SupplyOrderForm": {
      "FraudStopperSecurityBags": "FraudStopper Security Bags",
      "SelectQuantity": "Select Qty",
      "SelectOne": "Select one",
      "CommentsPlaceholder": "Please leave us any comments regarding the supply order",
      "QuantitiesInfoMessage": "Please note: all supply quantities are subject to reduction based on history of usage.",
      "FraudStopperInfoMessage": "A shipping label for the above selected carrier and service will be made on your account to ship the FraudStopper bags. Your standard rates will apply. Once completed, the label's tracking number will appear below.",
      "FraudStopperTrackingNumber": "FraudStopper tracking number",
      "USPSSuppliesInfo": "USPS supplies can be ordered free of charge on",
      "USPSRegisterAccount": "To register for a free account",
      "AdditionalSuppliesInfo": "Additional supplies valid for all carriers. Purchase of these supplies will be a separate transaction type, which will not appear in your supply order history.",
      "AdditionalSuppliesUrlLabel": "Order Additional Supplies Here",
      "ShippingAddress": "Shipping Address",
      "SupplyOrders": "Supply Orders",
      "BackToDashboard": "Back to the Shipping Dashboard",
      "CreateNewSupplyOrder": "Create new Supply Order"
    },
    "ScanForm": {
      "Title": "USPS SCAN Form",
      "InfoMessage": "Select from Origin and Created By dropdown boxes to display all applicable USPS shipments, then select those shipments you want to include in the SCAN form. SCAN form(s) must be given to the carrier with the package(s).",
      "AlertMessage": "Registered Mail shipments are not included. Shipments cannot be voided once included on a SCAN form. Only the first 250 shipments will be included.",
      "OriginAddressFilter": "Origin Address Location",
      "GenerateDocument": "Generate SCAN form",
      "SelectedShipmentCount": "{{selectedShipmentNum}} of {{totalShipmentNum}} shipments selected to include in SCAN form",
      "EmailNotificationInfo": "A copy of SCAN form will be sent to your email.",
      "PrintPdf": "Print",
      "DownloadAndSave": "Download and Save"
    },
    "PackageAcceptance": {
      "Title": "Packages tendered at JMSS office",
      "ToViewPackageAcceptancePdf": "To view package acceptance pdf, please enter the desired date below.",
      "RunReport": "Run Report",
      "RequiredField": "This field is required"
    },
    "FirmBook": {
      "Title": "USPS Registered Mail Firm Book",
      "InfoMessage": "Select the Origin Location and who it was Created By to display the applicable USPS Registered Mail&trade; shipments. Once you have done  that you can select the shipments you want to include in the Firm Book.",
      "AlertMessage": "Please retain your Firm Book with proof of acceptance by the U.S. Postal Service in case you need to file an insurance claim. Without this, your insurance coverage may not be valid.",
      "DateFilterLabel": "Show only shipments from:",
      "GenerateDocument": "Generate Firm Book",
      "HideFirmBookShipments": "Hide Shipments already in a Firm Book",
      "SelectedShipmentCount": "{{selectedShipmentNum}} of {{totalShipmentNum}} shipments selected to include in FIRM Book"
    },
    "ScanFormGrid": {
      "ShipmentId": "Shipment ID",
      "ShipmentDate": "Ship Date",
      "TrackingNumber": "Carrier Tracking #",
      "Reference": "Reference",
      "ShipToCompany": "Ship to Company",
      "ShipToContact": "Ship to Contact",
      "ServiceType": "Service",
      "PackagingType": "Packaging",
      "DeclaredValue": "Declared Value",
      "TransactionDate": "Transaction Date",
      "EmptyGrid": "No Shipments"
    },
    "AppraisalPreferencesModal": {
      "DisplayLogo": "Display Logo",
      "DisplayLogoLabel": "Display logo in Appraisal Document",
      "UpdatePreferences": "Update Preferences",
      "GeneralTermsAndConditions": "General Terms and Conditions",
      "GeneralTermsAndConditionsPlaceHolder": "Any text entered here will be printed on the customer's appraisal document",
      "SetDefaultLocation": "Default Location for Appraisals",
      "Save": "Save changes",
      "Max500CharError": "500 characters maximum",
      "InvalidSpecCharsInserted": "Certain special characters are not allowed"
    },
    "ProductToolbar": {
      "Grid": "Grid",
      "List": "List",
      "SearchResultCount": "{{count}} Results found",
      "MaxCompareMsg": "Max {{maxCompareItems}} items.",
      "Min": "Min Price Per Carat:",
      "Avg": "Avg Price Per Carat:",
      "Max": "Max Price Per Carat:",
      "AllFilters": "All Filters"
    },
    "ProductNavigation": {
      "Home": "Zing Home",
      "Order": "Order Dashboard",
      "Search": "Search",
      "Lab": "Lab Diamonds",
      "Natural": "Natural Diamonds",
      "DiamondSearch": "Diamond Search",
      "PoweredByIdex": "Powered by Idex"
    },
    "ProductFilterModal": {
      "AllFilters": "All Filters",
      "ShowResults": "Show Results"
    },
    "SaveSearchModal": {
      "Title": "Save Search",
      "Description": "Save your current search parameters to easily access them later.",
      "Nickname": "Nickname (optional)",
      "NicknameError": "Enter nickname (50-character limit, including spaces and -). Special characters are not allowed.",
      "Note": "Note: To view your saved searches, tap 'View Saved Searches' on the previous screen.",
      "MaxLimit": "A maximum of 15 saved searches are allowed across lab grown and natural diamonds. Please delete a saved search to save a new one."
    },
    "ViewSavedSearches": {
      "Title": "Saved Searches",
      "Description": "Select a saved search to apply.",
      "NoSearches": "You haven't saved any searches yet. Saved searches will appear here."
    },
    "LabGrownOrderConfirm": {
      "OrderConfirmTitle": "Lab Grown Diamond Details",
      "ViewOrderStatus": "View My Order Status",
      "SpecialInstructionsLabel": "Optional note to the fulfillment team:",
      "NoneProvided": "None provided"
    },
    "NoResultsFound": {
      "NoResultsMsg": "Sorry, no results found",
      "ModifySearchMsg": "Please modify your search criteria."
    },
    "ReplacementLimitModal": {
      "AddTitle": "Unable to Add Item",
      "EditTitle": "Unable to Edit Item",
      "ModalContent": "A maximum of {{limit}} replacement value per order is allowed.",
      "ViewCart": "View Shopping Cart",
      "Ok": "OK"
    },
    "ShoppingCart": {
      "ContinueShopping": "Continue Shopping",
      "GoToCart": "Go to Cart",
      "ManageCart": "Manage Cart",
      "AddedToCartTitle": "Diamond Added to Shopping Cart",
      "AddedToCartMessage": "This item has been added to your cart.",
      "UnableToAddTitle": "Unable to Add a Diamond",
      "MaxDiamondsInCartMessage": "A maximum of {{limit}} diamonds are allowed in the shopping cart.",
      "Checkout": "Checkout",
      "Step1": "Review Cart Items",
      "Step2": "Billing and Shipping Details",
      "Step3": "Review and Pay",
      "OrderSummary": "Order Summary",
      "NextStep": "Next Step",
      "ShoppingCart": "Shopping Cart ({{itemCount}})",
      "NoItems": "You do not have any items in your cart.",
      "ClickToContinue": "Click here to continue shopping.",
      "SaveToFavorites": "Save to Favorites and Buy Later",
      "SearchSimilar": "Search for Similar Diamonds",
      "DiamondPrice": "Diamond Price",
      "UnavailableItem": "This item is no longer available.",
      "AGS": "AGS Supplier Diamond"
    },
    "RemoveCartItemConfirmationModal": {
      "Title": "Remove Item from Shopping Cart",
      "Body": "Are you sure you want to remove this item?"
    },
    "EndOfDayReportModal": {
      "Title": "End of Day Report",
      "NoShipmentsBody": "No shipments have been processed today to include on this report. Please try again after one or more shipments or insurance only transactions are purchased.",
      "Body": "This report lists all shipments (including insurance only) purchased today, grouped by carrier. Select the origin address for the shipments to include in the End of Day Report.",
      "CreateReport": "Create End of Day Report",
      "SelectLabel": "Filter by Origin Address"
    },
    "DateRangeLimitModal": {
      "Title": "Export date range limit exceeded",
      "Body": "The selected date range exceeds the maximum export limit of 366 days. Please adjust the range and try again."
    },
    "HighValueShipmentsApprovalModal": {
      "Title": "High-Value Shipment Notice",
      "Body": "This shipment has a declared value exceeding ${{value}}. To minimize potential risks and ensure faster approval, we suggest dividing shipments with multiple items into separate packages."
    },
    "ExtendedCoverageModal": {
      "Title": "New Expanded Coverage Option Available",
      "BodyIntro": "Choose our new <strong>Expanded</strong> option on the Quotes page to get:",
      "Bullet1": "Coverage at The UPS Store up to $75,000",
      "Bullet2": "6-month window to report claims"
    },
    "SelectAll": "Select All",
    "NoInsurance": "(no ins)",
    "Required": "Required",
    "ExportDetails": "Export Details",
    "TransactionParties": "Transaction Parties are Related",
    "ReasonForExport": "Reason for Export",
    "ContentType": "Content Type",
    "CustomsContentType": {
      "MERCHANDISE": "MERCHANDISE",
      "GIFT": "GIFT",
      "DOCUMENT": "DOCUMENT",
      "COMMERCIAL_SAMPLE": "COMMERCIAL SAMPLE",
      "RETURNED_GOODS": "RETURNED GOODS",
      "OTHER": "OTHER"
    },
    "ContentsDescritpion": "Contents Description",
    "ITNNumber": "ITN Number",
    "FedexITN": "FedEx requires ITN",
    "EEIExemptions": "EEI Exemptions",
    "ExportCompliance": {
      "Title": "Export Compliance",
      "Question": "Does this shipment require an Internal Transaction Number (ITN)?",
      "Explainer": "An ITN is a federal confirmation number showing that required information about an export shipment has been reported to and accepted by the U.S. government through the Automated Export System (AES). The federal government, not Jewelers Mutual, determines when an ITN is required, and the federal government issues an ITN through AES.",
      "Certification": "I certify this shipment qualifies for the exemption selected above. I understand that Jewelers Mutual will rely on this certification and that I am responsible for the accuracy of the information provided and for any fees, fines, penalties, delays, or seizure resulting from my incorrect claim of an exemption or my failure to provide a required ITN.",
      "ItnNeeded": "Yes, ITN is needed",
      "HasEeiExemption": "No, I have an EEI Exemption",
      "FileEeiPrefix": "File your Electronic Export Information (EEI) at",
      "FileEeiLinkText": "ace.cbp.gov",
      "FileEeiSuffix": "to receive your ITN.",
      "Itn": "ITN",
      "NewToItnFiling": "New to ITN filing? Review requirements and details",
      "NewToItnFilingLinkText": "here",
      "ExitAndSave": "You may exit and save your forms at any time to return to this quote once you have received your ITN.",
      "SelectExemptionReason": "Select your reason for exemption below:"
    },
    "Documents": "Documents",
    "CommercialInvoice": "Commercial Invoice",
    "DutiesAndTaxes": {
      "Header": "Duties & Taxes",
      "DutiesAndTaxes": "Duties & Taxes",
      "ArePaidOnDelivery": "Duties & Taxes are paid on delivery for Repair and Return shipments.",
      "ArePaidOnDeliveryResale": "Duties & Taxes are paid on delivery for Resale shipments.",
      "WhenUsingUSPS": "When using USPS as the carrier, Duties & Taxes are paid on delivery.",
      "TheRecipientWillBeResponsible": "The recipient will be responsible for paying import duties, taxes, and customs clearance when the order arrives. (Incoterm: Delivered at Place — DAP)",
      "WillBeCollectedInCurrencyOfDestination": "Duties & Taxes will be collected in currency of destination. Estimated amount of duties & taxes is not currently supported.",
      "PleaseEnsureTheRecipientIsAware": "<strong>Please ensure the recipient is aware of these charges.</strong>",
      "EstimatedDutiesAndTaxes": "Estimated Duties & Taxes",
      "NotCurrentlySupported": "Not currently supported",
      "HowWouldYouLikeToHandle": "How would you like to handle duties & taxes for this shipment?",
      "PrepaidLabel": "Prepaid Duties & Taxes",
      "Recommended": "Recommended",
      "PrepaidDescription": "You handle all import duties, taxes, and customs clearance in advance. (Incoterm: Delivered Duty Paid — DDP)",
      "AdvantagesTitle": "Advantages:",
      "Advantage1": "Hassle-free delivery",
      "Advantage2": "Reduced risk of loss",
      "Advantage3": "Enhanced recipient experience",
      "PrepaidNotice": "Duties and taxes amount will appear on the next page prior to purchase.",
      "PrepaidDisclaimer": "*This method is intended for business to consumer only, not for resale. If for resale, duties and taxes should be paid on delivery (DAP).",
      "DeliveryLabel": "Duties & Taxes paid on delivery",
      "DeliveryDescription": "The recipient will be responsible for paying import duties, taxes, and customs clearance when the order arrives. (Incoterm: Delivered at Place — DAP)",
      "DisadvantagesTitle": "Disadvantages:",
      "Disadvantage1": "Delay in customs",
      "Disadvantage2": "Unwillingness of recipient to pay",
      "Disadvantage3": "Return or abandonment at your expense",
      "DeliveryNotice": "Estimated duties and taxes will be collected in the currency of the destination country and will appear on the next page prior to purchase.",
      "LandedCostFluctuatons": "Landed cost is subject to exchange rate fluctuations.",
      "Total": "Total",
      "DDPServicesAgreement": "DDP Services Agreement ",
      "ServicesAgreementAccepted": "Your organization agreed to the ",
      "ServicesAgreementDate": "on {{date}}.",
      "IHaveReadTerms": "I have read, understood, and agree to the ",
      "IAgreeTerms": "By clicking ‘I Agree,’ you acknowledge that you have read, understood, and agree to be bound by our Terms of Service. If you do not agree, please click cancel.",
      "ModalOkBtn": "Ok"
    },
    "CertificateOfOrigin": "Certificate of Origin",
    "SED": "SED",
    "SEDOnly": "SED Only",
    "Commodities": "Commodities",
    "AddCommodities": "Add",
    "TotalItemValue": "Total Item Value",
    "NoCommodities": "No Commodities",
    "SkipIHaveForms": "Skip - I have my own forms",
    "ExitForms": "Exit Forms",
    "Next": "Next",
    "Previous": "Previous",
    "ITNMayRequired": "ITN Number may be required for shipments over $2,500",
    "ShipperTaxId": "Shipper Tax ID",
    "UltimateConsignee": "Ultimate Consignee",
    "IntermediateConsignee": "Intermediate Consignee",
    "UseIntermediateConsignee": "Use Intermediate Consignee",
    "ForwardingAgent": "Forwarding Agent",
    "UseForwardingAgent": "Use Forwarding Agent",
    "SEDRequirements": "SED Requirements for UPS",
    "SEDStatement1": "By entering my name below, I authorize UPS to act as forwarding agent for export control and customs purposes.",
    "SEDStatement2": "By entering my name below, I certify that all statements made and all information contained herein are true and correct and that I have read and understand the instructions for preparation of this document, set forth in the \"Correct Way to Fill Out the Shipper's Export Declaration.\"",
    "SEDStatement2Important": "I understand that civil and criminal penalties, including forfeiture and sale, may be imposed for making false or fraudulent statements herein, failing to provide the requested information or for violation of U.S. laws on exportation (13 U.S.C. Sec. 305; 22 U.S.C. Sec. 401; 18 U.S.C. Sec. 1001; 50 U.S.C. App. 2410).",
    "SEDSignaturePerson": "Duly Authorized Officer or Employee (full name)",
    "SEDSignaturePersonPlaceholder": "Duly Authorized Officer or Employee",
    "SEDSignatureTitle": "Your Title",
    "SEDSignatureTitlePlaceholder": "Title",
    "SEDSignaturePhone": "Telephone Number",
    "SEDSignaturePhonePlaceholder": "(XXX) XXX-XXXX",
    "SEDSignatureEmail": "Email",
    "TaxId": "Tax ID",
    "EORI": "EORI",
    "EORINote": "NOTE:  Customs paperwork for shipments to ",
    "EORINote2": " Norway, or Switzerland often requires the Economic Operations Registration and Identification (EORI) number of your recipient. To expedite customs clearance, enter your recipient's EORI into the field above. Only leave this blank if you have confirmed that your recipient is not subject to EORI requirements.",
    "EUCountries": "EU Countries,",
    "Quote": "Quote",
    "ImporterOfRecord": "Importer of Record",
    "UseRecipient": "Use Recipient",
    "Back": "Back",
    "Sender": "Sender",
    "TaxID": "Tax ID",
    "TaxIDType": "Tax ID Type",
    "RegistrationTypeDHL": "Registration Type",
    "IssuerCountry": "Issuer Country",
    "EORIIssuerCountry": "EORI Issuer Country",
    "Recipient": "Recipient",
    "ImporterOfRecordTINS": "Importer of Record TINS",
    "Unspecified": "Unspecified",
    "TollFreePhone": "Toll Free Phone",
    "AddFromAddressBook": "Add from Address Book",
    "InvoiceNumber": "Invoice Number",
    "PONumber": "PO Number",
    "PaymentTerms": "Payment Terms",
    "TermsOfSale": "Terms of Sale",
    "SpecialInstructions": "Special Instructions",
    "AdditionalCharges": "Additional Charges",
    "Insurance": "Insurance",
    "Freight": "Freight",
    "Handling": "Handling",
    "Discount": "Discount",
    "PackagingCost": "Packaging Cost",
    "OtherCharges": "Other Charges",
    "OtherChargeType": "Other Charge Type",
    "AdditionalChargesPlaceholder": "$0.00",
    "AddCommodityTitle": "Add/Update Commodity",
    "OriginCountry": "Country of Origin",
    "UnitValue": "Item Value",
    "EnterItemalue": "Enter Item Value",
    "CommodityInfoMessage": "Please provide a tariff code, description, and details for each separate item (commodity) in your shipment. Your entry from the previous page appears below, which you may edit, if necessary. To add more items, use the +Add button.",
    "PartNumber": "Part Number",
    "EuPid": {
      "SectionTitle": "EU Customs Identifiers",
      "MPid": "SKU / Part Number (M-PID)",
      "MPidPlaceholder": "Your internal item reference or catalog number",
      "NsPid": "Manufacturer Part Number (NS-PID)",
      "NsPidPlaceholder": "The part number assigned by the item's maker",
      "NsPidHelp": "For items you made yourself, enter your own product identifier.",
      "SPid": "Product Barcode (S-PID)",
      "SPidPlaceholder": "UPC / EAN / GTIN",
      "SPidHelp": "Reference the barcode found on your item's packaging (if one exists).",
      "NoBarcode": "No barcode",
      "NotApplicable": "Not applicable",
      "Exempt": "Exempt from EU product identifiers",
      "LockedBusinessRecipient": "Business recipient",
      "LockedDocumentsShipment": "Documents shipment",
      "ExemptGuidancePrefix": "For more information, reference",
      "ExemptGuidanceLinkText": "European Union law"
    },
    "MarksAndNumbers": "Marks and Numbers",
    "ExportLicenseCode": "Export License Number",
    "ExportLicenseDate": "Export License Date",
    "DetailedDescription": "Detailed Description",
    "ExportType": "Export Type",
    "ScheduleBUnit": "Schedule B Unit",
    "AddCommodity": "Add this Commodity",
    "UpdateCommodity": "Update this Commodity",
    "DetailedDescriptionPlaceholder": "Description - what it is, what it's made of, and what it's used for (35 character maximum)",
    "AdditionalDescription": "Additional Description",
    "ShipmentConfirmation": "Shipment Confirmation",
    "ShipmentCreated": "Shipment created successfully",
    "InsuranceSuccess": "Your shipment has been insured",
    "ReturnToDashboard": "Return to Dashboard",
    "AccessLabel": "Access Your Shipment Label",
    "InternationalDocuments": "International Documents",
    "DocumentsWarningBold": "You must include 3 copies of your commercial invoice with value declared in a pouch on the outside of the package.",
    "DocumentsWarning": " Additionally, 3 copies of a completed SED are almost always required for shipments valued over $2,500. Review specific customs requirements on the carrier’s site. Documents you requested for this shipment have been emailed to you or you can include your own.",
    "CreateInsuranceOnlyShipment": "Create Insurance Only Shipment",
    "InsuranceOnlyShipment": "Insurance Only",
    "SaveAndFinishLaterUppercase": "Save and Finish Later",
    "FedExPickupLocation": "FedEx Pickup Location",
    "HoldLocation": "Hold Location",
    "FedExPrintAndShip": "FedEx Print and Ship",
    "ChooseAPickupLocation": "Choose a Pickup Location",
    "ChangePickupLocation": "Change Pickup Location",
    "ShowingHFPUResults": "Showing {{locationCount}} results",
    "NoDestinationEntered": "No Destination Entered",
    "ShowingResultsNear": "Showing Results Near",
    "NoHFPULocationsFound": "We’re sorry, but we couldn’t find any Hold for Pickup locations within a 50-mile radius of your entered destination. Please ensure the address entered is correct. If the issue persists, consider choosing a different delivery option. You can close this window by clicking the ‘X’ in the top right corner.",
    "ChooseALocationBelow": "Choose a location below that allows pickups for the service you intend to use (Express or Ground) to avoid errors and possible shipment delays or returns. Express shipments (next day, two day) are generally available at all FedEx locations listed. Ground shipments are only available at select FedEx locations, as identified below.",
    "TroubleShootingTips": "Troubleshooting Tips",
    "Buy": "Buy",
    "BuyNow": "Buy Now",
    "SaveForLater": "Save for Later",
    "Essential": "Essential",
    "Expanded": "Expanded",
    "EssentialClaimInfo": "Price includes a 30-day window to report a claim when coverage applies.",
    "ExpandedClaimInfo": "Price includes coverage for your package while it's at The UPS Store (up to $75,000) and a 6-month window to report a claim.",
    "30DayClaim": "30-Day Claim",
    "6MonthClaim": "6-Month Claim",
    "ReportingWindow": "Reporting Window",
    "30DayClaimInfo": "Prices reflect insurance with a 30-day window from ship date (purchase) to report a claim/loss to us. JM block coverage, if applicable to this shipment, has the same 30-day reporting window.",
    "180DayClaimInfo": "Prices reflect insurance with a 6-month optional extension window from ship date (purchase) to report a claim/loss to us. JM block coverage, if applicable to this shipment, will extend the same 6-month reporting window.",
    "Review": "Review",
    "BuyInsurance": "Buy Insurance",
    "ShipmentInsuranceLabel": "Shipment Insurance",
    "Options": "Options",
    "SaturdayDelivery": "Saturday Delivery",
    "DontCover": "Don’t cover under block insurance policy",
    "DontCoverBlock": "Don't cover under block insurance policy",
    "COD": {
      "Secure": "Secure - Money Order or Cashiers Check",
      "Any": "Any - Cash, Check, Money Order, Cashiers Check",
      "CollectPaymentOnDelivery": "COD - Collect payment on delivery (FedEx only)",
      "PaymentType": "Payment Type",
      "PopoverText": "COD is available for FedEx domestic shipments of $50,000 or less. If FedEx is unable to collect payment, the shipment will be returned to the origin address. In addition to the label to your recipient, a label will be created to return your recipient’s payment to include in the COD pouch in your outbound package. Carrier surcharges apply.",
      "CODInformation": "Payment will be returned to origin: ",
      "Amount": "Amount",
      "CODAmount": "COD Amount",
      "Error": {
        "AmountRequired": "Amount is required",
        "MaxAmount": "Maximum value allowed is $50,000."
      }
    },
    "ThirdParty": {
      "ThirdParty": "Third Party",
      "Type": "Type",
      "PopoverText": "This option is available for UPS and FedEx domestic shipments. The carrier account number and postal code of the third party accepting the freight bill are required. Insurance costs (if applicable) and freight costs (if third party information is inaccurate) will be billed to your JM® Shipping Solution account.",
      "Account": "Third Party Account #",
      "Zip": "US Zip Code",
      "BillThirdPartyFedEx": "Bill third party (FedEx)",
      "BillRecipientFedEx": "Bill recipient (FedEx)",
      "BillThirdPartyUPS": "Bill third party (UPS)",
      "BillRecipientUPS": "Bill recipient (UPS)",
      "Error": {
        "AccountRequired": "Third Party Account # is required",
        "ZipRequired": "Zip Code is required",
        "TypeRequired": "Type is required"
      }
    },
    "Packaging": "Packaging",
    "PackagingDetailsLabel": "Packaging Details",
    "Carrier": "Carrier",
    "InternationalService": "International Service",
    "ShippingDetails": "Shipping Details",
    "Filter": "Filter",
    "ECommerce": "Web Store",
    "ECommerceCustomizeYourCheckout": "Customize your checkout with our {{storeName}} shipping integration",
    "ECommerceWelcomeToOutShippingSolution": "Welcome to our shipping platform, now integrated with {{storeName}}. This {{appType}} is designed to empower you to configure shipping methods tailored to your ecommerce checkout experience. With this integration, you can offer your customers a variety of shipping options directly at checkout. You control the shipping rates shown to your customers, using real-time quotes from your <i>JM</i> Shipping Solution account. Enhance your ecommerce business with our {{storeName}} shipping integration.",
    "ECommercePleaseFollowThePluginInstructions": "Please follow the {{appType}} installation instructions below to get started. <b>Before enabling the {{appType}} on your {{storeName}} site</b>, please review the full instructions, linked below, to ensure your defaults and shipment methods are set up.",
    "ECommerceInstallationInstructions": "Installation Instructions:",
    "WooCommerceInstructionsTittle": "Flexible Shipping. Real-Time Rates. JM<sup>&reg;</sup> Shipping Solution Plugin for WooCommerce.",
    "WooCommerceInstructionsText1": "Welcome to your smarter shipping solution. This plugin puts you in control - customize shipping methods, show real-time rates from your <i>JM</i> Shipping Solution account, and offer flexible delivery options right at checkout.",
    "WooCommerceInstructionsText2": "Start by installing the plugin using this guide. <b> Before enabling the plugin on your WooCommerce site</b>, please review the full instructions, linked below.",
    "WooCommerceInstallationStep1": "Log into your WooCommerce admin account in WordPress.",
    "WooCommerceInstallationStep2": "Navigate to Plugins > Add Plugin from the left sidebar.",
    "WooCommerceInstallationStep3": "Search for <i>JM</i> Shipping Solution.",
    "WooCommerceInstallationStep4": "Install Now.",
    "WooCommerceInstallationStep5": "Review the <a class=\"ecommerce-instructions-link\">JM WooCommerce Instructions</a> for setup details.",
    "WooCommerceInstallationStep6": "Then configure your store defaults and shipment methods.",
    "WooCommerceInstallationStep7": "Enable the app once setup is complete.",
    "ShopifyInstallationStep1": "Log in to your Shopify Admin account.",
    "ShopifyInstallationStep2": "Navigate to the <a href=\"https://apps.shopify.com/jm-shipping-solution-app\" target=\"_blank\" rel=\"noopener noreferrer\">JM Shipping Solution app listing</a>.",
    "ShopifyInstallationStep3": "Install the app.",
    "ShopifyInstallationStep4": "Review the <a class=\"ecommerce-instructions-link\">JM Shopify Instructions</a> for setup details.",
    "ShopifyInstallationStep5": "Then configure your store defaults and shipment methods.",
    "ShopifyInstallationStep6": "Enable the app once set up is complete.",
    "ShopifyTitle": "Flexible Shipping. Real-Time Rates. JM<sup>&reg;</sup> Shipping Solution App for Shopify.",
    "ShopifyBodyPart1": "Welcome to your smarter shipping experience. This app puts you in control—customize shipping methods, show real-time rates from your <i>JM</i> Shipping Solution account, and offer flexible delivery options right at checkout. Shipping is simpler for you, and better for your customers.",
    "ShopifyBodyPart2": "Shopify plans will indicate eligibility for 3rd-party calculated shipping rates—check the plan details to confirm if your plan qualifies. Start by installing the app using this guide.",
    "ECommerceIssues": "Contact support at <a href=\"mailto:{{email}}\">{{email}}</a> or {{phone}} with any issues.",
    "OldEcommBannerText": "Support for existing Shopify integrations will be ending soon. You will need to integrate again using our new Shopify app. Find instructions by clicking view more on the Shopify section.",
    "ShopifyBannerText": "Our new Shopify app is now available, and support for prior integrations will end soon. We will contact affected users with further instructions.",
    "ECommerceEncounterAnyIssues1": "If you encounter any issues during the installation, please reach out to our support team at",
    "EcommerceEncounterAnyIssues2": "shipping@jminsure.com",
    "ECommerceEncounterAnyIssues3": " or 855.474.4756.",
    "ECommerceInstructionFile": "<strong>Instruction File:</strong>",
    "ECommerceReviewOriginDefaults": "Please review the Origin Defaults, General Defaults, and set up your Shipment Methods. Refer to the JM {{storeName}} Instructions document for assistance.",
    "EcommerceOriginDefaultsForm": "The origin defaults shown below will be used for all imported orders and will appear on all shipment labels.  Please avoid using words related to jewelry, particularly in your company name, to avoid indicating valuable contents are included in the package. To override any defaults, enter desired information below. All future imported orders will use the updated content upon save. If you desire to apply the updates to any existing imported orders (label not yet purchased), be sure to select the option below.",
    "EcommerceGeneralDefaultsForm": "Please update and/or select general defaults for your shipments. Any updates made to these items will appear on all future orders imported.",
    "ECommerceEnableThisMethod": "Enable this method",
    "ECommerceEnableThisMethodInfo": "This method can also be enabled/disabled from the Shipment Methods tab.",
    "EcommerceNotificationEmail": "Do you want to send a notification email from our system to the recipient upon label purchase to notify them a shipment is headed their way? (Assumes the customer provides an email during checkout in your cart).",
    "EcommerceClaimReportingPeriod": "Claim reporting period",
    "EcommerceCoverageOption": "Coverage Option",
    "ECommerceOriginDefaultsForm": "The origin defaults shown below will be used for all imported orders and will appear on all shipment labels.  Please avoid using words related to jewelry, particularly in your company name, to avoid indicating valuable contents are included in the package. To override any defaults, enter desired information below. All future imported orders will use the updated content upon save. If you desire to apply the updates to any existing imported orders (label not yet purchased), be sure to select the option below.",
    "ECommerceShipmentMethodsForm": "Once the JM Shipping {{appType}} for {{storeName}} is active, the shipment methods you enable below will determine what shipping choices are shown at checkout. Please note that specific services, signatures, and packaging may be necessary for insuring high-value shipments. <strong>Consult the JM {{storeName}} Instructions document for comprehensive setup guidelines and tips.</strong>",
    "ECommerceNewFlatRateShipmentMethod": "New Flat Rate Shipment Method",
    "ECommerceNewPercentMarkupShipmentMethod": "New Percent Markup Shipment Method",
    "ECommerceEditFallbackaShipmentMethod": "Edit Fallback Shipment Method",
    "ECommerceEditPercentMarkupShipmentMethod": "Edit Percent Markup Shipment Method",
    "ECommerceEditFlatRateShipmentMethod": "Edit Flat Rate Shipment Method",
    "ECommerceEditFlatRateInfo": "Set a fixed shipment price according to the cart subtotal. During checkout, customers will see the shipment method’s name, description, and price. For instance, to offer free shipping, input the desired name and description, specify a minimum cart subtotal of $0, leave the maximum as None, and set a flat rate of $0.00.",
    "ECommercePercentMarkupInfo": "Set the shipment price as a percent markup added to your shipment cost. During checkout, customers will see the shipment method’s name, description, and price. For instance, to show a shipment price equal to your shipment cost for all cart subtotals, put the desired name and description, specify a minimum cart subtotal of $0, leave the maximum as None, and set the percent markup to 0%.",
    "ECommerceFallbackInfo": "Set a fixed shipment price according to the cart subtotal. During checkout, customers will see the shipment method’s name, description, and price. For instance, to offer free shipping, input the desired name and description and set a flat rate of $0.00.",
    "ECommerceShipmentMethodName": "Shipment Method Name",
    "ECommerceDescription": "Description",
    "ECommerceMinCartSubtotal": "Min cart subtotal",
    "ECommerceMaxCartSubtotal": "Max cart subtotal",
    "ECommerceFormFlatRateAmount": "Flat rate amount",
    "ECommerceFormPercentMarkup": "Percent markup",
    "ECommerceSolutionPlugin": "JM Shipping Solution plugin is ",
    "ECommerceUseForPreviousOrdersCheckboxLabel": "Use the information above for all previously imported orders (label not yet purchased).",
    "ECommerceSolutionEnabled": "enabled",
    "ECommerceSolutionDisabled": "disabled",
    "ECommerceNewMethodButton": "New Method",
    "ECommerceNewMethodInfo": "Hover/Tap for a description of the method.",
    "ECommerceNewMethodInfoFlat": "Shipment price will be a flat amount.",
    "ECommerceNewMethodInfoPercent": "Shipment price will be a percent markup over your shipment cost.",
    "ECommerceNewMethodFlatRate": "Flat Rate",
    "ECommerceNewMethodPercentMarkup": "Percent Markup",
    "ECommerceShowOnlyEnabledMethods": "Show Only Enabled Methods",
    "ECommerceFallback": "Fallback",
    "ECommerceFlatRate": "Flat Rate:",
    "ECommercePercentMarkup": "Percent Markup:",
    "ECommerceNoMax": "No max",
    "ECommerceCartSubtotalRange": "Cart Subtotal Range:",
    "ECommerceCarrierService": "Carrier/Service:",
    "ECommerceAreYouSureYouWantToDelete": "Are you sure you want to delete this shipment method?",
    "ECommerceCannotBeUndone": "This action cannot be undone.",
    "WooCommerceInstructions": "JM WooCommerce Instructions",
    "ECommerceInstructions": "JM {{storeName}} Instructions",
    "WooCommercePlugin": "JM WooCommerce Plugin",
    "Results": " results",
    "Delivery": "Delivery",
    "ApprovalCodeJM": "Approval Code provided by JM<sup>®</sup> Shipping Solution",
    "IHaveAJMApprovalCode": "I have an Approval Code provided by JM<sup>®</sup> Shipping Solution",
    "ApprovalCodePlaceholder": "Enter Approval Code",
    "ScheduleUPSPickup": "Schedule UPS Pickup",
    "ScheduleFedExPickup": "Schedule FedEx Pickup",
    "SubmitUPSPickup": "Submit UPS Pickup",
    "SubmitFedExPickup": "SUBMIT FedEx PICKUP",
    "QuoteUPSPickup": "Quote UPS Pickup",
    "QuoteFedExPickup": "QUOTE FedEx PICKUP",
    "UPSPackageDetails": "UPS Package Details",
    "FedExPackageDetails": "FedEx Package Details",
    "OptionalLocation": "Location (Optional)",
    "Location": "Location",
    "Pickup": "Pickup",
    "ExpressAndGroundShipmentsNote": "For Express shipments, pickups can be scheduled for the current or next business day. For Ground shipments, pickups can be scheduled for the next business day or any business day or later (up to two weeks in advance).",
    "ParcelLimit": "Are any parcels over {{quantity}}lbs?",
    "PackageQuantity": "Package Quantity",
    "ReadyTime": "Ready Time",
    "CloseTime": "Close Time",
    "ResidentialPickup": "Residential Pickup",
    "SchedulePickupAddress": "Schedule Pickup Address",
    "RecentlyScheduledPickups": "View recently scheduled pickups",
    "ServiceType": "Service Type",
    "DateOfPickup": "Date of Pickup",
    "FutureDayQuote": "Future Day Quote",
    "SameDayQuote": "Same Day Quote",
    "DefaultShippingAddress": "Default Shipping Address",
    "ClaimSubmission": "Claim Submission",
    "NoDocumentsAttached": "No supporting documents attached.",
    "NoReportProvided": "No police report info provided.",
    "Braintree": {
      "PaymentMethods": "Payment Methods",
      "NoPaymentMethods": "You have no payment methods on file",
      "AddNew": "Add New",
      "AddNewPaymentMethod": "Add New Payment Method",
      "Default": "Default",
      "SetAsDefault": "Set as default",
      "Delete": "Delete",
      "ChoosePaymentMethod": "Choose a Payment Method",
      "CreditCardInformation": "Credit Card Information",
      "NameOnCard": "Name on Card",
      "NameOnCardRequired": "Enter valid name on card",
      "CardNumber": "Card Number",
      "CardNumberRequired": "Enter valid card number",
      "ExpirationDate": "Expiration Date",
      "ExpirationDateRequired": "Enter valid expiration date",
      "CVV": "CVV",
      "CVVRequired": "Enter valid CVV number",
      "Nickname": "Nickname (optional)",
      "EnterBillingAddress": "Enter Billing Address",
      "CreditCardDisclaimer": "In some cases a $1.00 authorization charge may temporarily apply as we secure preauthorization for potential future payments on your account.",
      "CreditCard": "Credit Card",
      "ACH": "ACH/Bank Account",
      "Cancel": "Cancel",
      "MakeDefaultPaymentMethod": "Set as default payment method",
      "AchAuthorizationDisclaimer": "By clicking “Save” I authorize Braintree, a service of PayPal, on behalf of JM Facets, LLC to verify my bank account information using bank information and consumer reports and I authorize JM Facets, LLC to initiate an ACH/electronic debit to my checking/savings account. Depository Name: {{bankName}}, Routing Number: {{routingNumber}}, and Account Number: {{accountNumber}}, that will be stored on file, and debited on or after the due date. I agree the ACH transactions I authorize comply with all applicable laws.<br><br>I understand that this authorization will remain in full force and effect until I notify JM Facets, LLC that I wish to revoke this authorization.",
      "SomethingWentWrong": "Something went wrong, please try again.",
      "ErrorAddingPaymentMethod": "There was a problem adding your payment method.",
      "PaymentMethodAddedSuccessfully": "Payment method added successfully.",
      "AccountInformation": "Account Information",
      "AccountType": "Account Type",
      "Personal": "Personal",
      "Business": "Business",
      "Checking": "Checking",
      "Savings": "Savings",
      "BusinessName": "Business Name",
      "AccountNumber": "Account Number",
      "RoutingNumber": "Routing Number",
      "BankName": "Bank Name",
      "Expired": "Expired",
      "Next": "Next: Billing Information",
      "SavePaymentMethod": "Save Payment Method",
      "BillingInformation": "Billing Information",
      "DefaultPaymentMethodUpdated": "Default payment method has been updated.",
      "MethodHasBeenAddedSuccessfully": "Your new payment method has been added.",
      "MethodHasBeenAdded": "Your new payment method has been added and will be used for future purchases if set as the default.",
      "ChoosePaymentMethodTitle": "Choose a payment method",
      "AddPaymentMethodTitle": "Add a payment method",
      "PaymentMethodAddedTitle": "Payment Method Added",
      "ErrorAddingPaymentMethodTitle": "Error Adding Payment Method",
      "AccountOwnership": "Account Ownership",
      "Errors": {
        "AchError": "Sorry, the bank account was not charged but you may still complete this transaction with an alternative account or payment method. This transaction was declined based, at least in part, on consumer reporting data obtained from Giact Systems, LLC. Giact did not make the decision to decline this transaction and is unable to provide the specific reasons why the transaction was declined. You have the right to obtain a free copy of your consumer report from Giact if you make a request within 60 days and you have the right to dispute the accuracy or completeness of the information with Giact by contacting them: Giact Systems, LLC 700 Central Expy. S, Suite 300 Allen, TX 75013 1-866-918-2409",
        "DefaultError": "There was an error adding your payment method. Please check your details and try again.",
        "AccountNumberRequired": "Account Number must be numeric and of valid length.",
        "RoutingNumberRequired": "Routing Number must be numeric and of valid length.",
        "FirstNameRequired": "First Name is required.",
        "LastNameRequired": "Last Name is required.",
        "BankNameRequired": "Bank Name is required.",
        "BusinessNameRequired": "Business Name is required.",
        "RemovingOrChangingDefaultPaymentMethod": "There was a problem changing or removing your default payment method. Please review and try again, or call us at {{phone}} for assistance in resolving the issue.",
        "NotAbleToAddNewPaymentMethod": "We were not able to add your new payment method. Please try again later. If the issue persists, please call us at {{phone}} for assistance.",
        "NotAbleToAddBankAccount": "<div class=\"d-flex flex-column\"><span class=\"pb-1rem\">Sorry, the bank account was not charged but you may still complete this transaction with an alternative account or payment method. This transaction was declined based, at least in part, on consumer reporting data obtained from Giact Systems, LLC. Giact did not make the decision to decline this transaction and is unable to provide the specific reasons why the transaction was declined. You have the right to obtain a free copy of your consumer report from Giact if you make a request within 60 days and you have the right to dispute the accuracy or completeness of the information with Giact by contacting them: </span><span class=\"mt-2\">Giact Systems, LLC</span><span>700 Central Expy. S, Suite 300</span><span>Allen, TX 75013</span><span>1-866-918-2409</span></div>"
      },
      "SetAsDefaultModal": {
        "BodyText": "Are you sure you want to set this as your new default payment method? <br/> <br/> All future charges will be applied to this new payment method."
      },
      "RemovePaymentMethodModal": {
        "Header": "Remove Payment Method",
        "DefaultBodyText": "You are removing your default payment method. Please select a new default to use for future purchases.",
        "NonDefaultBodyText": "Are you sure you want to remove this payment method?",
        "RemoveOnlyMethod": "Are you sure you want to remove your only payment method?",
        "NewDefaultLabel": "New Default Payment Method",
        "CancelButton": "Cancel",
        "ConfirmButton": "Remove",
        "ConfirmSelectButton": "Select and Remove",
        "SuccessBannerText": "Payment method removed",
        "ErrorBannerText": "There was a problem changing or removing your default payment method. Please review and try again, or call us at {{ phoneNumber }} for assistance in resolving the issue.",
        "AddPaymentMethod": "You will need to add a new payment method once again before purchasing labels.",
        "YourAccountHasAnOutstandingBalance": "Your account has an outstanding balance of {{ balance }}. Removing your only payment method on file will prompt an immediate processing of this amount."
      }
    },
    "ImportContacts": {
      "ImportAddresses": "Import Address(es)",
      "InvalidAddresses": "Invalid Address(es)",
      "DownloadTemplate": "Download Template",
      "UploadContacts": "Upload Contacts",
      "Instructions": "Instructions",
      "Step1": "Select \"Download Template\" and save to your computer/device.",
      "Step2": "Add your customer contact information in the columns provided (headers indicate required and optional fields). If required are not complete, you will receive an error while uploading.",
      "Step3": "Save the completed file.",
      "Step4": "Select \"Upload Contacts\" and choose your saved file.",
      "Success": "The addresses were imported successfully!",
      "Invalid": "One or more of the address records has invalid data as shown. Please update or delete the impacted records, save the file to your computer and upload again.",
      "IncorrectFile": "Incorrect file uploaded. Please use the template provided. Make sure the file extension is .xlsx.",
      "IncorrectHeadersMessage": "There are errors in the .xlsx file that you uploaded. Please make sure that the number of columns or headings are not changed.",
      "IncorrectFileType": "Incorrect File Type",
      "IncorrectHeaders": "There are Errors Found",
      "Ok": "OK"
    },
    "FedexIntegration": {
      "Errors": {
        "RequiredAccountNumber": "Account number is required",
        "RequiredAccountName": "Customer or company name is required",
        "RequiredAddressLine1": "Address line 1 is required",
        "RequiredCity": "City is required",
        "RequiredState": "State is required",
        "RequiredZipCode": "Zip code is required",
        "RequiredCountryCode": "Country code is required",
        "RequiredNickname": "Nickname is required",
        "RequiredInvoiceNumber": "Invoice number is required",
        "RequiredInvoiceAmount": "Invoice amount is required",
        "RequiredInvoiceDate": "Invoice date is required"
      },
      "FedexStepsNextCTA": {
        "Overview": "Get Started",
        "Licensing": "I accept the terms of FedEx EULA",
        "Account": "Continue to Verification",
        "Verify": "Send Verification Code",
        "Invoice": "Continue with Invoice",
        "Confirm": "Confirm Account"
      },
      "InternationalDocumentationGuideTitle": "FedEx International Documentation Guide",
      "FedexServicePermission": "FedEx service marks are owned by Federal Express Corporation and are used by permission",
      "Acknowledgement": "I have read and acknowledge this agreement",
      "FedExIntegrationSetup": "FedEx Integration Setup",
      "AccountAlreadyIntegrated": "Your account is already integrated.",
      "UsingForDomesticAndInternational": "You're currently using the following account for domestic and international shipments:",
      "UsingForInternationalOnly": "You're currently using the following account for international shipments:",
      "ReviewAgreement": "Review the",
      "AgreementSignedOn": "{{name}} signed on {{date}}",
      "EndUserAgreementLink": "FedEx End User Agreement",
      "UseThisFormToIntegrateFedExAccount": "Use this form to integrate your own FedEx account into this platform so that quotes and purchases are reflective of your FedEx account rates. FedEx will invoice you for freight costs.",
      "BeforeYouBegin": "Before you begin, please have the following information ready:",
      "YourFedExAccountDetails": "Your own U.S. based FedEx account details",
      "AccessToFedExEmailOrPhone": "Access to your FedEx registered email or phone for verification",
      "BrandedLetterheadAndSignature": "Your branded letterhead and signature for international shipment documentation",
      "InternationalInstructions": {
        "InstructionsText": "Shipping internationally? Download the ",
        "InstructionsLink": "International Documentation Guide",
        "PrepareYourBrandedLetterheadAndSignature": " to prepare your branded letterhead and signature before you begin. Having these ready will help avoid delays at customs.",    
        "HasIntegrationInstructionsText": "Shipping internationally? Make sure the required documentation is ready. Download the ",
        "HasIntegrationInstructionsLink": "FedEx International Documentation Guide",
        "InstructionsOnPreparingYourBrandedLetterheadAndSignature": " for instructions on preparing your branded letterhead and signature."
      },
      "FedExInvoice": "FedEx invoice from the last 90 days (optional, for alternate verification)",
      "Verify": {
        "Title": "Multi-Factor Authentication",
        "Subtitle": "Select a verification method to help us authenticate your account.",
        "PhoneCall": "Phone Call",
        "PhoneCallDescription": "Receive an automated call with a verification code",
        "SMSTextMessage": "SMS Text Message",
        "SMSTextMessageDescription": "Receive a text message with a verification code",
        "Email": "Email",
        "EmailDescription": "Receive an email with a verification code",
        "FedExInvoice": "FedEx Invoice",
        "FedExInvoiceDescription": "Verify using details from a FedEx invoice provided within the last 90 days",
        "LockoutWarning": "Multiple unsuccessful validation attempts will cause the validation method to be locked for 24 hours."
      },
      "VerifyLabel": {
        "PhoneCall": "phone call",
        "SMSTextMessage": "SMS text message",
        "Email": "email"
      },
      "TechSupportMessage": "We are unable to process this request. Please try again later or call FedEx Customer Service and ask for technical support. Once you receive assistance, you'll need to restart the integration process.",
      "FedexAccount": "FedEx Account",
      "Integration": "Integration",
      "IntegrationActive": "Integration Active",
      "FedexAccInt": "FedEx Account Integration",
      "BodyPt1": "Use this form to integrate your own FedEx account into this platform so that quotes and purchases are reflective of your FedEx account rates. FedEx will invoice you for freight costs. Insurance, if requested from this platform, will be billed by us.",
      "BodyPt2": "To proceed, please follow ",
      "BodyPt3": "these instructions (PDF)",
      "BodyPt4": " carefully to create your FedEx meter number, enter the required information, and Submit. During the integration process, we will run a test quote against your account to confirm the information provided is valid. If you encounter issues and need assistance, please contact us at shipping@jminsure.com or 855-474-4756.",
      "AllDomestic": "All domestic ",
      "AllInternational": "All international ",
      "AllDomesticAndInternational": "All domestic and international ",
      "RemoveIntegration": "quotes will use your account rating. If you want to remove this integration, please contact us at <a href='mailto:shipping@jminsure.com' class='text-decoration-underline'>shipping@jminsure.com</a>.",
      "AccountSuccessfullyIntegrated": "Account Successfully Integrated",
      "IntegrationSuccessfulPt1": "With your account integrated into this platform, you’ll continue to work directly with FedEx regarding tracking, redirects, return to sender requests, address corrections and supply ordering. You may schedule pickups from this platform.",
      "IntegrationSuccessfulPt2": "If you've not already done so, we also encourage you to proactively establish safeguards with FedEx to:",
      "IntegrationSuccessfulPt3": "Restrict individuals authorized to make changes with your packages.",
      "IntegrationSuccessfulPt4": "Establish a directive with FedEx that they are not to leave undelivered packages with a non-FedEx staffed location (ie : Walgreens, Dollar General, etc.) for pickup, as insurance does not extend to those situations.",
      "AccountName": "Account Name",
      "AccountNickname": "Account Nickname",
      "AccountNumber": "FedEx Account Number",
      "MeterNumber": "FedEx Meter Number",
      "Domestic": "Domestic",
      "International": "International Only",
      "DomesticAndInternational": "Domestic and International",
      "AppliesTo": "FedEx Account Integration applies to:",
      "AccountNameError": "Invalid Account Name. Account Name should contain maximum of 10 characters.",
      "AccountNumberError": "Invalid Account Number. Account Numbers should contain 9 numbers, without any spaces or dashes.",
      "MeterNumberError": "Invalid Meter Number. Meter Numbers should contain 7-9 numbers, without any spaces or dashes.",
      "AppliesToError": "Please select an option that FedEx Account Integration applies to.",
      "AccountNumberPlaceholder": "Enter your 9-digit FedEx account number",
      "EnterAccountInformation": "Enter your account information exactly as it appears within the FedEx account you are integrating.",
      "CustomerOrCompanyName": "Customer or Company Name",
      "CustomerOrCompanyNamePlaceholder": "Enter the name as it appears on your FedEx invoices",
      "UseAccountFor": "Use this FedEx account for",
      "UseAccountForAllShipments": "All shipments (domestic and international)",
      "UseAccountForInternationalShipments": "International shipments only",
      "AccountInfo": "FedEx Account Information",
      "AccountDetails": "Account Details",
      "AddressLine1Placeholder": "Street address",
      "AddressLine2Placeholder": "Apartment, suite, etc.",
      "ZipCode": "ZIP Code",
      "ZipCodePlaceholder": "ZIP",
      "CountryCode": "Country Code",
      "CountryCodePlaceholder": "US",
      "IsResidentialAddress": "This is a residential address",
      "ShippingAccountConfiguration": "<i>JM</i> Shipping Solution Account Configuration",
      "Nickname": "Nickname (internal use)",
      "NicknamePlaceholder": "e.g., Main Warehouse",
      "EnterVerificationCode": "Enter Verification Code",
      "VerificationCodeSent": "A 6-digit verification code has been sent via {{verificationMethod}}",
      "PinCode": "6-Digit PIN Code",
      "DidntReceivePin": "Didn't receive a PIN code?",
      "ResendPin": "Resend PIN",
      "InvoiceVerification": "Invoice Verification",
      "InvoiceVerificationDescription": "Enter details from a FedEx invoice you've received within the last 90 days.",
      "InvoiceNumber": "Invoice Number",
      "InvoiceNumberPlaceholder": "Invoice number",
      "Currency": "Currency",
      "InvoiceDate": "Invoice Date",
      "InvoiceDatePlaceholder": "YYYY-MM-DD",
      "InvoiceAmount": "Invoice Amount",
      "InvoiceAmountPlaceholder": "$0.00",
      "InvoiceVerificationInfo": "This information will be verified against your FedEx account records.",
      "AllSet": "You're All Set!",
      "IntegrationComplete": "FedEx account integration is complete."
    },
    "UPSIntegration": {
      "UPSAccount": "UPS Account",
      "Header": "UPS Account Integration",
      "IntegrationActive": "Integration Active",
      "Content1": "To integrate your UPS account to use for label purchases, please email <span class=\"roboto-bold\">one</span> of your last three invoices (must be within the last 75 days) to <a class=\"text-decoration-underline\" href=\"mailto:shipping@jminsure.com\">shipping@jminsure.com</a>. Please make sure the following information is included:",
      "Item1": "Shipper Number",
      "Item2": "UPS Control ID",
      "Item3": "Invoice Date",
      "Item4": "Invoice Number",
      "Item5": "Invoice Amount",
      "Content2": "You will be notified via email when integration is complete (may take up to three business days for processing time).",
      "Content3": "Labels purchased prior to integration will be charged via JM<sup>®</sup> Shipping Solution.",
      "Content4": "Once integrated, all labels purchased for UPS will be applied to your account and any insurance purchased will be charged to your <i>JM</i> Shipping Solution account. ",
      "IntegratedAccount": "Below is your currently integrated UPS Account Number. If you have any questions, or would like to remove this integration, please contact us at <a href='mailto:shipping@jminsure.com' class='text-decoration-underline'>shipping@jminsure.com</a>.",
      "AccountNumber": "Account Number: "
    },
    "BatchImport": {
      "BatchImportInformation": "Batch Import Information",
      "ProcessManyShipments": "Do you process many (25+) shipments each day and can easily export shipment details from your system?",
      "ExploreAnOption": "Would you like to explore an option to import shipment details in bulk for insurance only or shipment labels with insurance?",
      "IfSoContactUs": "If so, contact us to learn how Batch Import can simplify your workflow. It allows you to easily upload a file to purchase insurance on multiple shipments or set up multiple shipments to purchase labels individually or in bulk from your Saved Shipment dashboard when you're ready to ship.",
      "NotNow": "Not now",
      "InstructionsBtn": "Instructions",
      "UploadFileBtn": "Upload a File",
      "InstructionsModalTitle": "Instructions",
      "InstructionsModalContent": "A sample import template is provided for your reference. Please collaborate with our development team to properly map your system data to our required shipment details. More detailed instructions are also provided for your reference.",
      "SampleShipments": "Sample_Shipments.xlsx",
      "DetailedInstructions": "Detailed_Instructions.pdf",
      "UploadModalTitle": "Upload a File",
      "UploadDropzoneAdditionalText": "File types accepted: xls, xlsx or csv only",
      "UploadingTo": "Uploading to:",
      "PleaseSelectAProfile": "Please select a profile first",
      "SelectAProfile": "Select a profile...",
      "ValidatingFilePleaseWait": "Validating file. Please wait...",
      "ValidatingFile": "Validating File",
      "FileValidated": "File Validated",
      "YourFileHasBeenValidated": "Your file has been validated. Please ensure this is the correct file before continuing, as this cannot be undone.",
      "DetectedPotentialSecurityThreat": "We've detected a potential security threat in your file and cannot complete the upload. This is a safety measure to protect your account and our systems. Please scan your file with antivirus software before attempting to upload again.",
      "AnErrorHasOccured": "An error has occured.",
      "TheFileCouldNotBeValidated": "The file could not be validated. Please resolve the following and try again.",
      "Error": "Error",
      "RowCount": "Row Count",
      "EmailRecipientsModalTitle": "Select Email Recipients",
      "EmailRecipientsInformation": "Notify others when a file is processed by entering their email addresses below.",
      "EmailAddress": "Email Address:",
      "AddEmail": "Add",
      "InvalidEmail": "Invalid email format",
      "DuplicateEmail": "Duplicate email",
      "ProcessFile": "Process File",
      "FileName": "File Name",
      "BatchTable": {
        "BatchId": "Batch ID",
        "FileName": "File Name",
        "UploadDate": "Upload Date",
        "UploadedBy": "Uploaded by",
        "RowSuccess": "Row success",
        "RowError": "Row error"
      },
      "LastUpdated": "Last updated ",
      "AllFileUploads": "All File Uploads",
      "FilesOlderThan12Months": "Files older than 12 months are deleted.",
      "FileProcessingModalTitle": "Processing File",
      "FileProcessingModalContent": "Once processing is complete, your file will apear in your Batch Import File Uploads listing.",
      "FileProcessingSuccess": "Your file is being processed."
    },
    "PickupDate": "Pickup Date",
    "PickupAddress": "Pickup Address",
    "PickupCarrierId": "Carrier ID",
    "PickupStatus": "Status",
    "CancelledPickup": "Cancelled",
    "CancelPickup": "Cancel Pickup",
    "PurchaseTimeoutTitle": "Thank you for your patience",
    "PurchaseTimeoutBody": "Your request is taking longer than expected, likely due to heavy volumes. Please wait for your transaction to complete to avoid duplicate charges.",
    "ShipmentOriginAddress": "Shipment Origin",
    "ShipmentDestinationAddress": "Shipment Destination",
    "WhatToDoWithAddress": "What would you like to do with this address information?",
    "CreateAddressBookEntry": "Create a new address book entry",
    "Or": "OR",
    "UpdateExistingAddressBookEntry": "Update the existing address book entry",
    "UpdateExistingAddressBookEntryAndDontCheckAgain": "Update the existing address book entry so this check will not be performed again.",
    "CheckWillNotBePerformedAgain": "If you select Use entered address, this check will not be performed again.",
    "MakeDefaultAddress": "Make this my default address",
    "ChangesWillNotBeSaved": "Changes will not be saved until you advance to the next screen.",
    "SelectDateRange": "Select a Date Range",
    "CreatedDate": "Created Date",
    "TransactionDate": "Transaction Date",
    "DashboardFilters": {
      "Statuses": "Select Statuses",
      "ECommerce": "Select Web Store"
    },
    "ShipmentActions": {
      "EmailShipmentLabel": "Email Shipment Label",
      "EmailAddress": "Email Address",
      "EnterYourEmailAddress": "Enter your email address",
      "MarkAsDelivered": "Mark as Delivered",
      "DeleteShipment": "Delete Shipment",
      "EditShipment": "Edit Shipment",
      "ShipmentDetails": "Shipment Details",
      "ShipmentLabel": "Shipment Label",
      "VoidShipment": "Void Shipment"
    },
    "FNOLText": "In accordance with Shipping Terms and Conditions you previously agreed to, this is a courtesy reminder that all claims must be filed within five (5) days after discovery of any loss or damage; and no more than 30 days from the date of tender of the shipment to the Carrier. Failure by the recipient to report damage, loss, or non-receipt does not excuse compliance with this requirement.",
    "ReminderFNOL": "Reminder - Acknowledgment of Time Limit for Filing Claims",
    "ECommLabel": "Ecommerce",
    "EcommerceHomeLabel": "Ecommerce Home",
    "ContinueToIShip": "Continue to iShipJM.com",
    "UploadTaxCertificateModal": {
      "Criteria-v2": "Uploads must meet the following criteria:",
      "FileTypeRule-v2": "PDF format",
      "FileSizeRule-v2": "5 MB maximum size",
      "SecurityScanRule-v2": "Pass security scan",
      "HelpNumber": "Or call {{helpdeskNumber}} for assistance.",
      "Upload": "Upload",
      "Cancel": "Cancel",
      "ProceedAnyway": "Proceed Anyway",
      "Continue": "Continue",
      "Note": "Note:",
      "NoteText": "Only Business Administrators may manage exemptions.",
      "TaxDocumentText": "Tax exemption documentation is required to waive taxes on auction items and natural and lab grown diamonds wherever your company operates.",
      "EffectiveDates": "Effective Dates",
      "ExpiringTaxExemptionText1": "Your",
      "ExpiringTaxExemptionText2": "current tax exemption certificate",
      "ExpiringTaxExemptionText3": "for",
      "ExpiringTaxExemptionText4": "is still active until",
      "InProgress": "In Progress",
      "PendingApproval": "Pending Approval",
      "ExpiresSoon": "Expires Soon",
      "Expired": "Expired",
      "Active": "Active",
      "MississippiResellerPermitTooltip": "Mississippi locations require a Reseller Permit.",
      "SignDocument": "Sign Document",
      "NeedsAttention": "Needs Attention",
      "RejectReasonTooltip": "Your tax exemption couldn't be approved. Check your email for details, then submit a new form for review.",
      "ShowPreview": "Show Preview",
      "RedirectModal": "You will be transferred from Zing Marketplace to Docusign to sign your tax exemption. Tax exemptions are required to shop tax-free on the Marketplace. Do you want to continue?"
    },
    "DocumentSubmitSuccess": {
      "Title": "You're all set!",
      "SuccessMessage": "Your documents have been submitted for review and will be processed in the next 2-3 business days.",
      "ActionRequest": "Close this tab to return to the Zing® platform."
    },
    "DocumentInProgress": {
      "Title": "Your progress has been saved",
      "InProgressMessage": "You can return at any time to complete this form.",
      "ActionRequest": "Close this tab to return to the Zing® platform."
    },
    "Dropzone": {
      "DragAndDrop": "Drag and Drop the file here",
      "DragAndDropFiles": "Drag and Drop the files here",
      "Or": "or",
      "SelectFile": "Select File",
      "SelectFiles": "Select Files",
      "FileSelected": "{{count}} File Selected",
      "FilesSelected": "{{count}} Files Selected",
      "FileUploaded": "{{count}} File Uploaded",
      "FilesUploaded": "{{count}} Files Uploaded",
      "BrowseFile": "Browse File",
      "DragAndDropLogo": "Drag and Drop Logo Here"
    },
    "InvalidFileFormat": "The file type you are attempting to upload <span class=\"roboto-bold\">({{fileName}})</span> is not allowed.",
    "InvalidFileName": "The name of the file you are attempting to upload <span class=\"roboto-bold\">({{fileName}})</span> has invalid characters.",
    "InvalidFileSize": "The file you are attempting to upload <span class=\"roboto-bold\">({{fileName}})</span> exceeds the 5MB size limit.",
    "InfectedFile": "The file <span class=\"roboto-bold\">({{fileName}})</span> was not loaded, because it is considered unsafe.",
    "UploadAndAttachDocuments": "Upload and Attach Documents",
    "Upload&AttachDocuments": "Upload & Attach Documents",
    "PleaseAttachClaimDocuments": "To expedite the review of your claim, please attach documentation to support the loss and value of your claim (invoice, memo, sales receipt, etc.).",
    "PoliceReportRequiredIfTheft": "Police report will be required if a crime was committed and for loss of Rolex or GIA products. If you don't have it now, include with your supporting documentation at a later time.",
    "PoliceReportDetails": "You may submit the police report details later if it is unavailable now.",
    "SupportedClaimDocuments": "Supported Documents formats are .jpg, .jpeg, .png, .pdf, .doc, .docx, .gif, .xls, .xlsx",
    "DocumentSizeLimit": "Individual document size cannot exceed 5 MB",
    "TotalSizeLimit": "Total size for all attached documents should not exceed 15 MB",
    "UpTo10Documents": "Up to 10 documents can be attached",
    "Only1FileSelection": "Only 1 file selection is allowed",
    "SearchAddressBook": "Search Your Address Book",
    "FrequentlyUsed": "Frequently Used",
    "TapForPreview": "(Tap for preview)",
    "LoadFromAddressBook": "Load from Address Book",
    "AddNewAddress": "Add New Address",
    "SearchForContact": "Search for Contact",
    "DatePlaceHolder": "MM/DD/YYYY",
    "EnterApiSecret": "Enter API Secret",
    "EnterApiKey": "Enter API Key",
    "EditShipmentDetails": "Edit Shipment Details",
    "ShipmentDetailsPrice": "Declared Value of ",
    "ShipmentDetailsInvoice": "Invoice Value of ",
    "ShipmentDetailsCarriers": "Carriers: ",
    "ShipmentDetailsServices": "Services: ",
    "ShipmentDetailsPackageTypes": "Package Types: ",
    "ShipmentDetailsDeliveryConfirmation": "Delivery Confirmation: ",
    "AtLeastOneRequired": "(at least one is required)",
    "ChooseOnePlaceholder": "Choose one...",
    "PackagingSelection": "Packaging Selection",
    "PackageType": "Package Type",
    "FedExOneRate": "FedEx One Rate<sup>®</sup>",
    "UseFedExOneRate": "Use FedEx One Rate<sup>®</sup> for Quotes (Carrier packaging only)",
    "Reference1": "Reference 1",
    "Reference2": "Reference 2",
    "PrintOnLabel": "Print on label",
    "AddSecondarySealNum": "Add Secondary Seal #",
    "PackageDimensions": "Package Dimensions",
    "Length": "L (in)",
    "Width": "W (in)",
    "Height": "H (in)",
    "EnterOriginAndDestination": "Please enter Origin and Destination",
    "PhoneNumberPlaceholder": "Example: 1234567890",
    "ArmoredTransport": "Armored Transport",
    "ReviewT&C": "Review T&C",
    "ReviewTermsAndConditions": "Review the Terms and Conditions",
    "ReviewTermsAndConditionsMobile": "Review T&C",
    "QuotesResults": "Quotes Results",
    "CarrierBrandStatement": "Carrier service marks, names and logos are registered trademarks of their respective owners, and their use is for identification purposes only. Reference to any specific product, service, trade name, trademark, logo, or otherwise does not constitute recommendation or endorsement by any party.",
    "PricesDoNotIncludeDutiesAndTaxes": "<strong>Note:</strong> Prices do not include Duties and Taxes.",
    "OriginDestinationDetails": "Origin, Destination and Details",
    "DeclaredValueForInsurance": "Declared Value for Insurance",
    "EstimatedDeliveryDate": "Estimated Delivery By",
    "BlockPolicy": "Block Policy",
    "BlockPolicyOtherInsurance": "Block Policy/<br>Other Insurance",
    "BlockPolicyInsuranceOnly": "Block Policy/Other Insurance",
    "AdditionalInsurance": "Additional Insurance",
    "InsuranceFromThisPlatform": "Insurance From This Platform",
    "RequiredUponBuyNow": "Security Bag Seal required upon Buy Now",
    "ErrorMessage": "Error Message",
    "ValidQuotes": "Valid Quotes",
    "WithErrors": "With Errors",
    "QuotesWithErrors": "Quotes with Errors",
    "NoQuotesReturned": "No quotes returned",
    "PossibleCauses": "Possible causes",
    "ShipmentDetailsResultedNoQuotes": "Shipment details selection that resulted in no quotes.",
    "YouMayWishTo": "You may wish to ",
    "ModifyShipmentDetails": "modify your shipment details",
    "AndTryAgain": " and try again.",
    "EditRequiredLinkText": "Incomplete - ",
    "EditRequiredLinkAction": "Continue",
    "ConnectionError": "A connection error.",
    "CarrierOrDevice": "Either with the carrier or with your device.",
    "TryAgain": "Try again",
    "NoValidQuotesReturned": "No valid quotes returned",
    "Please": "Please",
    "ReviewQuotesWithErrors": "review quotes returned with errors",
    "IdentityChangesOnShipmentDetails": "to identify changes that may be needed on your shipment details.",
    "Then": "Then",
    "GoBackModifyShipmentDetails": "go back to modify your shipment details",
    "PurchaseUnable": "Unable to Complete Purchase",
    "ClientNotApprovedTitle": "Thank you for enrolling!",
    "ClientNotApprovedText": "In compliance with Known Shipper Regulations, our Customer Support Team will contact you shortly to activate your account fully and help you start shipping and saving. <br><br> Meanwhile, you can explore the system and make quotations. For urgent activation, please call (855) 474-4756 or email shipping@jminsure.com. <br><br> Your shipment has been saved and will appear as a Saved Shipment on the Shipment Dashboard page.",
    "UnexpectedPurchaseError": "<b>An unexpected error is preventing the purchase from being completed.</b> <br><br> Error Message <br><br> {{error}}",
    "RefreshQuotes": "Refresh Quotes",
    "EnterNewAddress": "Enter New {{addressType}}",
    "HoldForPickupLocation": "Hold for Pickup at FedEx Location",
    "HoldForPickup": "Hold For Pickup",
    "HoldForPickupAddressChanged": {
      "DestinationChange": "Destination Change",
      "ByChangingTheDestination": "By changing the destination address you will need to confirm/update your hold for pick up location.",
      "CurrentHoldLocation": "Current Hold Location",
      "FedexPickupLocation": "FedEx Pickup Location",
      "ConfirmHoldLocation": "Confirm Hold Location",
      "UpdateHoldLocation": "Update Hold Location"
    },
    "NewZing": {
      "ToggleButton": "Try Zing's new look!",
      "ModalTitle": "Switch to New Experience",
      "ModalBodyParagraph1": "You're about to switch to the new Zing experience. Your data and settings will remain intact, and you can opt out of the new beta experience at any time.",

      "SwitchButton": "Try it out",
      "StayButton": "Stay"
    },
    "AllCarriers": "All carriers",
    "FedExUPSOnly": "FedEx and UPS only",
    "MarkStatusAsDelivered": "Mark status as delivered",
    "UpdateLogo": "Update Logo",
    "MarkAsDeliveredModal": {
      "Header": "Mark as delivered",
      "BodyText": "<b>WARNING!</b> You are about to mark this shipment as Delivered.This action should be taken only if you are certain that a package reached its destination successfully.<b>THIS ACTION CANNOT BE UNDONE.</b><br><br>Are you sure you wish to mark this shipment as Delivered?"
    },
    "CreateReturnLabel": "Create Return Label",
    "SendShipmentNotification": "Send shipment notification",
    "Reconciliations": {
      "TrackingNumber": "Tracking #",
      "ReconApply": "Reconciliations apply&nbsp;•&nbsp;",
      "ReconListing": "Reconciliation Listing",
      "ShipmentId": "Shipment ID",
      "PurchasedOn": "Shipment Date",
      "ReconciledOn": "Reconciliation Date",
      "ReconAmount": "Recon Amount",
      "FromCompany": "From",
      "ToCompany": "To",
      "ToContact": "To",
      "Carrier": "Carrier",
      "Service": "Service"
    },
    "ReconSummary": {
      "ReconciliationAmount": "Reconciliation Amount",
      "AdditionalCharges": "The carrier found changes in your shipment details resulting in additional charges, as described below:",
      "ShipmentInformation": {
        "Title": "Shipment Information",
        "Id": "Shipment ID",
        "TrackingNumber": "Tracking #",
        "TransactionDate": "Transaction Date",
        "Carrier": "Carrier/<wbr>Service",
        "From": "From",
        "To": "To"
      },
      "ChargeSummary": {
        "Title": "Charge Summary",
        "OriginalCharge": "Original Charge",
        "ReconciliationCharge": "Reconciliation Charge",
        "ReconCharge": "Recon Charge",
        "TotalCharges": "Total Charges",
        "Invoice": "Invoice",
        "Pending": "Pending"
      },
      "HelpfulTopics": {
        "Title": "Helpful Topics",
        "Intro": "It's important that the details you enter about your shipment are accurate. Please refer to the following information for guidance."
      },
      "Review": {
        "Title": "Request a Review",
        "CommentLabel": "If you would like to dispute these charges, please enter your comments below. A member of our logistics team will contact you with a response.",
        "CommentPlaceholder": "Maximum 150 characters",
        "SendButtonText": "Send",
        "ReviewReceived": "Your request for a dispute review has been received. After review, a response will be sent to you via email."
      },
      "UsefulTopics": [
        {
          "Title": "Dimensional/Billable Weight",
          "Description": "Dimensional weight considers how much space a package occupies in relation to its actual weight. Visit the carrier site to determine how dimensional weight is calculated. Ultimately, the greater of actual weight or dimensional weight is what will be billed for your shipment. Avoid dimensional weight shipping charge corrections by indicating correct package dimensions and making sure that the box does not bulge out on any size due to contents that are too large for the box. Additionally, you may see a large fee for UPS 2 day service, which is most likely due to using a different carrier box than you indicated during label creation. Specifically, this will occur if you selected a Small or Medium Carrier Box but ultimately used a Large Carrier Box for your UPS 2 day shipment, or in certain instances where your entered package dimensions for a Custom Box were understated."
        },
        {
          "Title": "Oversized Packages",
          "Description": "Visit carrier site to determine maximum package size (packages can generally be up to 150 lbs., up to 165\" length + girth, or up to 108\" length) . To measure packages, determine the length (longest side) and girth (2x width + 2x height)."
        },
        {
          "Title": "Additional Handling",
          "Description": "Additional Handling charges will be applied in certain scenarios based on carrier requirements. Typically these occur due to oversized packages (weight or package size)."
        },
        {
          "Title": "Residential Surcharge",
          "Description": "Residential surcharges will apply for shipments delivered to a home or home-based business in a residential area. To avoid reconciliations for residential deliveries, ensure the \"Residential\" box is checked for all residential destinations when entering the shipment details."
        },
        {
          "Title": "Incorrect Weight",
          "Description": "If the actual weight of the package is different than what you entered for shipment details, you may see a reconciliation apply. To avoid weight charge corrections, use a standard scale and round up any fraction of a pound to the next full pound during entry."
        },
        {
          "Title": "Fuel Surcharge",
          "Description": "The fuel surcharge is related to fluctuating fuel prices and can apply when weight and address corrections result in reconciliations. The fuel surcharge is added due to the package detail discrepancies."
        }
      ]
    },
    "PaymentDetailsPage": {
      "PaymentDetailsTitle": "Payment Details",
      "BackToOrderDetails": "Back to the Order Details",
      "PaymentType": "Payment Type",
      "WireTransfer": "Wire Transfer",
      "ACH": "ACH",
      "CreditCard": "Credit Card",
      "PayNow": "Pay Now",
      "AccountHolderName": "Account Holder Name",
      "EnterAccountHolderName": "Account Holder Name",
      "ErrorAccountHolderName": "Enter account holder name (100-character limit)",
      "AccountHoldersEmailAddress": "Account Holder's Email Address",
      "EnterHoldersEmailAddress": "Email",
      "ErrorAccountHoldersEmailAddress": "Enter account holder email address (50-character limit)",
      "ProcessingMessage": "We are processing your payment.<br> Please do not close or refresh this page.",
      "Accept": "Accept",
      "Reject": "Reject",
      "AchLinkingErrorMessage": "We are not able to process the payment details entered. Please try again with a different account or use other payment options.",
      "PaymentErrorMessage": "We are not able to process the payment details entered. Please use other payment options.",
      "PaymentLimitExceededMessage": "We are not able to process the payment details entered. Please try again with a different account or use other payment options. If additional assistance is needed, please call 1-833-970-9464.",
      "PaymetErrorMessageWithPhoneNumber": " We are not able to process the payment details entered. Please use other payment options. If additional assistance is needed, please call 1-833-970-9464.",
      "CCPaymentErrorMessage": "Your payment was not successful. Please try again.",
      "CCPaymentErrorMessageWithReason": "Your payment was not successful for the following reason: {{message}} Please try again.",
      "ACHSelectedMessage": "ACH funded orders will ship once funds are secured, which is typically 5 business days.",
      "WireTransferSelectedMessage": "Wire Transfer funded orders will ship once funds are secured, which is typically 3 business days.",
      "CCSelectedMessage": "Credit Card funded orders will ship once funds are secured, which is typically 2 business days.",
      "Discount": "discount will apply",
      "ServicingFeesMessage": "Servicing fees vary per payment type.",
      "Disclaimer": "By providing your card information, you allow Zing by Jewelers Mutual Group® Marketplace to charge your card."
    },
    "SaveQuote": "Save Quote",
    "Declined": "Declined",
    "PurchaseError": "Purchase Error",
    "EditYourShipmentDetails": "edit your shipment details",
    "SelectForBuy": "Select for Buy",
    "SelectShipmentsToBuy": "Select Shipments to Buy",
    "BuySelected": "Buy Selected",
    "SelectForDelete": "Select for Delete",
    "SelectShipmentsToDelete": "Select Shipments to Delete",
    "DeleteSelected": "Delete Selected",
    "DeleteShipments": "Delete Shipments",
    "TheSelectedShipments": "The selected shipments will be deleted. This action can not be undone.",
    "DeleteXShipments": "Delete {{number}} Shipments",
    "DesktopPrinter": "Desktop Printer",
    "LabelPrinter": "Label Printer",
    "ShippingLabels": {
      "Label1": "8.5” x 5.5”, 2 per page",
      "Label2": "4” x 6” Label, no tab",
      "Label3": "4” x 6” Label, 3/4” tab",
      "Label4": "4” x 6” Label, 2” tab"
    },
    "ShippingLabelsSuccessMessage": "Your label preference has been saved' & in the mean while all other radio buttons will be disabled",
    "LabelsAndPrinting": "Labels & Printing",
    "AMLOption": "Anti-Money Laundering (AML) Compliance",
    "PrintingLabels": {
      "None": "None",
      "NoTAB": "No_TAB",
      "ThreeQuarterInchTab": "Three_Quarter_Inch_Tab",
      "TwoInchTab": "Two_Inch_Tab"
    },
    "LabelPurchase": {
      "30Day": "30-Day",
      "6Month": "6-Month",
      "ProcessingPurchase": "Processing purchase",
      "ClaimReportingWindow": "Claim Reporting Window",
      "Of": "of",
      "ProcessingComplete": "Processing complete",
      "PrintAll": "Print All",
      "PrintingHelpTitle": "Label Printing Help",
      "PrintAllButtonTitle": "Print All button",
      "PrintAllButtonText": "Enabled when all purchases have been processed. Opens a new browser tab containing a single PDF document with all labels, one label per page.",
      "PrintAllButtonText2": "Once this tab is closed, you will only be able to access your labels individually from the Shipment Details screen of each shipment. Please do not close or reload this browser tab until all purchases have been processed and you have printed your labels.",
      "SuccessfulPurchaseTitle": "Successful shipment purchase",
      "SuccessfulPurchaseText": "Indicates the shipment was successfully purchased and the label will be included in the PDF of all labels.",
      "ErrorPurchaseTitle": "Error encountered with purchase",
      "ErrorPurchaseText": "Indicates the shipment was not purchased and is not available to print due to an error. To resolve the error, access the shipment from the Saved Shipments tab on your main dashboard."
    },
    "SaturdayAlertMessage": "Saturday shipments are surcharged by most carriers. That surcharge is NOT included in the quoted price, but would be billed later.",
    "RemoveEStore": {
      "Header": "Remove Web Store Connection ",
      "Body": "The connection to {{webStoreName}} will be removed. <br><br> <b>All imported shipments in a saved state (i.e., label not yet purchased) will be removed from the Shipment Summary grid.</b> <br><br> Are you sure you wish to remove the connection to this store?"
    },
    "RemoveShipStationEStore": {
      "Header": "Remove ShipStation Connection",
      "Body": "Are you sure you wish to remove the connection to ShipStation?"
    },
    "LabGrownCheckoutPayment": {
      "CCPaymentErrorMessage": "Your payment was not successful. Please try again.",
      "CCPaymentErrorMessageWithReason": "Your payment was not successful for the following reason: {{message}} Please try again.",
      "PaymentErrorMessage": "We are not able to process the payment details entered. Please contact customer support by calling 1-833-970-9464 or emailing zing@jminsure.com  to resolve the issue. Thank you for your patience.",
      "PaymentSystemError": "System error. Please ",
      "TryAgain": "try again",
      "PaymentSystemErrorLimitReached": "System error. Please contact customer support by calling 1-833-970-9464 or emailing zing@jminsure.com to resolve the issue. Thank you for your patience."
    },
    "Appraisal": {
      "EmailPreview": {
        "Hello": "Hello <b>{{customerName}},</b>",
        "Disclaimer": "By clicking the link to get a quote, you move to the Jewelers Mutual Group website. {{appraiserName}} is not a licensed agent of Jewelers Mutual Group and does not sell or recommend insurance. Any coverage is subject to acceptance by the insurer and to policy terms and conditions. Insurance coverage is offered by a member insurer of the Jewelers Mutual Group, either Jewelers Mutual Insurance Company, SI (a stock insurer) or JM Specialty Insurance Company. <br /> Policyholders of both insurers are members of Jewelers Mutual Holding Company.",
        "ThankYou": "Thank you",
        "ForTrusting": "for trusting me with your recent {{documentTitle}}.",
        "NowThatYour": "Now that your {{jewelryType}} {{beVerb}} appraised, I encourage you to protect {{objectPronoun}} for peace of mind. <br /> <b>Jewelers Mutual<sup>®</sup> Group,</b> a company that I know and trust, has been insuring jewelry since 1913 and offers peace of mind so you can wear your jewelry without worry.",
        "AndIfYouEver": "And, if you ever file a claim, you get to work with your preferred jeweler ... us!",
        "GetAQuote": "GET A QUOTE ►",
        "ItsAQuickWay": "It's a quick and simple way to get jewelry insurance from the experts.",
        "WarmRegards": "Warm regards,"
      }
    },
    "LabGrownDiamonds": {
      "Title": "Diamond Search",
      "Returnable": "Returnable",
      "NewReturnableTooltip": "This diamond may be returned within 20 days of receipt. Fees for returns may vary. Shipping fees are non-refundable. See return policy for details.",
      "InitiateReturn": "Initiate Return",
      "ShoppingCart": {
        "ShoppingCartTitle": "Shopping Cart",
        "LabGrownDiamonds": "Lab Grown Diamonds",
        "EmptyLgdCart": "Your shopping cart is empty.",
        "MaxItems": "A maximum of {{limit}} diamonds are allowed in the shopping cart.",
        "DeliveryDetails": "Delivery Details",
        "DeliveryLocation": "Delivery Location",
        "Location": "Location {{locNumber}}:",
        "Company": "Company:",
        "Contact": "Contact:",
        "Address": "Address:",
        "DeliveryMethod": "Delivery Method",
        "StandardShipping": "Standard",
        "ShippingContactInformation": "Shipping Contact Information",
        "MobilePhone": "Mobile Phone",
        "InvalidPhoneNumber": "A valid phone number is required",
        "OrderSummary": "Order Summary",
        "TotalDiamondPrice": "Total Diamond Price",
        "Shipping": "Shipping",
        "Tax": "Tax",
        "TotalTransactionCost": "Total Transaction Cost",
        "SpecialInstructions": "Special Instructions",
        "OptionalNote": "Optional note to the fulfillment team",
        "PlaceOrder": "Place Order",
        "MaxCharacters": "Maximum 200 characters",
        "ContinueShopping": "Continue Shopping",
        "ReturnPolicy": "Our Return Policy",
        "NewReturnPolicyText": "<ul style='margin-top0.5rem;'><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>We offer <strong>20 days from receipt to return</strong> eligible lab grown diamonds to the supplier for a full refund.</li><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>Original shipping costs are non-refundable.</li><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>Refunds are processed after supplier authentication.</li></ul><strong style='line-height:1.25rem;margin-top:0.5rem;'>Free Return Shipping:</strong><ul><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>For a fair process for buyers and suppliers, we offer <strong>4 free returns</strong> per calendar month.</li><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>A $35 return fee per diamond will be deducted from the refund after the 4th return.</li></ul><strong style='line-height:1.25rem;margin-top:0.5rem;'>Required Return Condition:</strong><ul><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>Diamonds must be in original condition and include all accompanying certificates.</li><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>Incomplete, inaccurate, or shipments received <strong>after 20 days</strong> will be returned to you.</li></ul><strong style='line-height:1.25rem;font-size:0.875rem;margin-top:1rem;'>Important Note:</strong><span style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'> This policy outlines the lab grown diamond return and refund process. It does not guarantee acceptance or refunds in all cases.</span>",
        "AuthenticationGuarantee": "Authentication Guarantee",
        "AuthenticationGuaranteeText": "Every diamond is authenticated before shipping to verify the correct diamond is delivered. Diamond images and additional details, if not in the listing, can be obtained by emailing the Zing® Marketplace team prior to submitting your order.<br/><br/>Quality control preferences can be provided for a customized authentication review. We will contact you prior to delivery if we find any discrepancies between the selected diamond and your preferences.",
        "NewAuthenticationGuaranteeText": "All diamonds are authenticated before shipping. Please email the Zing<sup>®</sup> Marketplace team before purchase for images, videos, details not in the listing, or specific quality control preferences. Buyers will be notified of any quality discrepancies before shipping.",
        "CartItem": {
          "GradingLab": "Grading Lab:",
          "ReportNumber": "Report Number:",
          "Shape": "Shape:",
          "Clarity": "Clarity:",
          "Carat": "Carat:",
          "Color": "Color:",
          "Supplier": "Supplier:",
          "Location": "Location:",
          "ReturnEligibleUntil": "Return Eligible if Received by:",
          "ReturnEligibleTooltip": "If a return is necessary, the supplier must receive the diamond by this date",
          "EstimatedDelivery": "Estimated Delivery:",
          "RemoveFromCart": "Remove from Cart",
          "Remove": "Remove",
          "Returnable": "Returnable:",
          "SearchForSimilar": "Search for Similar",
          "LabGrown": "Lab Grown",
          "Days": "Business Days",
          "PriceChange": "Price Change",
          "DiamondPrice": "Diamond Price:",
          "Status": "Status:",
          "TrackPackage": "Track package",
          "ConfirmedTooltip": "The supplier has confirmed the order for this diamond and will begin the shipping process.",
          "NotAvailTooltip": "Unfortunately, the supplier alerted us that this diamond is now unavailable. This can happen when a diamond is available for purchase on more than one marketplace. A full refund will post to your original payment method within 5-10 business days. Email confirmation will follow.",
          "RefundTooltip": "The supplier has informed us that this diamond is no longer available. This can occur when diamonds are listed on multiple marketplaces.  We’ve processed a full refund for this diamond.",
          "RefundInitiatedTooltip": "The supplier has informed us that this diamond is no longer available. This can occur when diamonds are listed on multiple marketplaces. We’re processing a full refund for this diamond.",
          "ReturnInitiatedTooltip": "Check your email for return shipping label and additional instructions from the supplier.",
          "ReturnedTooltip": "Your return was received and accepted. Check your email for refund updates.",
          "ReturnRejectedTooltip": "We’ve encountered an issue with your return(s).  Check your email for further details and next steps."
        },
        "InCart": "IN CART",
        "ListInCart": "IN CART",
        "ItemAdded": "1 item has been added to the Shopping Cart",
        "ViewShoppingCart": "View Shopping Cart",
        "UnableToAdd": "Unable to Add Diamond to Cart",
        "Ok": "OK",
        "Payment": {
          "StripeFormFooterMessage": "By providing your card information, you allow Zing by Jewelers Mutual Group® Marketplace to charge your card.",
          "Processing": "We are processing your payment. <br> Please do not close or refresh the page."
        },
        "PriceChanged": "The price has changed for one or more items in your cart.  Please review before placing the order.",
        "UnavailableItemsTitle": "These items are no longer available",
        "UnavailableItems": "The following items are no longer available for purchase.",
        "TotalRefundedAmount": "Total Refunded Amount",
        "TotalRefundedTooltip": "The refunded amount includes the diamond price and tax if applicable. If you have exceeded your 4 free returns, a return fee of $35 per diamond was deducted from the refund.",
        "TotalRefundedTooltipUpdated": "The refunded amount includes the diamond price and tax if applicable. A $35 return fee per return shipment was deducted from the refund. Multiple items may be returned in the same shipment to avoid additional fees."
      },
      "MainFilters": {
        "Color": "Color",
        "Clarity": "Clarity",
        "Carat": "Carat"
      },
      "MoreOptions": {
        "MoreFiltersTitle": "More Filters",
        "FewerFiltersTitle": "Fewer Filters",
        "MoreOptionsTitle": "More Options",
        "FewerOptionsTitle": "Fewer Options",
        "Make": "Make",
        "Cut": "Cut",
        "CutGrade": "Cut Grade",
        "Polish": "Polish",
        "Symmetry": "Symmetry",
        "Fluorescence": "Fluorescence",
        "FluorescenceColor": "Fluorescence Color",
        "FancyColor": "Fancy Color",
        "ShadeAndLuster": "Shade and Luster",
        "Shade": "Shade",
        "Brown": "Brown",
        "Green": "Green",
        "Blue": "Blue",
        "Gray": "Gray",
        "OtherShade": "Other Shade",
        "Luster": "Luster",
        "Other": "Other",
        "Girdle": "Girdle",
        "TreatmentType": "Treatment Type",
        "Proportions": "Proportions",
        "Parameters": "Parameters",
        "To": "to",
        "TablePercent": "Table %",
        "DepthPercent": "Depth %",
        "Ratio": "Ratio",
        "PresetRatio": "Preset Ratio",
        "Length": "Length",
        "Width": "Width",
        "Crown": "Crown",
        "Pavilion": "Pavilion",
        "Height": "Height"
      },
      "ClearAllFilters": "Clear all filters",
      "OrderDetails": {
        "LabGrownDiamondDetails": "Lab Grown Diamond Details",
        "NaturalDiamondDetails": "Natural Diamond Details"
      },
      "SpecialInstructions": {
        "Title": "Special Instructions",
        "OptionalNote": "Optional note to the fulfillment team:",
        "NoneProvided": "None provided"
      },
      "DeliveryDetails": {
        "Title": "Delivery Details",
        "DeliveryLocation": "Delivery Location:",
        "DeliveryMethod": "Delivery Method:"
      },
      "PaymentDetails": {
        "Title": "Payment Details",
        "PaymentType": "Payment Type:",
        "PaymentStatus": "Payment Status:"
      },
      "ReturnOptionModal": {
        "Header": "Reason for Return",
        "Label": "What is the reason you are returning this diamond?",
        "Feedback": "Feedback is valuable for improving our service.",
        "TypeReason": "Type reason",
        "SelectReason": "Please provide a reason for your return.",
        "Cancel": "Cancel",
        "Submit": "Submit",
        "Counter": "{{value}}/{{maxLength}}",
        "RequiredField": "Required field"
      },
      "SuccessReturnRequestModal": {
        "Header": "Success",
        "Body": "Your return has been initiated. You’ll receive an email with the return instructions and shipping label.",
        "Button": "OK"
      },
      "FailsReturnRequestModal": {
        "Header": "Return Request Failed",
        "Body": "We're having trouble sending your request. Please try again. <br> Email zing@jminsure.com  or call 1-833-970-9464 if the issue continues.",
        "Button": "OK"
      }
    },
    "DiamondSearchSortOptions": {
      "DiamondLowToHigh": "Price Low to High",
      "DiamondHighToLow": "Price High to Low",
      "CaratLowToHigh": "Carat Low to High",
      "CaratHighToLow": "Carat High to Low"
    },
    "Update": "Update",
    "TaxDocuments": {
      "Title": "Tax Documents",
      "BLA/BUContent": "Contact your business administrator to manage tax exemptions.",
      "ViewDocument": "View Document"
    }
  },
  "Success": {
    "PartnerAffiliations": {
      "AGS": "You are now an AGS member"
    },
    "ChangedPassword": "Your password has been successfully updated",
    "2FASuccessful": "Authentication Successful.",
    "UpdatedCompanyDetails": "Your company details updated successfully.",
    "UpdatedPersonalDetails": "Your Personal Details are updated successfully",
    "UpdatedLocationDetails": "Location details updated successfully",
    "LocationAdded": "Location has been added successfully",
    "PhoneNumberCodeResend": "Text message with code for phone number confirmation sent.",
    "EmailLinkResend": "Email with link for email confirmation sent.",
    "EmployeeSelfRegistrationRequestMessage": "An email notification has been successfully sent to the business administrator to approve your membership.",
    "NewCompanyCreationOnLinking": "Your business is successfully registered and role has been changed to Business Administrator.",
    "FEINIdPopulated": "We were able to successfully pull your FEIN ID based on details provided. Please verify.",
    "MemberApproved": "Employee's request for registration is approved successfully",
    "MemberUpdated": "Employee details updated successfully",
    "MemberActivated": "User activated successfully",
    "MemberDeactivated": "User deactivated successfully",
    "InvitationSent": "Invite Sent Successfully!",
    "InvitationResent": "Email with invitation resent",
    "InvitationRemoved": "Invitation removed",
    "LocationActivated": "Location activated successfully",
    "LocationDeactivated": "Location deactivated successfully",
    "ImBusinessOwner": "You have successfully registered as a business administrator.",
    "InviteBusinessOwner": "An email notification has been successfully sent to your business owner.",
    "ContactAdded": "Your contact has been added successfully.",
    "ContactModified": "Your contact has been modified successfully.",
    "ContactDeleted": "Your contact has been successfully deleted.",
    "ContactFavorite": "Your contact has been successfully added to favorites",
    "ContactUnFavorite": "Your contact has been successfully removed from favorites",
    "ShipmentSuccess": "Your shipment has been created successfully!",
    "ShareLabelSuccess": "Shipment Label email sent.",
    "EmailDocumentsSuccess": "Email with shipment documents has been sent successfully.",
    "BillingReviewSuccess": "Your request to review the shipment charges is successfully submitted.",
    "PaymentMethodUpdated": "Your payment details have been saved successfully",
    "PaymentMethodSaved": "You may now close this modal. This payment method can now be used to make your purchase.",
    "ClaimSuccess": "Your claim has been submitted successfully!",
    "BoomerangShipmentSuccess": "Your Boomerang shipment has been created!",
    "EmailDetails": "Shipment Details email sent.",
    "LabelInstructionsSaved": "Label Printing Instructions successfully sent.",
    "BusinessInsuranceEmailSentSuccess": "Thank you for your interest. We will be contacting you shortly.",
    "EmailDiamondDetails": "Email(s) with diamond details have been sent successfully.",
    "RequestReturnEligibility": "Your Return Eligibility request has been sent successfully.",
    "EmailSent": "Email sent successfully on ",
    "EmailResent": "Email resent successfully on ",
    "EmailSentSuccessfully": "Email sent successfully.",
    "AppraisalEmailSent": "Thank you for your interest.  We will be contacting you shortly.",
    "PickupScheduled": "Pickup is successfully scheduled.",
    "LabelPreferenceSaved": "Your label preference has been saved."
  },
  "Warning": {
    "EmailOnPlatform": "This email address is already on Zing Marketplace. Please verify the email address.",
    "InvalidTwoFactorAuthentication": "Either your phone and/or email is not verified OR security questions have not been setup in your profile. Two Factor Authentication is not enabled for you at this time. Please contact Help Desk.",
    "OptInMessageToRestartNotifications": "Please reply START to {{twilioPhoneNumber}} from your verified mobile phone to receive text notifications again",
    "NoteAfterVerificationCodeReceived": "By clicking below, you consent to receiving text messages about your account. To end this consent, simply text “Stop” in reply to any message you receive.",
    "DeleteConfirmation": "Are you sure you want to delete this contact?",
    "ForbiddenWord": "Your label contains words that may identify the contents of the shipment. We suggest you modify your word choice. Proceeding without modification may void your insurance coverage.",
    "DuplicateAddress": "Duplicate address details are not saved to the address book.",
    "ShipmentRequireApproval": "This shipment will require an internal approval for further processing",
    "ContactOriginalShipper": "Please contact original shipper if additional changes are needed for Shipment Details.",
    "ShipmentQuoteNeedsApproval": "Shipment quote selected will need approval and shipment will be moved to Pending Approval status.",
    "EmailNotificationsCanNotBeDisable": "Email notifications cannot be disabled without a valid phone number for general communication preferences.",
    "ShippingNotificationMessage": "Shipping notifications are turned off, but you will still receive notifications for shipments in Exception status and all approval request responses.",
    "MarketplaceNotificationMessage": "Marketplace notifications are turned off.",
    "iShipCredentialsChange": "Your username and password for iShipJM.com (or Transguardian.com) will be updated to match your username and password for the Zing<sup>®</sup> Marketplace. Previous login credentials will no longer be valid.",
    "CompleteCommodities": "Please 'Edit' commodity {{commodities}} to confirm all required fields are complete.",
    "CommoditiesRequired": "Commodities are required.",
    "ApprovalRequired": "Shipment Requires Approval",
    "CustomerWarning": "Warning!",
    "LivePickupRequestWarningTitle": "WARNING for DEV/QA/UAT2 Environments",
    "LivePickupRequestWarningMessage1": "This pickup functionality is live",
    "LivePickupRequestWarningMessage2": "(connected to production). You must",
    "LivePickupRequestWarningMessage3": "any pickups scheduled, otherwise a driver will arrive to pick up these packages at the address listed. To Cancel, expand the \"View Recently Scheduled Pickups\" section and click \"CANCEL PICKUP\" for the applicable item."
  },
  "InformationMessage": {
    "VerifyAdditionalCompanyInfo": "Please fill in additional details to finalize your shipment and insurance pricing",
    "AskBAToFillAdditionalCompanyInfo": "Additional Company Details are needed in order to proceed with shipment creation. Please ask your Business Administrator to provide additional details."
  },
  "PlaceHolders": {
    "PartnerAffiliations": {
      "MasterMemberId": "Please enter company membership ID",
      "IndividualMemberId": "Please enter individual membership ID"
    },
    "TypeEmail": "Start typing email address",
    "EnterSearchAppraisal": "Find Appraisals"
  },
  "ToolTips": {
    "SealNumber": " Shipments valued over $75,000 (and over $10,000 if in transit over a weekend) require use of high security, tamper evident packaging (aka FraudStopper™ bag) inside of the outer box. Each high security bag contains a unique seal number. This number is required to be entered at the time of label purchase. Security packaging can be ordered via the Supply Order Form (free, except for shipping cost). New customers receive a small supply of security bags with their welcome letter mailed within days of program enrollment.",
    "AdditionalInsurance": "The value declared for insurance is distributed between your jewelers block policy (or self-insured retention, if opted in writing by you to us) and additional insurance requested beyond your jewelers block policy of this platform for the balance. The additional insurance may include your jewelers block deductible amount, if applicable.",
    "InsuranceFromThisPlatform": "The amount of insurance you are buying from <i>JM</i> Shipping Solution.",
    "BlockPolicyExamplesPt1": "Examples:<br>Jewelers Mutual Insurance Company block coverage (",
    "BlockPolicyExamplesPt2": "Click here to view policy details",
    "BlockPolicyExamplesPt3": ") or other insurance rules/requests if opted in writing by you to us.",
    "InsuranceFromThisPlatformInsuranceOnly": "The amount of insurance you are buying from <i>JM</i> Shipping Solution.",
    "BlockPolicyInsuranceOnlyPt1": "Jewelers Mutual Insurance Company block coverage (",
    "BlockPolicyInsuranceOnlyPt2": ") or other insurance rules/requests if opted in writing by you to us.",
    "AdditionalInsuranceDoNotAgree": "If you do not agree, please do not purchase and contact us for assistance.",
    "FeinInfo": "FEIN is your company's Federal Employer Identification Number, also known as EIN. You can find your FEIN on your business documents. If you need assistance, please contact us at {{helpdesknumber}}.",
    "EmailAddressNotVerified": "This email address is not verified. You will receive all notifications on the previously verified email address",
    "PhoneNumberNotVerified": "This phone number is not verified. You will receive all notifications on the previously verified phone number",
    "DeleteAppraisalItemNotAllowed": "At least one item should be added. To delete the item insert a new item.",
    "CompleteAppraisal": "Click on this button to complete your appraisal and email the customer.",
    "NewForSameCustomer": "Create new Appraisal for this customer",
    "ManageShipmentsToolTip": {
      "AllowHeader": "Allow Users to",
      "AllowContent": "View shipment details, edit shipments, buy labels, file claims, and complete other shipment-related activities.",
      "PermissionHeader": "Permission Level",
      "PermissionContent": "Manage shipments created by the entire organization or select Created by User from the drop-down to manage only shipments the user creates."
    },
    "CreateShipmentsToolTip": {
      "Header": "Optional permissions include:",
      "FirstPermission": "a. shipments below a specific value, and/or",
      "SecondPermission": "b. shipments below a specific cost.",
      "EnvelopePackagingNotAllowed": "Envelope Packaging is not allowed for Insured Value ${{insuredValue}}.",
      "BoxPackagingNotAllowed": "Box Packaging is not allowed for Insured Value ${{insuredValue}}.",
      "ShipmentQuoteNeedsApproval": "Shipment quote selected will need approval and shipment will be moved to Pending Approval status.",
      "NextDayShipmentServiceNotAllowed": "Next Day Shipment Service is not allowed for Insured Value ${{insuredValue}}.",
      "TwoDayShipmentNotAllowed": "Two Day Shipment Service is not allowed for Insured Value ${{insuredValue}}.",
      "ThreeDayShipmentNotAllowed": "Three Day Shipment Service is not allowed for Insured Value ${{insuredValue}}.",
      "TwoThreeDayShipmentNotAllowed": "Two Day and Three Day Shipment Services are not allowed for Insured Value ${{insuredValue}}.",
      "GroundServiceShipmentNotAllowed": "Ground/1st Class Shipment Service is not allowed for Insured Value ${{insuredValue}}."
    },
    "NextDayNotAllowed": "Next Day Shipment Service is not allowed for Insured Value ${{insuredValue}}",
    "2DaysNotAllowed": "Two Day Shipment Service is not allowed for Insured Value ${{insuredValue}}",
    "3DaysNotAllowed": "Three Day Shipment Service is not allowed for Insured Value ${{insuredValue}}",
    "2-3DaysNotAllowed": "Two to Three Day Shipment Service is not allowed for Insured Value ${{insuredValue}}",
    "Ground/1stClassNotAllowed": "Ground/1st Class Shipment Service is not allowed for Insured Value ${{insuredValue}}",
    "RegisteredMail": "Only quotes for USPS Registered Mail&trade; will be returned. Expect longer than usual delivery speed (up to 3 weeks). All package seams must be sealed with plain paper or cloth tape which must absorb ink and visibly damage the packaging if removed.",
    "PersonalInsuranceDescription": "Allowed must be selected for user to see Customer Jewelry Claims information.",
    "BusinessInsuranceDescription": "Allowed must be selected for user to see Business Insurance information.",
    "marketPlaceDescription": "Allowed must be selected for user to see Marketplace information.",
    "JewelerPagesDescription": "Allowed must be selected for user to create and update Jeweler Pages.",
    "AuctionPagesDescription": "Allowed must be selected for user to see Auction information.",
    "AppraisalDescription": "Allowed must be selected for user to generate appraisals for the customers.",
    "TransactionParties": "Check if this export is from a U.S. businessperson or business to a foreign business or from a U.S. business to a foreign person or business where the person has at least 10 percent of the voting shares of the business during the fiscal year. If unincorporated, then an equivalent interest in the business.",
    "ContentDescriptionForbiddenWord": "Your label contains words that may identify the contents of the shipment. We suggest you modify your word choice. Proceeding without modification will likely void your insurance coverage.",
    "ITNNumber": "The ITN is an Automated Export System (AES) generated number assigned to a shipment confirming that the EEI was accepted and is on file with the AES. Contact FedEx directly to obtain an ITN for your shipment.",
    "EEIExemption": "Click the EEI Exemption link for exemption definitions",
    "Documents": "Select one or more documents to create. See carrier sites for USMCA required forms.",
    "CommercialInvoice": "A commercial invoice is required for all shipments containing anything besides documents. You may provide your own or create one now.",
    "CertificateOfOrigin": "A document that certifies that the shipped goods are wholly obtained or produced in a particular country. Required by some countries for import.",
    "SED": "Shipper's Export Declaration",
    "SecuritySealInfo": "Shipments valued over $75,000 (and over $10,000 if in transit over a weekend) require use of high security, tamper evident packaging (aka FraudStopper&trade; bag) inside of the outer box. Each high security bag contains a unique seal number. This number is required to be entered at the time of label purchase.<br><br> Security packaging can be ordered via the Supply Order Form (free, except for shipping cost). New customers receive a small supply of security bags with their welcome letter mailed within days of program enrollment.",
    "DeliveryConfirmationInfo": "Options will be defaulted based on the declared value for the shipment to encourage appropriate security.<br><br><b>Delivery Confirmation</b> - carrier may leave the package without anyone at the delivery address confirming it was actually received<br><br><b>Signature Confirmation</b> - carrier is to obtain a signature from anyone at the delivery address - note that this may be a verbal confirmation in certain situations and is often waived under COVID protocol<br><br><b>Adult Signature</b> - carrier is required to obtain a signature or name from a legal adult at the delivery address (warning: could be front desk or central receiving in multi-occupancy buildings)<br><br><b>Restricted (USPS)</b> - the postal carrier is to verify the ID of the named recipient<br><br><b>Adult Restricted (USPS)</b> - the postal carrier is to verify the ID and the legal age of the recipient named on label",
    "HoldForPickupLocationInfo": "Hold for Pickup service allows packages to be held at a designated carrier location for pick up by your recipient. This service is a better alternative for deliveries to high-risk areas or residential addresses. Based on your recipient's address entered in the Destination section, select this option and then choose a Pickup Location from the list of eligible carrier-staffed locations displayed.<br><br>To ensure successful delivery to your recipient, be sure to notify your customer of the pickup location, tracking number, and the need for them to show photo ID matching the recipient details you provided in the destination field.",
    "ECommerceStatusInfoDisabled": "To enable your plugin, access your WooCommerce admin account and switch the mode to “Enabled” in the JM Shipping plugin option. Ensure all Origin and General Defaults and Shipment Methods are established prior to enabling the plugin.",
    "ECommerceStatusInfoEnabled": "To disable your plugin, access your WooCommerce admin account and switch the mode to “Disabled” in the JM Shipping plugin option.",
    "ECommerceFallbackInfo": "The “Fallback” option is in place to ensure your customer always sees a shipping option in the cart. It will only be used if no other methods generate a valid quote. We are defaulting this as free shipping ($0 price to your customer), but you can edit it to be whatever price you deem appropriate.",
    "ECommercePhoneInfo": "Some carriers require a phone number for the recipient of the package. In the event your customer does not provide a phone number with their order, we will default the recipient’s phone with this Origin Phone Number to avoid validation errors with the carrier.",
    "ECommerceClaimReportingPeriod": " Select the claim reporting period default for all future imported orders. Option can be edited for individual saved shipments once orders are imported.",
    "EssentialInfo": "Prices reflect insurance with a 30-day window from ship date (purchase) to report a claim/loss to us. JM block coverage, if applicable to this shipment, has the same 30-day reporting window.",
    "ExpandedInfo": "Prices reflect insurance with a 6-month optional expanded window from the ship date (purchase) to report a claim/loss to us. This option also includes coverage while at The UPS Store with a maximum coverage limit of $75,000. JM block coverage, if applicable to this shipment, has the same expanded coverage.",
    "ECommerceCargoType": "Select the cargo type most common for your shipments. Option can be edited for individual saved shipments once orders are imported.",
    "ECommerceWeightInfo": "The shipment weight will default as the sum of all items purchased in the cart. In the event a weight is not imported with any orders, we will default to the value shown below.",
    "DefaultPresetInfo": "The selected preset is used as the default when creating new shipments.",
    "SingleDefaultPresetInfo": "Click to deselect and set no default preset.",
    "EnterOriginAndDestination": "Please enter Origin and Destination",
    "OpenAddressBook": "Open Address Book",
    "YourSelectedHFPUAddress": "Your selected Hold For Pickup location:",
    "EcommerceLearnMore": "Easily integrate compatible Ecommerce merchants to simplify your shipping operation. By establishing an integration, we will import your order details to streamline the label production process. You can also set defaults and assign shipping methods received from your merchant. Integrations not only speed up your shipping efforts, it minimizes risks from manual entry.",
    "30DayToolTip": "Prices reflect insurance with a 30-day window from ship date (purchase) to report a claim/loss to us. JM block coverage, if applicable to this shipment, has the same 30-day reporting window",
    "6MonthToolTip": "Prices reflect insurance with a 6-month optional extension window from ship date (purchase) to report a claim/loss to us. JM block coverage, if applicable to this shipment, will extend the same 6-month reporting window",
    "PoliceReportHoverText": "A police report will be required if a crime was committed and for loss of Rolex or GIA products.",
    "ZoomIn": "Zoom In",
    "ZoomOut": "Zoom Out"
  },
  "SecuredDocument": {
    "Title": "Documents",
    "TextLine1": "Files will only be available through the link received via email and will remain accessible for 90 days.",
    "TextLine2": "Please ensure that pop-up blockers are disabled.",
    "NoAvailableDocuments": "There are no available documents.",
    "DownloadFailed": "There was an error downloading the document."
  },
  "USA_Code": "USA",
  "USA_Text": "United States",
  "US_States": [
    {
      "name": "Alabama",
      "abbreviation": "AL"
    },
    {
      "name": "Alaska",
      "abbreviation": "AK"
    },
    {
      "name": "American Samoa",
      "abbreviation": "AS"
    },
    {
      "name": "Arizona",
      "abbreviation": "AZ"
    },
    {
      "name": "Arkansas",
      "abbreviation": "AR"
    },
    {
      "name": "California",
      "abbreviation": "CA"
    },
    {
      "name": "Colorado",
      "abbreviation": "CO"
    },
    {
      "name": "Connecticut",
      "abbreviation": "CT"
    },
    {
      "name": "Delaware",
      "abbreviation": "DE"
    },
    {
      "name": "District Of Columbia",
      "abbreviation": "DC"
    },
    {
      "name": "Federated States Of Micronesia",
      "abbreviation": "FM"
    },
    {
      "name": "Florida",
      "abbreviation": "FL"
    },
    {
      "name": "Georgia",
      "abbreviation": "GA"
    },
    {
      "name": "Guam",
      "abbreviation": "GU"
    },
    {
      "name": "Hawaii",
      "abbreviation": "HI"
    },
    {
      "name": "Idaho",
      "abbreviation": "ID"
    },
    {
      "name": "Illinois",
      "abbreviation": "IL"
    },
    {
      "name": "Indiana",
      "abbreviation": "IN"
    },
    {
      "name": "Iowa",
      "abbreviation": "IA"
    },
    {
      "name": "Kansas",
      "abbreviation": "KS"
    },
    {
      "name": "Kentucky",
      "abbreviation": "KY"
    },
    {
      "name": "Louisiana",
      "abbreviation": "LA"
    },
    {
      "name": "Maine",
      "abbreviation": "ME"
    },
    {
      "name": "Marshall Islands",
      "abbreviation": "MH"
    },
    {
      "name": "Maryland",
      "abbreviation": "MD"
    },
    {
      "name": "Massachusetts",
      "abbreviation": "MA"
    },
    {
      "name": "Michigan",
      "abbreviation": "MI"
    },
    {
      "name": "Minnesota",
      "abbreviation": "MN"
    },
    {
      "name": "Mississippi",
      "abbreviation": "MS"
    },
    {
      "name": "Missouri",
      "abbreviation": "MO"
    },
    {
      "name": "Montana",
      "abbreviation": "MT"
    },
    {
      "name": "Nebraska",
      "abbreviation": "NE"
    },
    {
      "name": "Nevada",
      "abbreviation": "NV"
    },
    {
      "name": "New Hampshire",
      "abbreviation": "NH"
    },
    {
      "name": "New Jersey",
      "abbreviation": "NJ"
    },
    {
      "name": "New Mexico",
      "abbreviation": "NM"
    },
    {
      "name": "New York",
      "abbreviation": "NY"
    },
    {
      "name": "North Carolina",
      "abbreviation": "NC"
    },
    {
      "name": "North Dakota",
      "abbreviation": "ND"
    },
    {
      "name": "Northern Mariana Islands",
      "abbreviation": "MP"
    },
    {
      "name": "Ohio",
      "abbreviation": "OH"
    },
    {
      "name": "Oklahoma",
      "abbreviation": "OK"
    },
    {
      "name": "Oregon",
      "abbreviation": "OR"
    },
    {
      "name": "Palau",
      "abbreviation": "PW"
    },
    {
      "name": "Pennsylvania",
      "abbreviation": "PA"
    },
    {
      "name": "Puerto Rico",
      "abbreviation": "PR"
    },
    {
      "name": "Rhode Island",
      "abbreviation": "RI"
    },
    {
      "name": "South Carolina",
      "abbreviation": "SC"
    },
    {
      "name": "South Dakota",
      "abbreviation": "SD"
    },
    {
      "name": "Tennessee",
      "abbreviation": "TN"
    },
    {
      "name": "Texas",
      "abbreviation": "TX"
    },
    {
      "name": "Utah",
      "abbreviation": "UT"
    },
    {
      "name": "Vermont",
      "abbreviation": "VT"
    },
    {
      "name": "Virgin Islands",
      "abbreviation": "VI"
    },
    {
      "name": "Virginia",
      "abbreviation": "VA"
    },
    {
      "name": "Washington",
      "abbreviation": "WA"
    },
    {
      "name": "West Virginia",
      "abbreviation": "WV"
    },
    {
      "name": "Wisconsin",
      "abbreviation": "WI"
    },
    {
      "name": "Wyoming",
      "abbreviation": "WY"
    }
  ],
  "Canada_States": [
    {
      "name": "Alberta",
      "abbreviation": "AB"
    },
    {
      "name": "British Columbia",
      "abbreviation": "BC"
    },
    {
      "name": "Manitoba",
      "abbreviation": "MB"
    },
    {
      "name": "New Brunswick",
      "abbreviation": "NB"
    },
    {
      "name": "Newfoundland and Labrador",
      "abbreviation": "NL"
    },
    {
      "name": "Northwest Territories",
      "abbreviation": "NT"
    },
    {
      "name": "Nova Scotia",
      "abbreviation": "NS"
    },
    {
      "name": "Nunavut",
      "abbreviation": "NU"
    },
    {
      "name": "Ontario",
      "abbreviation": "ON"
    },
    {
      "name": "Prince Edward Island",
      "abbreviation": "PE"
    },
    {
      "name": "Quebec",
      "abbreviation": "QC"
    },
    {
      "name": "Saskatchewan",
      "abbreviation": "SK"
    },
    {
      "name": "Yukon Territory",
      "abbreviation": "YT"
    }
  ],
  "Countries": [
    {
      "name": "USA",
      "code": "USA"
    },
    {
      "name": "Canada",
      "code": "CAN"
    }
  ],
  "Months": [
    {
      "name": "Jan",
      "code": 0
    },
    {
      "name": "Feb",
      "code": 1
    },
    {
      "name": "Mar",
      "code": 2
    },
    {
      "name": "Apr",
      "code": 3
    },
    {
      "name": "May",
      "code": 4
    },
    {
      "name": "Jun",
      "code": 5
    },
    {
      "name": "Jul",
      "code": 6
    },
    {
      "name": "Aug",
      "code": 7
    },
    {
      "name": "Sep",
      "code": 8
    },
    {
      "name": "Oct",
      "code": 9
    },
    {
      "name": "Nov",
      "code": 10
    },
    {
      "name": "Dec",
      "code": 11
    }
  ],
  "ShipmentSummaryFilter": {
    "TotalShipments": "Total Shipments",
    "Saved": "Saved",
    "Created": "Created",
    "InTransit": "In Transit",
    "Exception": "Exception",
    "Delivered": "Delivered",
    "Complete": "Complete"
  },
  "BillingPayment": "Billing & Payments",
  "InvoiceDetails": "Invoice Details",
  "PaymentDetails": "Payment Details",
  "BillingMultitable": {
    "Invoices": "Invoices",
    "Transactions": "Transaction",
    "Payments": "Payments"
  },
  "ClientInfo": {
    "Id": "Client ID #",
    "AmountPending": "Amount Pending",
    "TotalSpendMTD": "Total Spend (MTD)",
    "TotalSpend": "Total Spend (Last Month)"
  },
  "Adjustments": {
    "only": "Adjustments only",
    "all": "All",
    "unpaid": "Unpaid",
    "paid": "Paid"
  },
  "PermissionLevelCreatedByUser": {
    "name": "Created by User",
    "value": "0"
  },
  "PermissionLevelCreatedByEntireOrganization": {
    "name": "Created by Entire Organization",
    "value": "1"
  },
  "ShipmentStatuses": {
    "Saved": "Saved",
    "Created": "Created",
    "Parked": "Parked",
    "ApprovalRequired": "Pending Approval",
    "Approved": "Approved",
    "AwaitingPayment": "Awaiting Payment",
    "Processed": "Processed",
    "Rejected": "Rejected",
    "Voided": "Voided",
    "Boomerang": "Boomerang",
    "InTransit": "In Transit",
    "Exception": "Exception",
    "Delivered": "Delivered",
    "Complete": "Complete",
    "EditRequired": "Incomplete - Continue",
    "ReadyForPurchase": "Ready for Purchase",
    "NeedsReview": "Declined/Resolve",
    "RequiresInput": "Requires Input"
  },
  "NonAvailable": "N/A",
  "RequiresInput": "Requires Input",
  "Carriers": {
    "FedEx": "FedEx",
    "UPS": "UPS",
    "USPS": "USPS",
    "DHL": "DHL",
    "Other": "Other",
    "RequiresInput": "Requires Input",
    "EasternConnection": "Eastern Connection",
    "Lonestar": "Lonestar",
    "Newgistics": "Newgistics",
    "Ontrac": "Ontrac",
    "DHLGM": "DHLGM"
  },
  "ClaimStatuses": {
    "Open": "Open",
    "Closed": "Closed"
  },
  "DateFilters": {
    "Today": "Today",
    "Last7Days": "Last 7 days",
    "CurrentMonth": "Current Month",
    "LastMonth": "Last Month",
    "Last60Days": "Last 60 days",
    "Last3Months": "Last 3 Months",
    "Last6Months": "Last 6 Months",
    "AllHistory": "All History",
    "SpecificRange": "Specific Date Range",
    "Last15Days": "Last 15 days",
    "Last30Days": "Last 30 days"
  },
  "CombinedFilters": {
    "Equal": "Is equal to",
    "NotEqual": "Is not equal to",
    "GreaterThan": "Is greater than",
    "GreaterOrEqual": "Is greater than or equal to",
    "LessThan": "Is less than",
    "LessOrEqual": "Is less than or equal to"
  },
  "FilterLogic": {
    "And": "and",
    "Or": "or"
  },
  "BooleanFilters": {
    "True": "Is True",
    "False": "Is False"
  },
  "ServiceType": {
    "None": "None",
    "NextDayEarlyAM": "Next Day Early AM",
    "NextDayEarly": "Next Day Early",
    "NextDayAM": "Next Day AM",
    "NextDayPM": "Next Day PM",
    "TwoDayAM": "Two Day AM",
    "TwoDayPM": "Two Day PM",
    "ThreeDay": "3 Day",
    "ThirdDay": "Third Day",
    "GroundOrFirstClass": "Ground Or First Class",
    "Ground": "Ground",
    "GroundAdvantage": "Ground Advantage",
    "GroundFirstClass": "Ground/First Class",
    "ParcelSelect": "Parcel Select",
    "International1": "International One",
    "International2": "International Two",
    "International3": "International Three",
    "International4": "International Four",
    "Expedited": "Expedited",
    "Priority": "Priority"
  },
  "DeliverySpeed": {
    "NextDay": "Next Day",
    "TwoThreeDays": "2-3 Days",
    "Ground": "Ground",
    "TwoDay": "2 Day",
    "ThreeDay": "3 Day",
    "USPSExpressMail": "USPS Express Mail",
    "USPSPriorityMail": "USPS Priority Mail",
    "USPSNextDay": "UPS Next Day",
    "UPS2NdDay": "UPS 2nd Day",
    "UPSGround": "UPS Ground",
    "Pickup": "Pickup (LA customers only)"
  },
  "PackageType": {
    "NoneSelected": "None Selected",
    "CarrierBox": "Carrier Box",
    "CarrierBoxAll": "Carrier Box (All)",
    "FlatRateAllBox": "Flat Rate Box (All)",
    "FlatRateSmallBox": "Flat Rate Small Box",
    "FlatRateMediumBox": "Flat Rate Medium Box",
    "FlatRateLargeBox": "Flat Rate Large Box",
    "FlatRateRegionalA": "Flat Rate Regional A Box",
    "FlatRateRegionalB": "Flat Rate Regional B Box",
    "FlatRateAPO": "Flat Rate APO Box",
    "Tube": "Tube",
    "Envelope": "Carrier Envelope",
    "CarrierEnvelope": "Carrier Envelope",
    "FlatRateAllEnvelope": "Flat Rate Envelope (All)",
    "FlatRateWindowedEnvelope": "Flat Rate Windowed Envelope",
    "FlatRateCardboardEnvelope": "Flat Rate Cardboard Envelope",
    "FlatRateSmallEnvelope": "Flat Rate Small Envelope",
    "FlatRateEnvelope": "Flat Rate Envelope",
    "FlatRateLegalEnvelope": "Flat Rate Legal Envelope",
    "FlatRatePaddedEnvelope": "Flat Rate Padded Envelope",
    "Letter": "Letter",
    "Pak": "Pak",
    "Custom": "Custom Box",
    "CustomBox": "Custom Box",
    "CustomPolyBag": "Custom Poly Bag",
    "SmallCarrierBox": "Small Carrier Box",
    "MediumCarrierBox": "Medium Carrier Box",
    "LargeCarrierBox": "Large Carrier Box"
  },
  "CarrierPackageDetailType": {
    "None": "None",
    "CarrierBox": "Carrier Box - USPS",
    "SmallCarrierBox": "Small Carrier Box - FedEx/UPS",
    "MediumCarrierBox": "Medium Carrier Box - FedEx/UPS",
    "LargeCarrierBox": "Large Carrier Box - FedEx/UPS",
    "FlatRateSmallBox": "Flat Rate Small Box - USPS",
    "FlatRateMediumBox": "Flat Rate Medium Box - USPS",
    "FlatRateLargeBox": "Flat Rate Large Box - USPS",
    "FlatRateRegionalA": "Flat Rate Regional A - USPS 15lbs max",
    "FlatRateRegionalB": "Flat Rate Regional B - USPS 20lbs max",
    "FlatRateAPO": "Flat Rate APO/FPO - USPS only - US Armed Forces outside the country",
    "Tube": "Tube - triangular box",
    "Envelope": "Carrier Envelope",
    "FlatRateWindowedEnvelope": "Flat Rate Windowed Envelope - USPS",
    "FlatRateCardboardEnvelope": "Flat Rate Cardboard Envelope - USPS",
    "FlatRateSmallEnvelope": "Flat Rate Small Envelope - USPS",
    "FlatRateEnvelope": "Flat Rate Envelope - USPS",
    "FlatRateLegalEnvelope": "Flat Rate Legal Envelope - USPS",
    "FlatRatePaddedEnvelope": "Flat Rate Padded Envelope - USPS",
    "Letter": "Letter",
    "Pak": "Pak",
    "Custom": "Custom Box",
    "CustomPolyBag": "Custom Poly Bag"
  },
  "PackageDetailType": {
    "None": "None",
    "CarrierBox": "Carrier Box",
    "SmallCarrierBox": "Small Carrier Box",
    "MediumCarrierBox": "Medium Carrier Box",
    "LargeCarrierBox": "Large Carrier Box",
    "FlatRateSmallBox": "Flat Rate Small Box",
    "FlatRateMediumBox": "Flat Rate Medium Box",
    "FlatRateLargeBox": "Flat Rate Large Box",
    "FlatRateRegionalA": "Flat Rate Regional A",
    "FlatRateRegionalB": "Flat Rate Regional B",
    "FlatRateAPO": "Flat Rate APO/FPO - US Armed Forces outside the country",
    "Tube": "Tube - triangular box",
    "Envelope": "Carrier Envelope",
    "FlatRateWindowedEnvelope": "Flat Rate Windowed Envelope",
    "FlatRateCardboardEnvelope": "Flat Rate Cardboard Envelope",
    "FlatRateSmallEnvelope": "Flat Rate Small Envelope",
    "FlatRateEnvelope": "Flat Rate Envelope",
    "FlatRateLegalEnvelope": "Flat Rate Legal Envelope",
    "FlatRatePaddedEnvelope": "Flat Rate Padded Envelope",
    "Letter": "Letter",
    "Pak": "Pak",
    "Custom": "Custom Box",
    "CustomPolyBag": "Custom Poly Bag",
    "FedExSmallBox": "Small Box",
    "FedExMediumBox": "Medium Box",
    "FedExLargeBox": "Large Box",
    "UpsSmallBox": "Small Box",
    "UpsMediumBox": "Medium Box",
    "UpsLargeBox": "Large Box",
    "UpsLetterEnvelope": "Letter Envelope",
    "UpsLegalEnvelope": "Legal Envelope",
    "UpsLabels": "Labels (2 per sheet)",
    "UpsInternationalDocumentPouch": "International Document Pouch",
    "UpsPaddedPack": "Padded Pack",
    "UpsSaturdayStickers": "Saturday Delivery Stickers",
    "FraudStoppersE": "Size E Bags",
    "FraudStoppersShippingMethod": "FraudStopper Shipping Method"
  },
  "PackageDimensions": {
    "FedExSmallBox": "12.5\" x 11\" x 1.5\"",
    "FedExMediumBox": "13\" x 11.5\" x 2.5\"",
    "FedExLargeBox": "17.5\" x 12.5\" x 3\"",
    "UpsSmallBox": "13\" x 11\" x 2\"",
    "UpsMediumBox": "16\" x 11\" x 3\"",
    "UpsLargeBox": "18\" x 13\" x 3\"",
    "UpsLetterEnvelope": "13.4\" x 9.8\"",
    "UpsLegalEnvelope": "15\" x 9.5\"",
    "UpsLabels": "8.5\" x 5.5\"",
    "UpsPaddedPack": "14.75\" x 11\"",
    "FraudStoppersE": "15\" x 20\""
  },
  "TimeRange": {
    "Today": "Today",
    "LastWeek": "Last Week",
    "Last30Days": "Last 30 days"
  },
  "TransactionSource": {
    "Unknown": "Unknown",
    "Not_Defined": "Not Defined",
    "Stc": "Stc",
    "Pac": "Pac",
    "Manual": "Manual",
    "Pickup": "Pickup",
    "Reconciliation": "Reconciliation",
    "Credit": "Credit",
    "Incentives": "Incentives"
  },
  "SchedulePickupLocation": {
    "Undefined": "Choose one",
    "BackDoor": "Back Door",
    "Downstairs": "Downstairs",
    "FrontDoor": "Front Door",
    "Garage": "Garage",
    "GuardRoom": "Guard Room",
    "MailRoom": "Mail Room",
    "Office": "Office",
    "Receiving": "Receiving",
    "Reception": "Reception",
    "Shipping": "Shipping",
    "SideDoor": "Side Door",
    "Upstairs": "Upstairs",
    "Warehouse": "Warehouse",
    "None": "None",
    "Rear": "Rear"
  },
  "ClaimReasonType": {
    "ScannedAsDeliveredButRecipientDidNotReceive": "Scanned as delivered but recipient did not receive",
    "CarrierFailedToDeliver": "Carrier failed to deliver / no delivery scan",
    "ContentsDamagedInShipping": "Contents damaged in shipping (Photos Required)",
    "ContentsStolenOrMissing": "Contents stolen or missing (Photos of Original Contents Required)",
    "Other": "Other"
  },
  "SchedulePickupServiceType": {
    "Undefined": "Choose one",
    "NextDayAir": "Next Day Air",
    "Ground": "Ground",
    "WorldwideExpress": "Worldwide Express",
    "WorldwideExpedited": "Worldwide Expedited",
    "Standard": "Standard",
    "ThreeDay": "Three Day",
    "NextDayAirSaver": "Next Day Air Saver",
    "NextDayEarlyAM": "Next Day Early AM",
    "WorldwideExpressPlus": "Worldwide Express Plus",
    "SecondDayAirAM": "Second Day Air AM",
    "SecondDaySaver": "Second Day Saver",
    "FedExGround": "FedEx Ground",
    "FedExExpress": "FedEx Express"
  },
  "PleaseReviewAddressDetailsMessage": "Please review the address for accuracy and make any necessary changes.",
  "AddressValidationFailedInstruction": "Click <b>Edit Address</b> to edit and re-validate the address, or click <b>Use This Address</b> to proceed with the unvalidated address below.",
  "LocationAddressValidationFailedInstruction": "Click <b>Edit Address</b> to edit and re-validate the address, or click <b>Use This Address</b> to proceed with the address you entered.",
  "AddressValidationFailedWarning": " Using this address may result in delivery difficulties, additional charges, and claim denial.",
  "EnterCodeOrDescription": "Enter code or description or select from list",
  "NotFindingTariffCode": "Not finding the tariff code you need? ",
  "ClickHere": "Click here to access the U.S. Census Bureau site for code lookup",
  "USCensusBureauSite": " and enter the 10-digit tariff code and brief description directly into this field. As long as the code is correct, consider using a brief description that will not clearly identify the valuable items in the shipment.",
  "LandingPage": {
    "Login": "Login",
    "JMLogin": "Login via JM Identity",
    "Register": "Register",
    "RasingTide": "Raising the Tide",
    "OfJewelryIndustry": "Of the Jewelry Industry",
    "Section2Title": "Maximizing your business potential",
    "Section2Content": "Since 1913, Jewelers Mutual® Group has supported the jewelry industry with insurance offerings, but today's portfolio also includes products to help jewelers’ bottom lines.",
    "Section2Content1": "The <i>Zing</i> Marketplace brings all of that and more together in a digital experience that will empower you to make smart business decisions, help you create a seamless customer experience, and provide product selection not historically available to everyone.",
    "Section2Content2": "Access the industry’s leading service providers in one place, from core Jewelers Mutual products to solutions powered by IDEX and leveraging the expertise of Gemworld.",
    "LearnMore": "Learn More",
    "PlayVideo": "Play Video",
    "SeeItInAction": "See it in action",
    "BuiltForYou": "Built for You",
    "BuiltForYou1": "Available for anyone in the jewelry industry",
    "BuiltForYou2": "Free; there is no cost or fee to enroll in the <i>Zing</i> Marketplace",
    "BuiltForYou3": "Personalized dashboard based on your business needs",
    "EaseOfUse": "Ease of Use",
    "EaseOfUse1": "Web-based Zing Marketplace accessible from any device",
    "EaseOfUse2": "Single sign-on; giving you all your tools in one place",
    "ConnectToTheIndustry": "Connect to the Industry",
    "ConnectToTheIndustry1": "Easily connect with the Jewelers Mutual Group in one place",
    "ConnectToTheIndustry2": "Tap into additional resources to help grow your business",
    "Benefits": "Overall Benefits",
    "Benefits1": "The <i>Zing</i> Marketplace provides an easy-to-use, one-stop-shop for the jewelry industry to facilitate the digital connections necessary to be successful in today’s world.",
    "SeeWhatsHappening": "See what’s happening on the <i>Zing</i> Marketplace",
    "ShippingSolution": "JM™ Shipping Solution",
    "ShippingSolutionText": "Compare options side by side, access incentive programs, and intelligently insure your packages, all from one location.",
    "CarePlan": "JM™ Care Plan",
    "CarePlanText": "This revenue-generating plan goes beyond a typical manufacturer’s warranty to protect your customers’ jewelry and watches from damage and keep each piece in like new condition.",
    "PolicyDetails": "Business Insurance*",
    "PolicyDetailsText": "View up-to-date, transparent information about your billing and claim history in one convenient location, along with other basic policy details.",
    "PolicyDetailsInfo": "*Available for Jewelers Mutual Group policyholders only<br>*<i>JM</i> Care Plan and <i>JM</i> Shipping Solution not currently available in Canada.",
    "AppraisalSolution": "Retail Insurance Appraisal Tool",
    "AppraisalSolutionText": "Generate an appraisal in a simple, step-by-step approach leveraging expertise from Gemworld, the industry leader in appraisals.",
    "DiamondMarketplace": "Diamond Marketplace",
    "DiamondMarketplaceText": "With IDEX’s Guaranteed Diamond Transactions™ service, suppliers can share their inventory (including specifications, grading, and pricing information), so that all jewelers have transparent access to inventory and pricing information around the globe.",
    "Policyholder": "Personal Jewelry Insurance Claims",
    "PolicyholderText": "Quickly and easily submit claims for your customers and track the progress in real time.",
    "RegisterNow": "Register Now",
    "RegisterNowText": "The <i>Zing</i> Marketplace is free to access and is open to everyone in the industry, even if you aren't a Jewelers Mutual policyholder.",
    "RegisterNowButton": "GET STARTED",
    "BannerMessage": "<strong>Zing is moving!</strong> Visit the new Zing Marketplace <a href='{{ url }}'>here</a>."
  },
  "LandingPageHelpVideos": {
    "HelpVideoMainTitle": "How It Works",
    "HelpVideoDescription": "Watch in-depth videos to learn how each feature on the <i>Zing</i> platform works from start to finish."
  },
  "ClaimsOptionsModal": {
    "SubmitClaim": "Submit a claim",
    "MakeCorrectSelection1": "Make selection to ensure that you're proceeding with",
    "MakeCorrectSelection2": "the correct type of claim.",
    "SelectContinuePersonalLines1": "Select Continue to submit a claim",
    "SelectContinuePersonalLines2": "on behalf of a <strong class='blue-text'>Personal Lines Insurance</strong> customer.",
    "SelectContinueCarePlan1": "Select Continue to submit a claim on",
    "SelectContinueCarePlan2": "behalf of a <strong class='blue-text'>JM Care Plan</strong> customer.",
    "SelectContinueShipping1": "Select Continue to submit a claim for",
    "SelectContinueShipping2": "<strong class='blue-text'>Commercial Lines Cargo/Shipping</strong>.",
    "ContinueButton": "Continue"
  },
  "ForbiddenWordsCollapsed": "The address contains one or more words that may indicate valuable contents. Use of these words (unless a street, first/last name of an individual, or city) will void insurance coverage. Please review and edit, if needed.",
  "ForbiddenWordsTitle": "<span class='text-danger roboto-bold forbidden-words'>The label contains one or more words that may indicate valuable contents.</span>",
  "ForbiddenWordsTitleAndIcon": "<i class='mdi mdi-alert mr-1' style='font-size: 1.3rem;'></i><div class='roboto-bold forbidden-words'>The label contains one or more words that may indicate valuable contents.</div>",
  "ForbiddenWordsText": "Use of these words or their variations (unless the name of a person, street, or city) will void insurance coverage. Please review and edit, as needed.",
  "VerifyCompanyInfo": "Please review your company name and address for accuracy and edit as needed to help ensure successful carrier pickup.",
  "QuoteError": {
    "FirstLine": "A connection issue is preventing quotes for your shipment. The connection issue may reside with the carrier or with your device.",
    "SecondLine": "Select \"Go Back\" to return to the Shipment Details and then select \"Continue\" to try again.",
    "ThirdLine": "If the issue continues or this is your first time shipping from the Zing<sup>®</sup> Marketplace, please try these troubleshooting tips:",
    "Point1": "Ensure your browser is up to date.",
    "Point2": "Clear your browser's cache and cookies",
    "Point3": "Retry from a different computer or device.",
    "FourthLine": "For further assistance, call our Customer Helpline at"
  },
  "ApprovalContactModal": {
    "IntroText1": "Our risk management team will review the details of your shipment upon submission of this approval request.",
    "IntroText2": "Response time is approximately 15 minutes.",
    "InformationTitle": "What happens next?",
    "Information1": "After review, an email will be sent to the address(es) indicated below.",
    "Information2": "If <b>approved</b>, the email will include a PDF of the label or you can access the shipment from the Processed Shipments tab on the Shipment Dashboard.",
    "Information3": "If <b>declined</b>, the email will contain an explanation and a link to your shipment on the Saved Shipment tab to edit and resubmit.",
    "Information4": "By default, this notification email will be sent to the contact on file. If you wish to notify another person, please select the Send additional notification checkbox and add their contact information.",
    "NotificationTitle": "Upon submission and review, email notification will be sent to",
    "AdditionalNotification": "Send additional email notification",
    "SubmitRequest": "Submit Approval Request"
  },
  "UPSInfoMessage": "UPS requires Commercial Invoice and SED documents which will be transmitted to them electronically upon purchase.",
  "CommodityUnitValuesLessThanInvoice": "Your entered total Commodity Item Value is less than your Invoice Value",
  "CommodityInfoMessage": "Please note that under declaring your shipment could result in the delay or confiscation of your package by Customs.",
  "SaveAndFinishLaterMessage": "Please enter a name for your shipment so you can locate it later in the Shipment Summary on your Shipment Dashboard.",
  "ForbiddenWordsWarningMobileVersion": "The label contains one or more words that may indicate valuable contents. ",
  "ForbiddenWordsWarningBodyMobileVersion": "Use of these words (unless a street, first/last name of an individual, or city) will void insurance coverage. Please review and edit, if needed.",
  "ShipmentDetailsMobileMessage": "Please complete Origin and Destination",
  "Memo": {
    "HamburgerMenu": "Memo",
    "Widget": {
      "Title": "Memos",
      "Tagline": "Your digital destination for managing memos:",
      "FirstBullet": "Sellers - Create and submit memos",
      "SecondBullet": "Buyers - Accept memos from anywhere at anytime",
      "ThirdBullet": "Keep track of your memos in one digital dashboard",
      "Text": "Track who you lend merchandise to and from",
      "MemosReceived": "Memos Received",
      "MemosGenerated": "Memos Generated",
      "GoToMemosBtn": "Go to my Memos"
    },
    "BuyerDetails": {
      "Title": "Memo",
      "BuyerInfo": "Buyer Info",
      "MemoDetails": "Memo Details",
      "Complete": "Complete",
      "SellerLocation": "My Location",
      "BuyerInformation": "Buyer's Information",
      "SearchByEmail": "Search by Email",
      "SearchError": "User with that email address was not found",
      "Search": "Search",
      "BuyerLocation": "Buyer Location",
      "CompanyName": "Company Name",
      "FirstName": "First Name",
      "LastName": "Last Name",
      "Address1": "Address 1",
      "Address2": "Address 2",
      "City": "City",
      "State": "State",
      "Country": "Country",
      "Zipcode": "Zipcode",
      "Email": "Email",
      "PhoneNumber": "Phone Number",
      "CancelMemo": "Cancel Memo",
      "CancelChanges": "Cancel Changes",
      "Next": "Next"
    },
    "MemoDetails": {
      "Title": "Memo",
      "MemoId": "Memo ID:",
      "MemoStatus": "Status:",
      "BacktoMemoDashboard": "Back to Memo Dashboard",
      "BackToMemos": "Back to Memos",
      "BuyerInfo": "Buyer Info",
      "Seller": "Seller",
      "Buyer": "Buyer",
      "MemoDetails": "Memo Details",
      "Complete": "Complete",
      "SellerLocation": "My Location",
      "CancelMemo": "Cancel Memo",
      "CancelChanges": "Cancel Changes",
      "CompleteMemo": "Complete Memo",
      "SaveAsDraft": "Save as Draft",
      "MemoValidity": "Memo Validity (days)",
      "PaymentTerms": "Payment Terms (days)",
      "Interest": "Interest (in %)",
      "TotalPrice": "Memo Total Price: ",
      "AddAnItem": "Add an Item to Memo",
      "Jewelry": "Jewelry",
      "Diamond": "Diamond",
      "Phone": "Phone:",
      "MaxValue365": "Max value should be 365",
      "MaxValue100": "Max value should be 100",
      "TypeOfItem": "What type of item?",
      "ItemId": "Item ID",
      "Quantity": "Quantity",
      "Description": "Description",
      "TotalPriceTitle": "Total Price",
      "JewelryItemSummary": "{{jewelryType}}, {{totalWeight}} {{weightType}}",
      "DiamondSummary": "{{shape}}, {{weightInCarats}} Carats, Clarity: {{clarityGrade}}, Color: {{color}}, Price per Carat: ${{price}}",
      "ReturnItems": "Return Items",
      "KeepAllItems": "Keep All Items",
      "MaxLimit365": "Maximum limit is 365",
      "MaxLimit100": "Maximum limit is 100",
      "Status": "Status"
    },
    "MemoDashboard": {
      "Title": "Memo Dashboard",
      "NewMemo": "New Memo",
      "Selling": "Selling",
      "Buying": "Buying",
      "SellingMemos": "Selling Memos",
      "BuyingMemos": "Buying Memos",
      "SearchForSupplierMemo": "Search for Buyer or Memo ID",
      "SearchForBuyerMemo": "Search for Seller or Memo ID",
      "Search": "Search",
      "Go": "Go",
      "SelectDate": "Select a Date Range",
      "MemoID": "Memo ID",
      "Buyer": "Buyer",
      "Status": "Status",
      "ShipmentTrackingNumber": "Tracking Number",
      "Carrier": "Carrier",
      "MemoGenerated": "Memo Generated",
      "LastUpdatedDate": "Last Updated Date",
      "ItemQuantity": "Item Quantity",
      "TotalPrice": "Total Price",
      "NoMemosToBeViewed": "Currently, there are no memos to be viewed",
      "DownloadPdfFail": "Please try downloading the PDF again.",
      "Actions": {
        "Edit": "Edit",
        "Delete": "Delete",
        "Cancel": "Cancel",
        "Return": "Return",
        "Shipped": "Shipped",
        "Close": "Close",
        "SellerReceived": "Seller Received",
        "ViewMemo": "View Memo",
        "DownloadMemoPdf": "Download PDF",
        "ChangeStatus": "Change Status",
        "Accept": "Accept",
        "BuyerReceived": "Buyer Received",
        "SellerShipped": "Seller Shipped"
      },
      "Banner": {
        "Title": "Welcome to Memo",
        "Content": "Create, accept and track your memos in one easy digital dashboard"
      },
      "Popover": {
        "ShippingTrackingNumber": "Shipping Tracking Number"
      }
    },
    "MemoStatuses": {
      "PendingReview": "Pending Review",
      "PendingWithBuyer": "Pending With Buyer",
      "Accepted": "Accepted",
      "SellerShipped": "Seller Shipped",
      "BuyerReceived": "Buyer Received",
      "BuyerReturned": "Buyer Returned",
      "SellerReceived": "Seller Received",
      "Closed": "Closed",
      "Cancelled": "Cancelled",
      "Draft": "Draft",
      "Shipped": "Seller Shipped"
    },
    "MemoActions": {
      "Edit": "Edit",
      "Delete": "Delete",
      "Cancel": "Cancel Memo",
      "SellerShipped": "Seller Shipped",
      "Close": "Close",
      "Received": "Seller Received",
      "DownloadPDF": "Download PDF",
      "ReturnItems": "Return Items",
      "Accept": "Accept Memo",
      "BuyerReceived": "Buyer Received",
      "KeepAllItems": "Keep All Items"
    },
    "JewelryItemModal": {
      "Title": "Add Jewelry",
      "Quantity": "Quantity",
      "JewelryType": "Jewelry Type",
      "Other": "Other Jewelry Type",
      "TotalWeight": "Weight",
      "ItemID": "Item ID",
      "AdditionalNotes": "Additional Notes",
      "TotalPrice": "Total Price",
      "Price": "$0.00",
      "Cancel": "Cancel",
      "Save": "Save"
    },
    "ShippedMemoModal": {
      "Title": "Enter Tracking Info",
      "OtherCarrier": "Other Carrier"
    },
    "AddDiamondModal": {
      "AddDiamond": "Add Diamond",
      "Quantity": "Quantity",
      "CreationType": "Creation Type",
      "ItemId": "Item ID",
      "AdditionalNotes": "Additional Notes",
      "TotalPrice": "Total Price",
      "Save": "Save",
      "Cancel": "Cancel",
      "Price": "$0.00",
      "Treatment": "Treatment",
      "Clarity": "Clarity",
      "Cut": "Cut",
      "EnterCaratWeight": "Enter Carat Weight",
      "Color": "Color",
      "Others": "Others",
      "SpecialShapes": "Special Shapes",
      "Shapes": "Select a Shape"
    },
    "MemoItemConfirmationModal": {
      "Title": "Delete Memo Item",
      "Text": "Are you sure you want to delete this item?",
      "Cancel": "Cancel",
      "Confirm": "Yes, Delete the item"
    },
    "CloseMemoModal": {
      "Title": "Close Memo",
      "Text": "Are you sure, you want to close this memo?",
      "Reason": "Reason for closing the memo",
      "Cancel": "Cancel",
      "Confirm": "Yes, Close",
      "ErrorRequiredCommentToContinue": "Please add a comment for closed memo",
      "MaximumCharactersError": "200 Character Maximum",
      "SpecialCharacterError": "Special characters not allowed"
    },
    "CancelMemoModal": {
      "Title": "Cancel Memo",
      "Text": "Are you sure you want to cancel this memo?",
      "Reason": "Reason for cancelling the Memo",
      "Cancel": "Do not cancel",
      "Confirm": "Yes, Cancel",
      "ErrorRequiredCommentToContinue": "Please enter a comment for cancelling the memo.",
      "MaximumCharactersError": "200 Characters Maximum",
      "SpecialCharacterError": "Special characters are not allowed"
    },
    "DeleteMemoModal": {
      "Title": "Delete Memo",
      "Text": "Are you sure you want to delete this memo?",
      "Reason": "Reason for deleting the memo",
      "Cancel": "Cancel",
      "Confirm": "Yes, Delete",
      "ErrorRequiredCommentToContinue": "Please enter a comment for deleting the memo.",
      "MaximumCharactersError": "200 Characters Maximum",
      "MinimumCharactersError": "25 Characters Minimum",
      "SpecialCharacterError": "Special characters not allowed"
    },
    "ReturnMemoModal": {
      "Title": "Confirm Returning Items",
      "ConfirmationText": "Please confirm the following items will be returned and provide the tracking number.",
      "TrackingNumberLabel": "Enter the Tracking Number",
      "OtherCarrier": "Other Carrier"
    },
    "AcceptMemoModal": {
      "Title": "Accept Memo Confirmation",
      "T&CTitle": "Memo Terms and Conditions",
      "Version": "Version 2020",
      "Description": "Please review information below before accepting the memo.",
      "AcceptMemoTerms": "Your access to and use of the services is at your own risk. The services and content are provided \"as is\". You are responsible for the content of any document created and any required UCC filing(s). Jewelers Mutual Group makes no representation or warranty, express or implied, regarding the validity or effectiveness of any document created herein and will not be liable for any damages of any kind arising from the use of any document, content or other services made available to you.",
      "AcceptMemo": "Accept Memo",
      "DeclineMemo": "I do not accept the terms and conditions",
      "Actor": "Buyer"
    },
    "MemoLogoModal": {
      "Title": "Upload Logo and your Terms and Conditions",
      "AttachLogo": "To successfully load a company logo it must meet the below criteria.",
      "SupportedFileFormats": "Supported Documents formats are  .jpg, .jpeg, .png,",
      "FileSizeLimit": "Document size cannot exceed 5 MB",
      "TermsTitle": "Load company’s legal information and terms and conditions",
      "AddTerms": "Add Terms and Conditions"
    }
  },
  "JewelerPages": {
    "Title": "Jeweler Pages",
    "SubTitle": "Page Builder",
    "NextStep": "Next Step",
    "Preview": "Preview",
    "PublishPageBtn": "Publish",
    "ReturnToDashboardBtn": "Return to dashboard",
    "ErrorMessage": "Sorry, we’re having a problem with this page. Please try again later.",
    "Sections": {
      "CompanyInfo": "COMPANY INFORMATION",
      "BannerHeadline": "BANNER & HEADLINE",
      "Services": "SERVICES",
      "AboutYou": "ABOUT YOU",
      "UpcomingEvents": "UPCOMING EVENTS"
    },
    "CompanyInfoSection": {
      "CompanyNameFieldLabel": "Company Name",
      "CustomerUrlFieldLabel": "Web Address",
      "CompanyNamePlaceholder": "Your Company Jeweler",
      "CustomerUrlPlaceholder": "Customer URL",
      "Country": "Country",
      "GoToMyPage": "Visit My Page",
      "Address": "Address",
      "PhoneNumber": "Phone Number",
      "EmailAddress": "Email Address",
      "City": "City",
      "State": "State",
      "StateProvince": "State/Province",
      "ZipCode": "Zip Code",
      "PostalCode": "Postal Code",
      "HoursOfOperation": {
        "Title": "Hours Of Operation",
        "FormLabel": "Select Days and Time",
        "Monday": "Mon",
        "Tuesday": "Tue",
        "Wednesday": "Wed",
        "Thursday": "Thu",
        "Friday": "Fri",
        "Saturday": "Sat",
        "Sunday": "Sun",
        "AddSectionBtn": "Add Day(s)",
        "DeleteSectionBtn": "Delete",
        "OpensAtControl": "Open",
        "ClosesAtControl": "Closes",
        "TimeZoneControl": "Time Zone"
      },
      "CompanyLogo": {
        "Title": "Add Company Logo",
        "AttachLogo": "To successfully load a company logo it must meet the below criteria.",
        "SupportedFileFormats": "Supported Documents formats are  .jpg, .jpeg, .png",
        "FileSizeLimit": "Document size cannot exceed 5 MB"
      }
    },
    "AboutYouSection": {
      "Headline": "About You Headline",
      "HeadlinePlaceholder": "About Us",
      "Description": "About You Description",
      "DescriptionPlaceholder": "About You Description",
      "DescriptionInfo": "This area is to help the customer to learn more about you.",
      "BulletType": "Bullet Type",
      "BulletContent": "Bullet Content",
      "BulletContentPlaceholder": "The bullet need to be short and sweet.",
      "AddBullet": "Add another bullet",
      "DeleteBullet": "X Delete",
      "RequiredError": "Required Field",
      "MaxRange50Error": "50 character maximum",
      "MaxRange2000Error": "2000 character maximum"
    },
    "SocialMedia": {
      "Title": "Social Media",
      "Description": "Adding social media links will help drive traffic to your page and enhance searchability.",
      "FacebookPlaceholder": "Link to Facebook account (optional)",
      "InstagramPlaceholder": "Link to Instagram account (optional)",
      "TwitterPlaceholder": "Link to Twitter account (optional)",
      "YouTubePlaceholder": "Link to YouTube account (optional)",
      "LinkedInPlaceholder": "Link to LinkedIn account (optional)"
    },
    "Back": "Back",
    "Status": "Status",
    "Published": "Published",
    "Draft": "Draft",
    "Steps": {
      "CompanyInfo": "Company Info.",
      "BannerHeadline": "Banner & Headline",
      "Services": "Services",
      "AboutYou": "About You",
      "UpcomingEvents": "Upcoming Events"
    },
    "Messages": {
      "ValidationMessages": {
        "CompanyNameExceedsLimit": "Entry exceeds 60-character limit. Please enter valid company name.",
        "CustomerUrlExceedsLimit": "Entry exceeds 100-character limit. Please choose a different address.",
        "InvalidCustomerUrl": "Please enter valid company URL (100-character limit).",
        "PhoneNumberExceedsLimit": "Entry exceeds 10-character limit. Please enter valid Phone number.",
        "InvalidPhoneNumber": "Cannot contain special characters. Please enter valid phone number. (10-character limit).",
        "EmailAddressExceedsLimit": "Entry exceeds 254-character limit. Please enter valid email address.",
        "InvalidEmailAddress": "Please enter valid Email Address (254-character limit).",
        "AddressExceedsLimit": "Entry exceeds 254-character limit. Please enter valid address.",
        "InvalidAddress": "Cannot contain special characters. Please enter valid address. (254-character limit).",
        "CityExceedsLimit": "Entry exceeds 60-character limit. Please enter valid city.",
        "InvalidCity": "Cannot contain special characters. Please enter valid city (60-character limit).",
        "ZipCodeExceedsLimit": "Entry exceeds 5-character limit. Please enter valid Zip Code (5-character limit).",
        "InvalidZipCode": "Cannot contain special characters and alphabets. Please enter valid Zip Code (5-character limit).",
        "LinkExceedsLimit": "Over 1500-character limit. Please enter valid link.",
        "LinkMustStartWithHTTPS": "Please provide URL starting with \"https\"",
        "RequiredField": "Required field",
        "MaxRange50Error": "50 character maximum",
        "MaxRange250Error": "250 character maximum",
        "MaxRange200Error": "200 character maximum",
        "InvalidFileFormat": "Format not supported. Please upload image as JPG or PNG file",
        "InvalidFileSize": "Image exceeds 5MB size limit. Please resize or choose a new image.",
        "NotUnique": "Address already in use. Please choose a different address.",
        "ForbiddenAddress": "{{forbiddenSubdomain}} already in use. Please choose a different address.",
        "EventTitleLimit": "Entry exceeds 50-character limit. Please enter valid event title",
        "EventDescriptionLimit": "Entry exceeds 200-character limit. Please enter valid event description",
        "ThemeNameExceedsLimit": "Name exceeds 30 characters",
        "ThemeNameExists": "{{value}} already in use. Please choose a different name."
      },
      "FieldDescriptions": {
        "NoSpaces": "No spaces.",
        "FacebookField": "If left empty the Facebook icon will not be displayed.",
        "InstagramField": "If left empty the Instagram icon will not be displayed.",
        "TwitterField": "If left empty the Twitter icon will not be displayed.",
        "YouTubeField": "If left empty the YouTube icon will not be displayed.",
        "LinkedInField": "If left empty the LinkedIn icon will not be displayed."
      }
    },
    "CreateTheme": {
      "CreateThemeLabel": "Give your theme a name",
      "ThemeNameLabel": "Choose a name that describes the content of the theme.",
      "ThemeNamePlaceholder": "Theme Name",
      "CreateThemeCancel": "Cancel",
      "CreateThemeContinue": "Continue"
    },
    "DuplicateTheme": {
      "DuplicateThemeLabel": "Duplicate Theme",
      "ModalText": "Please create a unique name to save a duplicate of a theme <i>{{themeName}}</i>",
      "DuplicateThemeFormDescription": "Create a unique theme name",
      "DuplicateThemePlaceholder": "Duplicate Theme Name"
    },
    "Banner": {
      "BannerTheme": "Choose a Banner Image Theme",
      "BannerImage": "Choose a {{theme}} Banner Image",
      "Headline": "Headline",
      "HeadlinePlaceholder": "Welcome to Our Online Jewelry Store Showcase",
      "HeadlineDescription": "This text is important to represent your brand and enhance searchability.",
      "BodyCopy": "Description below the headline",
      "BodyCopyPlaceholder": "Learn more about our story and what we do. Come and experience our meticulously curated jewelry collections.",
      "BodyCopyDescription": "This text is important to represent your brand and enhance searchability.",
      "AddButton": "Add a Button",
      "ButtonText": "Button Text",
      "ButtonTextPlaceholder": "Let’s Connect",
      "ButtonAction": "Button Action",
      "ButtonActions": [
        {
          "value": "0",
          "label": "Email",
          "inputLabel": "Email address",
          "placeholder": "shelia.bayes@jewelrystore.com"
        },
        {
          "value": "1",
          "label": "Phone Number",
          "inputLabel": "Phone Number",
          "placeholder": "(XXX) XXX-XXXX"
        }
      ]
    },
    "Services": {
      "Service": "Service",
      "ServiceImageTitle": "Choose Service Image",
      "SelectService": "Select a Service",
      "ServiceDescription": "Service Description",
      "ServiceType": {
        "CreateOriginalDesigns": "Create Original Designs",
        "AppraiseYourJewelry": "Appraise Your Jewelry",
        "RepairAndRestore": "Repair and Restore",
        "SellOrConsignEstateJewelry": "Sell or Consign Estate Jewelry",
        "UpcycleYourGold": "Upcycle Your Gold"
      },
      "ServisTypeFieldDesc": "List service as offered in store.",
      "ServiceFieldDesc": "Describe the features and benefits of the service",
      "CreateOriginalDesignsDesc": "Craft the piece of your dreams. Choose the metal, shape and stones and we'll help you design a true original.",
      "AppraiseYourJewelryDesc": "Know the value of your jewelry. Whether for insurance purposes or documentation to give you peace of mind, we offer on-site, accurate evaluations and appraisals of all kinds of jewelry.",
      "RepairAndRestoreDesc": "Renew your jewelry or timepiece back to its original luster/brilliance. We offer cleaning, polishing, restoration, sizing, and much more. You’ll fall in love all over again with your cherished piece.",
      "SellOrConsignEstateJewelryDesc": "Inherit a piece that doesn't suit your style? We can help you get the most out of your estate jewelry. Let us help you clear some space in your jewelry box.",
      "UpcycleYourGoldDesc": "Give your unwanted or unused gold a new life. We’ll buy your gold at a fair price.",
      "RequiredError": "Required Field",
      "MaxRange200Error": "Entry exceeds 200-character limit. Please enter valid service description",
      "AddService": "Add another service",
      "ClearChanges": "Clear Changes"
    },
    "PreviewModal": {
      "TargetedSection": "Targeted Section",
      "Ok": "OK"
    },
    "PreviewPage": {
      "Modal": {
        "Header": "Ready to publish your page?",
        "ButtonText": "Publish",
        "ContinueEditingBtn": "Continue Editing"
      }
    },
    "PublishPage": {
      "Modal": {
        "Header": "One moment while we build your page.",
        "Body": "This may take 2-5 minutes. Your new web address is: <a target='_blank' class=\"jeweler-pages-publish-url\" href=\"{{ address }}\">{{ address }}</a>",
        "ButtonText": "Go to the Jeweler Page Dashboard",
        "ButtonTextWhenFeatureInactive": "Go to the Zing Dashboard",
        "Error": {
          "Code412.1": "This web address is already in use. Please choose a different name.",
          "Code412.2": "{{ reservedAddress }} is already in use. Please choose a different name.",
          "ButtonText": "Go to Company Info Page"
        }
      }
    },
    "UpcomingEvents": {
      "HideEvents": "Hide Upcoming Events",
      "Title": "Name your event",
      "TitlePlaceholder": "Add name",
      "Description": "Describe your event",
      "DescriptionPlaceholder": "Add description, date and time",
      "AddNewEvent": "+ Add event",
      "DeleteEvent": "x Delete Event",
      "TitleInfo": "Name your event"
    },
    "JewelerPagesDashboard": {
      "Title": "Jeweler Pages",
      "AnalyticsSectionTitle": "Webiste traffic",
      "ThemesSectionTitle": "MY THEMES",
      "ThemesSectionDescription": "Create, edit and manage webpage themes. Switch themes as needed by selecting an existing or creating a new theme. Max 10 themes.",
      "CreateThemeBtn": "Create a New Theme"
    },
    "JewelerPageThemes": {
      "ActionList": {
        "Edit": "Edit",
        "Duplicate": "Duplicate",
        "Rename": "Rename",
        "Delete": "Delete",
        "PreviewTheme": "Preview Theme",
        "Active": "Active",
        "GoToActive": "Go to Active Page"
      }
    },
    "ExitEditPageModal": {
      "ValidForm": {
        "Title": "You are exiting the theme editor",
        "Content": "All changes will be saved for later.",
        "OkBtn": "OK"
      },
      "InvalidForm": {
        "Title": "You are leaving",
        "Content": "You will lose all changes if you exit without completing every required field. Do you still want to leave this page?",
        "BackToDashboard": "Back to Dashboard",
        "ContinueToEdit": "Continue to Edit"
      },
      "ActiveThemeValidForm": {
        "Title": "You are exiting the theme editor",
        "Content": "Your changes will not be viewable on the active webpage until you publish your edits.",
        "BackToDashboard": "Back to Dashboard",
        "ContinueToEdit": "Continue to Edit"
      }
    },
    "DeleteModal": {
      "DraftTheme": {
        "Title": "Are you sure?",
        "Content": "You are about to delete this theme. Do you want to continue?",
        "Continue": "Yes, Delete Theme",
        "Cancel": "Cancel"
      },
      "ActiveTheme": {
        "Title": "Unable to delete active theme",
        "Content": "To delete an active theme, please select and publish a replacement theme.",
        "Close": "Close"
      }
    }
  },
  "JewelerPagesDashboard": {
    "Title": "Jeweler Pages",
    "AnalyticsSectionTitle": "Webiste traffic",
    "ThemesSectionTitle": "My themes",
    "ThemesSectionDescription": "Create, edit and manage webpage themes. Switch themes as needed by selecting an existing or creating a new theme. Max 10 themes.",
    "CreateThemeBtn": "Create a New Theme"
  },
  "MarketplaceSearch": {
    "PopularFilters": "Popular filters",
    "DiamondsWithImageOrVideo": "Diamonds with image/video",
    "StandardShapes": "Standard Shapes",
    "ChooseOneOrMoreShapes": "Choose one or more shapes",
    "ShowMoreShapes": "Show more shapes",
    "HideMoreShapes": "Hide more shapes",
    "Carat": "Carat",
    "Color": "Color",
    "Clarity": "Clarity",
    "White": "White",
    "FancyColor": "Fancy Color",
    "Location": "Location",
    "GradingLab": "Grading Lab",
    "DiamondPrice": "Diamond Price",
    "PricePerCarat": "Price Per Carat",
    "ReportNumber": "Report Number",
    "SearchBy": "Search by",
    "ItemId": "Item ID"
  },
  "MarketplaceLabGrownDashboard": {
    "ListViewColumns": {
      "Compare": "Compare",
      "Image": "Image",
      "Shape": "Shape",
      "Carat": "Carat",
      "Color": "Col",
      "Clarity": "Cla",
      "CutGrade": "Cut",
      "Polish": "Pol",
      "Symmetry": "Sym",
      "Fluorescence": "Fluor\nFluor Color",
      "EyeClean": "Eye Clean",
      "GradingLab": "Lab",
      "Location": "Location",
      "Price": "Price"
    },
    "GridItem": {
      "EstimatedDelivery": "Est. Delivery:",
      "Days": "Business Days"
    },
    "Labels": {
      "ViewDetails": "View Details",
      "AddToCart": "Add to Cart"
    },
    "Image": {
      "NoImage": "No Image",
      "RequestImage": "Request Image",
      "RequestSent": "Image Request Sent"
    },
    "DiamondItem": {
      "Shape": "Shape:",
      "Carat": "Carat:",
      "Clarity": "Clarity:",
      "Color": "Color:",
      "CutGrade": "Cut Grade:",
      "Supplier": "Supplier:",
      "Location": "Location:",
      "EstimatedDelivery": "Estimated Delivery:",
      "Returnable": "Returnable:",
      "Days": "days",
      "PricePerCart": "Price per Carat:",
      "DiamondPrice": "Diamond Price:",
      "BackToSearch": "Back to Search",
      "DiamondSpecifications": {
        "Title": "Diamond Specifications",
        "EyeClean": "Eye Clean",
        "Shade": "Shade",
        "Luster": "Luster",
        "Polish": "Polish",
        "Symmetry": "Symmetry",
        "FluorescenceIntensity": "Fluorescence Intensity",
        "FluorescenceColor": "Fluorescence Color",
        "Measurements": "Measurements",
        "Ratio": "Ratio",
        "Depth": "Depth",
        "Table": "Table",
        "CrownAngle": "Crown Angle",
        "CrownHeight": "Crown Height",
        "PavilionAngle": "Pavilion Angle",
        "PavilionDepth": "Pavilion Depth",
        "Girdle": "Girdle",
        "Culet": "Culet",
        "TreatmentType": "Treatment Type",
        "Comments": "Comments"
      },
      "EmailZing": "E-Mail Zing",
      "AddToCart": "Add to Cart",
      "ReturnPolicy": "Our Return Policy",
      "NewReturnPolicyText": "<ul style='margin-top0.5rem;'><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>We offer <strong>20 days from receipt to return</strong> eligible lab grown diamonds to the supplier.</li><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>Original shipping costs are non-refundable.</li><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>Refunds are processed after supplier authentication.</li><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>(Returning to US) A $35 return fee per diamond will be deducted from the refund.</li><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>(Returning outside US) A $70 return fee per diamond will be deducted from the refund.</li><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>For diamonds priced $10,000<, an additional restocking fee of 1.25% of the diamond’s value will be deducted from the refund.</li></ul><strong style='line-height:1.25rem;margin-top:0.5rem;'>Required Return Condition:</strong><ul><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>Diamonds must be in original condition and include all accompanying certificates.</li><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>Incomplete, inaccurate, or shipments received <strong>after 20 days</strong> will be returned to you.</li></ul><strong style='line-height:1.25rem;font-size:0.875rem;margin-top:1rem;'>Important Note:</strong><span style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'> This policy outlines the lab grown diamond return and refund process. It does not guarantee acceptance or refunds in all cases.</span>",
      "AuthenticationGuarantee": "Authentication Guarantee",
      "AuthenticationGuaranteeText1": "Every diamond is authenticated before shipping to verify the correct diamond is delivered. Diamond images and additional details, if not in the listing, can be obtained by emailing the Zing<sup>®</sup> Marketplace team prior to submitting your order.",
      "AuthenticationGuaranteeText2": "Quality control preferences can be provided for a customized authentication review. We will contact you prior to delivery if we find any discrepancies between the selected diamond and your preferences.",
      "NewReturnPolicyTextUpdated": "<ul style='margin-top:0.5rem;'><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>Lab-grown diamonds are eligible for return to the supplier up to <strong>20 days after receipt</strong>.</li><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>Original shipping costs are non-refundable.</li><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>Refunds are processed after supplier authentication.</li><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>A <strong>$35 return fee</strong> will be deducted from the refund per return shipment. Multiple items may be returned in the same shipment to avoid additional fees.</li></ul><strong style='line-height:1.25rem;margin-top:0.5rem;'>Required Return Condition:</strong><ul><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>Diamonds must be in original condition and include all accompanying certificates.</li><li style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'>Incomplete, inaccurate, or shipments received <strong>after 20 days</strong> will be returned to you.</li></ul><strong style='line-height:1.25rem;font-size:0.875rem;margin-top:1rem;'>Important Note:</strong><span style='font-size:0.875rem;font-style:normal;font-weight:400;line-height:1.25rem;'> This policy outlines the lab-grown diamond return and refund process. It does not guarantee acceptance or refunds in all cases.</span>"
    }
  },
  "ForbiddenModal": {
    "HeaderText": "Unexpected Error!",
    "MainText": "We’ve encountered an unexpected error. If the problem continues, please contact our support team at {{ phoneNumber }} for assistance.",
    "Ok": "Ok"
  },
  "DashboardModals": {
    "ThankYouModal": {
      "ThankYou": "Thank You",
      "ThankYouForYourInterest": "Thank you for your interest. We will be contacting you shortly.",
      "OK": "OK"
    },
    "JMCCContactSupportModal": {
      "ThankYou": "Thank you for contacting us!",
      "WeHaveReceived": "We've received your request and will contact you within 1-2 business days.",
      "Close": "Close"
    }
  },
  "DashboardWidgets": {
    "PLClaimsWidget": {
      "Title": "Personal Insurance Claims",
      "NewClaims": "New Claims",
      "OpenClaims": "Open Claims",
      "ViewCustomerClaims": "View Customer Claims",
      "Dashboard": "Go To Dashboard",
      "SearchClaimPlaceholder": "Search Claim ID",
      "VideoText": "Watch a Claims Overview video",
      "StartAClaim": "Start a Claim"
    },
    "BusinessInsuranceWidget": {
      "BusinessInsurance": "Business Insurance",
      "CurrentAmountDue": "Current Amount Due",
      "Dashboard": "Go To Dashboard",
      "ViewBusinessInsuranceDetails": "View Business Insurance Details",
      "MakeAPayment": "Make a Payment",
      "YourApplicationIsBeingProcessed": "Thanks for your request. We are processing your application.",
      "ConnectBusinessPolicy": "Connect your Jewelers Mutual® business policy.",
      "LinkMyPolicy": "Link my Policy",
      "GetAQuote": "Get a Quote"
    },
    "ShippingWidget": {
      "ShippingSolution": "JM<sup>®</sup> Shipping Solution",
      "EnterTrackingId": "Enter tracking number",
      "ShipmentsInProgress": "Shipments in Progress",
      "CreateNewShipment": "Create New Shipment",
      "GoToShipmentDahboard": "Go To Shipment Dashboard",
      "PermissionRequired": "Permission required. Please contact your business’s Zing Marketplace administrator for access.",
      "TrackShipment": "Track Shipment",
      "StartShipping": "Start Shipping",
      "PrintLabelsAndTrackShipments": "Print labels and track shipments with all major carriers from a single view.",
      "AccountApproved": "Your account is approved! Please accept the Terms and Conditions to get started.",
      "GetStarted": "Get Started",
      "FinishSetup": "Finish setting up your account and start shipping!",
      "RequestAccess": "Request Access",
      "RequestAccessText": "Save time and money. Insure, ship and track packages all in one convenient location.",
      "AccessRequested": "We’re reviewing your request. Please refresh the page to see your updated status. Once services are activated, use the Get Started button to begin.",
      "RequestForApprovalBeingReviewed": "We’ll contact you within the next 24 hours to complete activation. For urgent activation, please call (855) 474-4756 or email us at ",
      "PendingRequestedAccess": "We’re reviewing your request for access. This tile will update to allow you to Get Started once your services are activated. (Please refresh the page to see the status of your request).",
      "SetupIncompleteModalTitle": "Account Setup Incomplete",
      "SetupIncompleteModalBody": "Your Company's Business Administrator must complete your account setup before you can proceed. Please ask your Business Administrator to log in to their Zing® Marketplace account and access JM<sup>®</sup> Shipping Solution to complete the required steps."
    },
    "MarketplaceAccessWidget": {
      "Title": "Diamond Marketplace",
      "ZingMarketplace": "Zing<sup>®</sup> Diamond Marketplace",
      "RequestAccess": {
        "Text1": "Shop natural and lab grown diamonds from reputable sellers around the world.",
        "Text2": "Get free access and start shopping some of the finest diamonds on the market.",
        "RequestAccessButton": "Request Access"
      },
      "AccessRequested": {
        "Text1": "Thanks for your interest in Zing® Diamond Marketplace.",
        "Text2": "We’ll email you once we’ve reviewed your request for access."
      }
    },
    "CarePlanWidget": {
      "Title": "JM<sup>®</sup> Care Plan",
      "GoToDashboard": "Go to Dashboard",
      "GoToClaims": "Go to Claims",
      "GoToSales": "Go to Sales",
      "RequestAccessText": "Grow your revenue and optimize your customer experience resulting in greater satisfaction and loyalty.",
      "FindOutMore": "Find out More",
      "RequestACallButton": "Request a Call",
      "RequestSent": "Your company’s request for access is being reviewed. Thank you.",
      "ViewReportSales": "View & Report Sales",
      "FileAClaim": "File a Claim",
      "OpenClaims": "Open Claims",
      "GetToKnow": "Get to know JM Care Plan",
      "PermissionNeeded": "Permission needed.",
      "ContactAdmin": "For access, please contact your company's Zing administrator."
    },
    "NaturalDiamondsWidgetDashboard": {
      "Title": "Natural Diamonds",
      "ZingMarketplace": "Shop natural diamonds with the power of IDEX",
      "GetInventory": "Get inventory and pricing transparency with direct access to IDEX’S Guaranteed Diamond Transactions™ service.",
      "GuaranteedAvailability": "Guaranteed Availability",
      "AuthenticatedDiamonds": "Authenticated Diamonds",
      "DoorToDoor": "Door-to-Door Delivery",
      "ViewOrderStatus": "View Order Status",
      "ShopNaturalDiamonds": "Shop Natural Diamonds"
    },
    "MemoWidget": {
      "Title": "Memos",
      "KeepTrackMemos": "Keep track of your memos in one convenient online dashboard.",
      "CreateMemos": "Create, submit and accept digital memos on the go.",
      "MyMemos": "My Memos",
      "MemosGenerated": "Memos Generated",
      "MemosReceived": "Memos Received"
    },
    "JewelerPagesWidget": {
      "Title": "Jeweler Pages",
      "BuildAndGrow": "Build And Grow Your Web Presence.",
      "ExpandYourReach": "Expand your reach and attract new customers.",
      "DesignCustom": "Design a custom web page powered by Zing.",
      "LearnMore": "Learn More about Jeweler Pages",
      "GoToMyUrl": "Go to My Page",
      "PermissionRequired": "Permission required.",
      "PleaseContactAdmin": "Please contact your Zing administrator at your business for access.",
      "GoToDashboard": "Go To Dashboard",
      "GetStarted": "Get Started",
      "ViewOrderStatus": "View Order Status"
    },
    "AppraisalWidget": {
      "Title": "Jewelry Appraisal Solution",
      "RetailJewelry": "Retail Jewelry Appraisals Powered by Gemworld",
      "PermissionRequired": "Permission required. Please contact your company’s business administrator for access.",
      "AppraisalsMadeEasy": "Appraisals Made Easy – Powered by Gemworld",
      "CreatePoS": "Create point-of-sale appraisals customized with your logo and business name in minutes and get paid for appraisals resulting in completed applications. ",
      "RequestAccess": "Request Access",
      "ThankYouForInterest": "Thank you for your interest. A member of our sales team will email you within 48 business hours.",
      "StartAnAppraisal": "Start an appraisal",
      "PrintAndEmail": "Print and email appraisals",
      "SearchAppraisal": "Search your appraisal history",
      "GoToDashboard": "Go to Dashboard",
      "CreateFreeDemo": "Create Free Demo",
      "Left": "left",
      "RequestAccessTooltip": "Register for the full system that includes the ability to access your dashboard, email and print your appraisals, and generate income. A signed agreement will be needed to activate.",
      "StartAppraisal": "Start Appraisal",
      "ActivateTrial": "Activate Trial"
    },
    "LabgrownDiamondsWidget": {
      "Title": "Lab Grown Diamonds",
      "BrowseHighQuality": "Browse over 100,000 high-quality lab grown diamonds.",
      "WithAllInclusive": "Enjoy all-inclusive delivered pricing and pay with your credit card for hassle-free buying.",
      "ViewOrderStatus": "View Order Status",
      "ShopLabGrownDiamonds": "Shop Lab Grown Diamonds"
    },
    "LabgrownDiamondsWidgetDashboard": {
      "Title": "Lab Grown Diamonds",
      "ShopLabGrownDiamonds": "Shop Lab Grown Diamonds",
      "ShopOurSelection": "Welcome to the Lab Grown Diamond Marketplace",
      "BrowseHighQuality": "Browse over 100,000 high-quality lab grown diamonds.",
      "WithAllInclusive": "Enjoy all-inclusive delivered pricing and pay with your credit card for hassle-free buying.",
      "ViewOrderStatus": "View Order Status"
    },
    "NaturalDiamondsWidget": {
      "Title": "Natural Diamonds",
      "ShopForDiamondsOnIdex": "Shop for natural diamonds with the power of IDEX",
      "GetTransparentAccess": "Get transparent access to inventory and pricing information around the globe with direct access to IDEX’s Guaranteed Diamond Transactions™ service.",
      "ShopNaturalDiamonds": "Shop Natural Diamonds"
    },
    "RiskWidget": {
      "Title": "Risk Services",
      "KeepYourBusiness": "Keep your business safe and secure.",
      "GetTraining": "Get training resources and proven risk management solutions that support the safety and security of you and your staff.",
      "LearnMore": "Learn More"
    },
    "AuctionWidget": {
      "Title": "JM<sup>®</sup> Auction",
      "JoinAuction": "Thrill Customers With Exclusive Finds",
      "SourcePieces": "Our exclusive online auction connects you with a trusted network of jewelry industry professionals selling high-quality items.",
      "BrowseItems": "— Browse Auction Items Like —",
      "BidNow": "Browse and Bid",
      "MyAccount": "My Account",
      "ExploreFeatures": "Explore Features",
      "BrowseListings": "Browse Listings",
      "GoToOfferManagement": "View Offers",
      "AuctionItems": "Fine Jewelry | Watches | Loose Stones",
      "LearnMore": {
        "Title": "Built for Jewelry Pros",
        "ElevateClientOfferings": "Tired of the same old options? Elevate your client offerings and uncover truly exceptional items through exclusive auctions and direct seller storefronts. ",
        "WaysToBuy": "Ways to Buy:",
        "BuyNowAuction": "Buy now Auction - Skip the bidding and claim items instantly at a set price.",
        "BuyNowDirect": "Buy Now Direct - Shop directly from seller stores for quick, reliable sourcing.",
        "GroupBuy": "Group Buy - Team up with other buyers to unlock volume deals.",
        "PartOfNextAuction": "Want to be part of our next auction?",
        "WantToBidAndBuy": "Just sign your Tax Exemption documents for the states you ship to, and you're all set!",
        "UploadTaxExemption": "Sign Documents",
        "RequestAccess": "Request Access",
        "ThanksForInterest": "Thanks for your interest in JM Auction",
        "ReviewingApplication": "We're reviewing your application and will update you as soon as your account is ready."
      }
    },
    "JmccWidget": {
      "Title": "JM™ Customer Connect",
      "GoToDashboard": "Go To Dashboard",
      "LearnMore": "Learn More",
      "WelcomeToJewelerSolutions": "Welcome to your Jeweler Solutions account",
      "GoToYourDashboard": "Go to your dashboard to review your activity and transactions.",
      "IncreaseRevenue": "Increase Revenue & Customer Loyalty",
      "EarnRevenue": "Earn additional revenue and generate repeat customers with our easy-to-implement personal jewelry insurance program.",
      "GetStarted": "Get Started",
      "ThankYouForYourInterest": "Thank you for your interest. A member of our sales team will contact you within 48 business hours.",
      "AtThisTime": "At this time, we are not able to grant you access to this feature.",
      "ContactSupport": "Contact Support"
    },
    "SynchronyWidget": {
      "Title": "Customer Payment Solutions",
      "OfferFinancing": "Offer your customers flexible financing",
      "SynchronyPartnership": "We've partnered with Synchrony to provide a way to pay over time that helps put more jewelry purchases within reach while making more moments - and results - shine.",
      "GetStarted": "Get Started"
    }
  },
  "Appraisal": {
    "RetailInsuranceAppraisals": "Retail Insurance Appraisals",
    "CustomizeAppraisalPreferences": "Customize your appraisals by adding a logo, document title, and preparer name and title.",
    "AppraisalFAQ": "JAS Frequently asked questions",
    "CustomerDetails": {
      "WhoAreYouHelping": "Who are you helping today?",
      "WhoWillWearJewelry": "Who will be wearing the jewelry?",
      "CustomerSpouseSignificantOther": "Customer / Spouse / Significant Other",
      "LocationSelectionTitle": "Where is the customer getting the appraisal?",
      "SelectLocationOrCreateNew": "Select a location or enter a new one",
      "WhatIsTheirAddress": "What is their address?"
    },
    "NumberRequired": "Please enter a number",
    "PhoneInputPlaceholder": "(000) 000-0000",
    "InvalidPhoneNumber": "Enter a valid phone number (Example: +1 (123) 456-7890)",
    "FieldRequired": "Please choose an option",
    "Color": "Color",
    "To": "to",
    "WholesaleValue": "Wholesale Value",
    "WholesaleValueGems": "Wholesale Value Gems",
    "WholesaleValueMounting": "Wholesale Value Mounting",
    "ResetWholesaleValue": "Reset Wholesale Value",
    "NoWholesaleValue": "Pricing currently not available for your entry. Please enter a wholesale price manually.",
    "NoWholesaleValueRestrictedView": "Please note that your selection was not able to match our pricing database. This may result in an incorrect final retail valuation. Please check your entry for accuracy.",
    "MaxCharactersError": "Only a max of {{ maxLength }} characters are allowed",
    "MaxValueExceeded": "Value cannot exceed {{ maxNumber }}",
    "MaxDigitsError": "A maximum of {{ maxLength }} digits is allowed",
    "OnlyNumbersAllowed": "Only numbers are allowed",
    "Stone": {
      "HasReport": "I have a GIA Lab Report Number for this stone.",
      "LabReportNumber": "Lab Report Number: {{ number }}",
      "Quantity": "Quantity",
      "CreationType": "Creation Type",
      "Treatment": "Treatment",
      "Cut": "Cut",
      "CutGrade": "Cut Grade",
      "CutShape": "Cut / Shape",
      "Shape": "Shape",
      "Clarity": "Clarity",
      "Color": "Color",
      "FancyColor": "Fancy Color",
      "OtherFancyColor": "Other Fancy Color",
      "VarietyOfStone": "Variety Of Stone",
      "OtherVarietyOfStone": "Other Variety Of Stone",
      "Pattern": "Pattern",
      "OverallQuality": "Overall Quality",
      "CaratWeight": "Carat Weight",
      "NumberOfPearls": "# Pearls",
      "PearlType": "Pearl Type",
      "MinimumPearlsSize": "Min. mm",
      "MaximumPearlsSize": "Max. mm",
      "NumberOfStrands": "# Strands",
      "LengthInches": "Length Inches",
      "Variation": "Variation"
    },
    "InvalidFancyColor": "Fancy color must be alphanumeric or is missing. Please re-enter.",
    "AddDiamond": "Add Diamond",
    "AddColoredStone": "Add Colored Stone",
    "AddPearls": "Add Pearls",
    "Jewelry": "Jewelry",
    "Watch": "Watch",
    "Diamonds": "Diamonds",
    "Diamond": "Diamond",
    "ColoredStone": "Colored Stone",
    "ColoredStones": "Colored Stones",
    "Pearl": "Pearl",
    "Available": "Available",
    "NotAvailable": "Not Available",
    "GradingReport": {
      "Gia": {
        "ReportNumber": "GIA Report Number",
        "ConnectingWithGia": "Connecting with GIA...",
        "TroubleConnecting": "We're having trouble connecting to the GIA database. Please try again later.",
        "QuotaReached": "GIA maximum quota reached. Please contact the administrator.",
        "GiaReportNumberExample": "Example: 1234567890"
      },
      "LabReportNumber": "GIA Lab Report Number",
      "ReportNumberRequired": "Report Number is required",
      "ReportFound": "Good news! We found the report",
      "ReportPartialMatch": "We found a partial match",
      "ReportFoundMessage": "This report will be included in your appraisal documents.",
      "PartialReportMessage": "Please import partial report details.",
      "Import": "Import Grading Report",
      "ImportPartialReport": "Import Partial Report",
      "PdfLabReport": "PDF Lab Report",
      "PartialReportAlertMessage": "Some Grading Lab details were unavailable for import.<br/> Please select the best match from the options provided.",
      "NoReportsFound": "No reports found.",
      "MismatchDetected": "Mismatch Detected",
      "ReportRetrievalError": "There was a problem retrieving the report.",
      "SorryMessage": "We’re sorry, something is not working on our end.",
      "MaxAttemptsReached": "You have reached the maximum number of attempts. Please try again later.",
      "CheckReportNumber": "Please double-check the number you entered and try again. Or, you can enter the gem’s details manually.",
      "TypeMismatchDetails": "We located the report, but the gem doesn’t match. Please verify and try again."
    },
    "ReportCheckboxTooltip": "To remove the Lab Report and add a diamond manually, you must cancel and re-open the 'Add Diamond' window.",
    "GemList": {
      "LabReportNo": "Lab Report No.",
      "Actions": "Actions",
      "ViewDiamondDetails": "View Diamond Details"
    },
    "DiamondDetails": "Diamond Details",
    "AddItem": {
      "AppraisalImageDocumentSize": "Images or documents with a file size larger than 5MB will not upload. Check the size of your file, and reduce it before trying to upload it again."
    },
    "DeleteItemModalTitle": "Are you sure you want to delete this Item?",
    "DeleteItemConfirmText": "Yes, Delete This Item",
    "DeleteGemModalTitle": "Are you sure you want to delete this Gem?",
    "DeleteGemConfirmText": "Yes, Delete This Gem",
    "DeleteItemDeclineText": "No, Do Not Delete It"
  },
  "TaxWidgetContent": {
    "Title": {
      "BATaxCertificateMissing": "We are missing your current tax exemption document",
      "BATaxCertificateExpiring": "Update your tax exemption",
      "BATaxCertificateNeedsAttention": "Review and complete your tax exemption",
      "BATaxCertificateInProgress": "Complete and submit your tax exemption documentation",
      "TaxCertificateUploaded": "Your tax exemption was successfully submitted!",
      "TaxCertificateMissing": "Continue enjoying tax-free shopping",
      "TaxCertificateExpiring": "Want to shop tax free?",
      "TaxCertificateNeedsAttention": "Tax exemption needs attention",
      "TaxCertificateInProgress": "Tax exemption document in progress"
    },
    "Description": {
      "BATaxCertificateMissing": "Continue enjoying tax-free shopping! Complete your tax exemption ",
      "BATaxCertificateExpiring": "Your tax exemption has expired or is about to expire. Please update your tax exemption ",
      "BATaxCertificateNeedsAttention": "We were unable to approve your submitted tax exemption. Please complete and resubmit your form ",
      "BATaxCertificateInProgress": "Your form is in progress.  Please complete your exemption documentation and submit it ",
      "BATaxCertificateInProgressEnding": " to shop tax free",
      "TaxCertificateUploaded": "Your tax exemption was successfully submitted. Please allow 2-3 business days for our team to approve or deny your form",
      "TaxCertificateMissing": "Contact your business administrator to manage tax exemptions",
      "TaxCertificateExpiring": "Your tax exemption has expired or is about to expire. Please contact your business administrator to manage tax exemptions",
      "TaxCertificateNeedsAttention": "Your account needs attention. Please contact your business administrator to manage tax exemptions",
      "TaxCertificateInProgress": "Your tax exemption is in progress. Please contact your business administrator to manage tax exemptions"
    },
    "Clickable": {
      "Here": "here"
    }
  },
  "RefundSummaryContent": {
    "RefundSummary": "Refund Summary",
    "Captions": {
      "TaxRefund": "Tax Refund",
      "ShippingRefund": "Shipping Refund",
      "ShippingTaxRefund": "Shipping Tax Refund",
      "RestockingFee": "Restocking Fee",
      "USReturnFee": "US Return Fee",
      "InternationalReturnFee": "International Return Fee",
      "ReturnFee": "Return Fee"
    },
    "Tooltips": {
      "USReturnFee": "All lab grown diamonds returned to U.S. dealers will incur a $35.00 return fee deducted from their refund.",
      "InternationalReturnFee": "All lab grown diamonds returned to international dealers will incur a $70.00 return fee deducted from their refund.",
      "RestockingFee": "All lab grown diamonds over $10,000, an additional restocking fee of 1.25% of the diamond’s value will be deducted from their refund.",
      "ReturnFee": "All lab-grown diamonds may be returned within 20 days of receipt. A $35 return fee per return shipment will be deducted from your refund."
    }
  }
}
